import type { Dict } from '../types';

export const it: Dict = {
  'chat.amrCard.switchTitle': 'Chiamata al modello fallita — questa esecuzione è in pausa',
  'chat.amrCard.switchBody': 'Passa al servizio modelli AMR ufficiale di ZalureAI — nessuna chiave API da configurare. Dopo accesso, autorizzazione e ricarica, questa esecuzione verrà ritentata automaticamente.',
  'chat.amrCard.chipOfficial': 'Hosting ufficiale',
  'chat.amrCard.chipNoKey': 'Senza chiave API',
  'chat.amrCard.chipAutoRetry': 'Ritenta automatico dopo l\'accesso',
  'chat.amrCard.switchCta': 'Passa ad AMR e riprova',
  'chat.amrError.authMessage': 'Il tuo account AMR non è ancora autorizzato. Autorizzalo e questa esecuzione verrà ritentata automaticamente.',
  'chat.amrError.balanceMessage': 'Il tuo saldo AMR è esaurito. Ricarica per continuare questa esecuzione.',
  'chat.amrError.authorizeCta': 'Autorizza e riprova',
  'chat.amrError.rechargeCta': 'Ricarica AMR',
  'chat.antigravityError.launchTerminalCta': 'Accedi tramite terminale',
  'chat.antigravityError.launchSwitchModelCta': 'Cambia modello nel terminale',
  'chat.connectionDropped': 'La connessione al servizio del modello è caduta prima del completamento della risposta, di solito a causa di una rete o di un proxy instabili. Riprova.',
  'common.cancel': 'Annulla',
  'common.save': 'Salva',
  'common.close': 'Chiudi',
  'common.clear': 'Cancella',
  'common.delete': 'Elimina',
  'common.rename': 'Rinomina',
  'common.edit': 'Modifica',
  'common.preview': 'Anteprima',
  'common.share': 'Condividi',
  'common.search': 'Cerca',
  'common.searchEllipsis': 'Cerca…',
  'common.loading': 'Caricamento…',
  'common.all': 'Tutto',
  'common.none': 'Nessuno',
  'common.default': 'Predefinito',
  'common.installed': 'installato',
  'common.notInstalled': 'non installato',
  'common.active': 'attivo',
  'common.offline': 'offline',
  'common.selected': 'selezionato',
  'common.create': 'Crea',
  'common.openPreview': 'Apri anteprima',
  'common.exitFullscreen': 'Esci da schermo intero',
  'common.fullscreen': 'Schermo intero',
  'common.openInNewTab': 'Apri in una nuova scheda',
  'common.exportPdf': 'Esporta in PDF',
  'common.exportZip': 'Scarica come .zip',
  'common.exportHtml': 'Esporta in HTML autonomo',
  'common.exportImage': 'Esporta come immagine',
  'common.exportImageFailed': 'Acquisizione immagine fallita. Riprova o usa lo strumento di screenshot del browser.',
  'common.justNow': 'proprio ora',
  'common.minutesAgo': '{n} min fa',
  'common.hoursAgo': '{n} h fa',
  'common.daysAgo': '{n} g fa',
  'common.weeksAgo': '{n} sett. fa',
  'common.now': 'ora',
  'common.minutesShort': '{n} min',
  'common.hoursShort': '{n} h',
  'common.daysShort': '{n} g',
  'common.untitled': 'Senza titolo',
  'plugins.availableDetails.provenance': 'Provenienza',
  'plugins.availableDetails.provenanceLine': 'da {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'da {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Installa',
  'plugins.availableDetails.version': 'Versione',
  'plugins.availableDetails.pluginVersion': 'Versione plugin',
  'plugins.availableDetails.copyInstallCommand': 'Copia comando di installazione',
  'plugins.availableDetails.copied': 'Copiato',
  'plugins.availableDetails.deprecatedPrefix': 'Obsoleto: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Questa versione è stata contrassegnata come obsoleta.',
  'plugins.availableDetails.yanked': 'Ritirata.',
  'plugins.availableDetails.yankedWithReason': 'Ritirata: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (obsoleto)',
  'plugins.availableDetails.versionYankedSuffix': ' (ritirato)',
  'plugins.availableDetails.ref': 'Rif.',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Autorizzazioni',
  'plugins.availableDetails.capabilitySummary': 'Riepilogo delle capacità',
  'plugins.actions.copyInstallCommand': 'Copia comando di installazione',
  'plugins.actions.copyPluginId': 'Copia ID plugin',
  'plugins.actions.copyReadmeBadge': 'Copia badge README',
  'plugins.actions.openSourceGithub': 'Apri sorgente su GitHub',
  'plugins.actions.openSource': 'Apri sorgente',
  'plugins.actions.openHomepage': 'Apri homepage',
  'plugins.actions.openMarketplace': 'Apri nel marketplace',
  'app.brand': 'ZalureAI',
  'app.brandPill': 'Anteprima di ricerca',
  'app.brandSubtitle': 'di Nexu Labs',
  'app.welcomeLoading': 'Caricamento dello spazio di lavoro…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Benvenuto',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Inizia da un brief',
  'settings.onboardingCreateBody': 'Descrivi il sito, l\'app, la presentazione, l\'immagine o il video che desideri. ZalureAI creerà un progetto e manterrà il lavoro modificabile.',
  'settings.onboardingMemoryTitle': 'Salva il contesto di lavoro',
  'settings.onboardingMemoryBody': 'Aggiungi preferenze, informazioni sul progetto e regole ricorrenti affinché le chat future utilizzino il contesto corretto.',
  'settings.onboardingSystemsTitle': 'Porta il tuo design system',
  'settings.onboardingSystemsBody': 'Scegli o crea un sistema di brand affinché il lavoro generato segua colori, tipografia e linguaggio di prodotto reali.',
  'settings.onboardingExecutionTitle': 'Scegli come eseguire la generazione',
  'settings.onboardingExecutionBody': 'CLI ufficiale con configurazione in un clic e impostazioni predefinite pronte all\'uso. Usa una sola chiave per scegliere tra molti modelli con prezzi migliori.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Consigliato ufficialmente',
  'settings.onboardingAmrCloudBenefitReady': 'Senza deploy',
  'settings.onboardingAmrCloudBenefitModels': 'Supporta Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'Harness SOTA',
  'settings.onboardingAmrCloudUpcomingLabel': 'In arrivo',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Immagini e video',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills in massa',
  'settings.onboardingAmrCloudUpcomingRouting': 'Routing intelligente',
  'settings.onboardingAmrModelSourceLabel': 'AMR CLI',
  'settings.onboardingAmrCloudAuthorizeAction': 'Autorizza AMR',
  'settings.onboardingAmrCloudAuthorizedAction': 'Autorizzato',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Design system',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Resta aggiornato',
  'settings.onboardingNewsletterTitle': 'Resta aggiornato',
  'settings.onboardingNewsletterBody': 'Ricevi novità di prodotto, nuovi template, design system e attività degli ambassador nella tua casella. Opzionale — puoi saltare.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'Ufficiale',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'About you',
  'settings.onboardingProfileBody': 'Optional details for better defaults.',
  'settings.onboardingRoleLabel': 'Your role',
  'settings.onboardingOrgSizeLabel': 'Organization size',
  'settings.onboardingUseCaseLabel': 'Use case',
  'settings.onboardingSourceLabel': 'Where did you hear about us?',
  'settings.onboardingSelectPlaceholder': 'Select one',
  'settings.onboardingSelectMultiplePlaceholder': 'Select one or more',
  'settings.onboardingOrgSolo': 'Solo / personal (1)',
  'settings.onboardingOrgTeam': 'Small team (2-10)',
  'settings.onboardingOrgStartup': 'Startup / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Growth company (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Engineer',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleGrowth': '📈 Growth',
  'settings.onboardingRoleOps': '⚙️ Operations',
  'settings.onboardingRoleFounder': '🚀 Founder / executive',
  'settings.onboardingRoleStudent': '🎓 Student / educator',
  'settings.onboardingRoleOther': '✨ Other',
  'settings.onboardingUseProduct': '🎨 Product design',
  'settings.onboardingUseDesignSystem': '🧩 Design system',
  'settings.onboardingUsePrototype': '📱 Prototype / app UI',
  'settings.onboardingUseLanding': '🌐 Landing pages',
  'settings.onboardingUseAds': '📣 Ads / social content',
  'settings.onboardingUseDashboard': '📊 Dashboards / internal tools',
  'settings.onboardingUseDeck': '🖥️ Presentation / deck',
  'settings.onboardingUseMarketing': '📈 Marketing / growth',
  'settings.onboardingUseEngineering': '🤝 Engineering handoff',
  'settings.onboardingUseAgency': '💼 Agency / client work',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceFriend': '👥 Friend or coworker',
  'settings.onboardingSourceSocial': '📱 Social media',
  'settings.onboardingSourceProductHunt': '🅿️ Product Hunt',
  'settings.onboardingSourceCommunity': '💬 Design / AI community',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceBlog': '📰 Blog or newsletter',
  'settings.onboardingSourceAiTool': '✨ AI tool recommendation',
  'settings.onboardingSourceSearch': '🔍 Search',
  'settings.onboardingSourceEvent': '🎤 Event or community',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.onboardingSkip': 'Skip for now',
  'settings.kicker': 'Impostazioni',
  'settings.title': 'Esecuzione e modello',
  'settings.subtitle': 'Scegli tra CLI locale e BYOK.',
  'settings.modeAria': 'Modalità di esecuzione',
  'settings.protocolAria': 'Protocollo API',
  'settings.modeDaemon': 'CLI locale',
  'settings.modeDaemonHelp': 'Esegui tramite un agente CLI sulla tua macchina',
  'settings.modeDaemonOffline': 'Il daemon non è in esecuzione',
  'settings.modeDaemonOfflineMeta': 'daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} installato/i',
  'settings.modeApi': 'Provider API',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK non può leggere, scrivere o modificare i file del progetto. Usa la Local CLI quando hai bisogno di modifiche al codice.',
  'settings.codeAgent': 'Agente di codice',
  'settings.codeAgentHint': 'Rilevato analizzando il tuo PATH. Scegli la CLI attraverso cui verranno eseguite le generazioni.',
  'settings.rescan': '↻ Rianalizza',
  'settings.rescanTitle': 'Rianalizza il PATH',
  'settings.rescanRunning': 'Analisi in corso...',
  'settings.rescanSuccess': 'Analisi completata. {count} disponibile/i.',
  'settings.designSystemRenameFailed': 'Rinomina non riuscita. Controlla il daemon e riprova.',
  'settings.rescanFailed': 'Analisi fallita. Controlla il daemon e riprova.',
  'settings.test': 'Testa',
  'settings.testTitle': 'Invia un piccolo messaggio di test per verificare la connessione',
  'settings.testRunning': 'Test della connessione…',
  'settings.byokReadyToTest': 'Pronto per il test',
  'settings.testCancel': 'Annulla',
  'settings.testRetry': 'Riprova il test',
  'settings.required': 'obbligatorio',
  'settings.testMissingFields': 'Compila {fields} per testare la connessione.',
  'settings.testSuccessApi': 'Connesso. Risposto in {ms} ms — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} ha risposto in {ms} ms — \'{sample}\'',
  'settings.testAuthFailed': 'Autenticazione fallita. Controlla la tua chiave API.',
  'settings.testForbidden': 'Accesso negato. Controlla account, regione o organizzazione.',
  'settings.testNotFoundModel': 'Modello \'{model}\' non trovato su questo endpoint.',
  'settings.testInvalidModelId': 'L\'id del modello \'{model}\' non è valido. Gli id personalizzati devono iniziare con una lettera o un numero e non contenere spazi.',
  'settings.testInvalidBaseUrl': 'L\'URL di base non è valido o non è accessibile.',
  'settings.testRateLimited': 'Il provider ha limitato il test. La configurazione sembra valida.',
  'settings.testUpstream': 'Il provider ha restituito {status}. Riprova tra un momento.',
  'settings.testTimeout': 'Il test è scaduto dopo {ms} ms.',
  'settings.testAgentMissing': '{agentName} non è installato o non è nel PATH.',
  'settings.testAgentSpawn': 'Impossibile avviare {agentName}: {detail}.',
  'settings.testUnknown': 'Test fallito: {detail}',
  'settings.agentInstall.install': 'Installa',
  'settings.agentInstall.docs': 'Documentazione',
  'settings.agentInstall.pathHint': 'Se hai installato una CLI con npm o Homebrew e appare ancora come non installata, verifica che la cartella bin dello strumento sia nel PATH ereditato dal daemon ZalureAI (Terminale e app GUI possono differire su macOS). Vedi QUICKSTART.md (sezione "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Apri Installa o Documentazione per l\'agente desiderato.',
  'settings.agentInstall.stepAuth': 'Autenticati con la CLI del provider (login o aggiunta delle credenziali API) prima di tornare in ZalureAI.',
  'settings.agentInstall.stepRescan': 'Clicca su Rianalizza in questa sezione.',
  'settings.agentInstall.stepSelect': 'Seleziona la scheda dell\'agente una volta che appare come installato.',
  'settings.noAgentsDetected': 'Nessun agente rilevato per ora. Installa Claude Code, Codex, Devin for Terminal, Gemini CLI, OpenCode, Cursor Agent, Qwen o GitHub Copilot CLI, poi clicca su Rianalizza.',
  'settings.agentInstalledGroup': 'Le tue CLI ({count})',
  'settings.agentInstallGroup': 'Disponibili per l\'installazione ({count})',
  'settings.agentAuthRequired': 'Autenticazione richiesta',
  'settings.agentAuthUnknown': 'Stato di autenticazione sconosciuto',
  'settings.amrCloud': 'ZalureAI AMR',
  'settings.amrAuthorize': 'Autorizza',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Molti modelli',
  'settings.amrPromoBonus': 'Bonus limitato: +100%',
  'settings.amrSignInToContinue': 'Accedi per continuare',
  'settings.amrSignIn': 'Accedi',
  'settings.amrSignedIn': 'Accesso effettuato',
  'settings.amrNotSignedIn': 'Accesso non effettuato',
  'settings.amrSigningIn': 'Accesso in corso…',
  'settings.amrCancelSignIn': 'Annulla accesso',
  'settings.amrAccountStatus': 'Stato account AMR',
  'settings.amrConsole': 'Console AMR',
  'settings.amrLoginErrorCompact': 'Accesso AMR non riuscito.',
  'settings.advanced': 'Avanzate',
  'settings.amrLogin': 'Accedi',
  'settings.amrLogout': 'Esci',
  'settings.amrLoggingIn': 'Accesso in corso…',
  'settings.amrLoggingOut': 'Disconnessione in corso…',
  'settings.amrLoggedInAs': 'Accesso effettuato come {email}',
  'settings.amrLoggedInWithPlan': 'Connesso come {email} · {plan}',
  'settings.amrLoggedInPill': 'Accesso effettuato',
  'settings.amrNotLoggedIn': 'Accesso non effettuato',
  'settings.apiSection': 'API Anthropic',
  'settings.quickFillProvider': 'Compilazione rapida del provider',
  'settings.providerPreset': 'Preset gateway',
  'settings.protocolGroupProtocols': 'Protocolli',
  'settings.protocolGroupGateways': 'Gateway',
  'settings.customProvider': 'Provider personalizzato',
  'settings.apiKey': 'Chiave API',
  'settings.apiKeyGetLink': 'Ottieni chiave ↗',
  'settings.showKey': 'Mostra chiave',
  'settings.hideKey': 'Nascondi chiave',
  'settings.show': 'Mostra',
  'settings.hide': 'Nascondi',
  'settings.model': 'Modello',
  'settings.apiKeyInvalid': 'API key non valida.',
  'settings.apiKeyCleaned': 'Spazi vuoti aggiuntivi rimossi dalla API key.',
  'settings.modelsLoadedFromAccount': '✓ Caricati {count} modelli dal tuo account.',
  'settings.modelsLoadedCount': '✓ Caricati {count} modelli.',
  'settings.modelSourceAccount': 'Dal tuo account',
  'settings.modelSourceSuggested': 'Suggerito',
  'settings.fetchModels': 'Recupera modelli',
  'settings.fetchModelsTitle': 'Recupera i modelli disponibili da questo provider',
  'settings.fetchModelsRunning': 'Recupero dei modelli…',
  'settings.fetchModelsMissingFields': 'Compila {fields} per recuperare i modelli.',
  'settings.fetchModelsInvalidBaseUrl': 'Inserisci un Base URL valido per recuperare i modelli.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI usa i nomi di deployment, quindi l\'individuazione dei modelli non è disponibile qui.',
  'settings.fetchModelsUnsupportedOllama': 'L\'individuazione dei modelli di Ollama Cloud non è ancora disponibile. Scegli o digita un modello.',
  'settings.fetchModelsSuccess': 'Recuperati {count} modelli.',
  'settings.fetchModelsEmpty': 'Nessun modello di testo compatibile restituito.',
  'settings.fetchModelsUnsupported': 'L\'individuazione dei modelli non è disponibile per questo protocollo.',
  'settings.fetchModelsFailed': 'Impossibile recuperare i modelli: {detail}',
  'settings.suggestedModelsHint': 'Questi sono modelli suggeriti per questo protocollo. Il tuo provider potrebbe supportare altri modelli.',
  'settings.baseUrl': 'URL di base',
  'settings.baseUrlInvalid': 'Usa un URL pubblico http:// o https://.',
  'settings.baseUrlCustomize': 'Personalizza',
  'settings.baseUrlDefaultHint': 'Endpoint predefinito. Di solito non serve modificarlo.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Lo trovi nel portale Azure → la tua risorsa → Endpoint.',
  'settings.azureDeploymentModel': 'Nome del deployment',
  'settings.azureCustomDeploymentName': 'Nome di deployment personalizzato',
  'settings.azureDeploymentModelHint': 'Per Azure OpenAI, questo campo viene utilizzato come nome del deployment in /openai/deployments/<model>. Inserisci il nome del deployment creato in Azure.',
  'settings.azureModelFetchHint': 'Inserisci il nome del deployment dalla tua risorsa Azure. I deployment Azure non possono essere recuperati automaticamente.',
  'settings.apiVersion': 'Versione API',
  'settings.byokImageModel': 'Modello di generazione immagini',
  'settings.byokVideoModel': 'Modello di generazione video',
  'settings.byokVideoI2vHint': 'Modello immagine-in-video: è richiesta un’immagine di riferimento (altrimenti viene usata l’ultima immagine del progetto)',
  'settings.byokSpeechModel': 'Modello vocale',
  'settings.byokSpeechVoice': 'Voce',
  'settings.byokModelDefaultOption': 'Predefinito',
  'settings.maxTokens': 'Token massimi (opzionale)',
  'settings.maxTokensHint': 'Limite della lunghezza della risposta. Ogni modello ha un valore predefinito (mostrato nel placeholder); lascia vuoto per usarlo, o inserisci un numero per sostituirlo.',
  'settings.apiHint': 'Le chiamate passano attraverso il proxy del daemon locale verso l\'URL di base definito. La chiave è memorizzata solo in questo browser e inviata con le richieste al provider.',
  'settings.skipForNow': 'Salta per ora',
  'settings.getStarted': 'Inizia',
  'settings.envConfigure': 'Modalità di esecuzione',
  'settings.localCli': 'CLI locale',
  'settings.anthropicApi': 'API Anthropic',
  'settings.noAgentSelected': 'nessun agente selezionato',
  'settings.language': 'Lingua',
  'settings.languageHint': 'Cambia la lingua dell\'interfaccia. Salvato in questo browser.',
  'settings.appearance': 'Aspetto',
  'settings.appearanceHint': 'Scegli chiaro, scuro o segui l\'impostazione di sistema.',
  'settings.themeSystem': 'Sistema',
  'settings.themeLight': 'Chiaro',
  'settings.themeDark': 'Scuro',
  'settings.agentModelHead': 'Modello per:',
  'settings.modelPicker': 'Modello',
  'settings.modelSourceLive': 'Live dalla CLI',
  'settings.modelSourceFallback': 'Elenco integrato',
  'settings.reasoningPicker': 'Sforzo di ragionamento',
  'settings.modelPickerHint': 'Recuperato dalla CLI quando espone un comando `models`. "Predefinito" lascia la scelta alla configurazione della CLI; "Personalizzato…" ti permette di inserire qualsiasi identificatore di modello accettato dalla CLI.',
  'settings.modelPickerLiveHint': 'I modelli sono stati aggiornati dalla CLI installata. Predefinito usa ancora la configurazione della CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'I modelli sono stati aggiornati dalla CLI installata.',
  'settings.modelPickerFallbackHint': 'Mostra i valori predefiniti integrati. Clicca su Rianalizza per recuperare i modelli live dalla CLI.',
  'settings.cliEnvTitle': 'Posizioni di configurazione CLI',
  'settings.cliEnvHint': 'Imposta directory di configurazione non segrete per esecuzioni di app impacchettate e rilevamento agenti.',
  'settings.cliEnvClaudeConfigDir': 'Directory di configurazione Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL del proxy Claude',
  'settings.cliEnvClaudeApiKey': 'API key del proxy Claude',
  'settings.cliEnvCodexHome': 'Home di Codex',
  'settings.cliEnvCodexBin': 'Percorso eseguibile Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL del proxy Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key del proxy Codex/OpenAI',
  'settings.modelCustom': 'Personalizzato (inserisci sotto)…',
  'settings.modelCustomLabel': 'Identificatore del modello personalizzato',
  'settings.modelCustomPlaceholder': 'es. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Provider di media',
  'settings.mediaProvidersHint': 'Chiavi API per la generazione di immagini, video e audio. Memorizzate localmente e sincronizzate con il daemon locale.',
  'settings.mcpServerTitle': 'Server MCP',
  'settings.mcpServerHint': 'Esponi ZalureAI come server MCP per il tuo agente di codice.',
  'settings.externalMcpTitle': 'MCP esterno',
  'settings.externalMcpHint': 'Aggiungi strumenti MCP da servizi esterni (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'Chiave API',
  'settings.mediaProviderBaseUrl': 'URL di base',
  'settings.mediaProviderConfigured': 'Configurato',
  'settings.mediaProviderUnset': 'Non impostato',
  'settings.mediaProviderClear': 'Cancella',
  'settings.mediaProviderClearConfirm': 'Cancellare le impostazioni salvate per {name}? Dovrai inserirle di nuovo per usare {name}.',
  'settings.mediaProviderPlaceholder': 'Incolla la chiave API',
  'settings.mediaProviderBaseUrlPlaceholder': 'Sostituisci l\'URL di base predefinito',
  'settings.mediaProviderReload': 'Ricarica dal daemon',
  'settings.mediaProviderReloadError': 'Impossibile ricaricare le impostazioni dei provider di media dal daemon locale.',
  'settings.mediaProviderReloadSuccess': 'Impostazioni dei provider di media ricaricate dal daemon locale.',
  'settings.mediaProviderLoadError': 'Impossibile caricare le impostazioni dei provider di media dal daemon locale. Uso temporaneo delle impostazioni salvate nel browser.',
  'settings.mediaProviderComingSoonHint': 'Teniamo traccia di questi per la roadmap; il daemon non fornisce ancora un client, quindi non c\'è nulla da configurare.',
  'settings.privacy': 'Privacy',
  'settings.privacyHint': 'Quali dati vengono condivisi con il team di ZalureAI',
  'settings.privacyConsentKicker': 'Aiutaci a migliorare ZalureAI',
  'settings.privacyConsentLead': 'ZalureAI può condividere dati di utilizzo con il nostro team per aiutarci a migliorare. Questo include:',
  'settings.privacyConsentFooter': 'Puoi modificare queste opzioni in qualsiasi momento in Impostazioni → Privacy.',
  'settings.privacyConsentShare': 'Condividi i dati di utilizzo',
  'settings.privacyConsentDecline': 'Non condividere',
  'settings.privacyConsentAccept': 'Ho capito',
  'settings.privacyConsentBannerFooter': 'La condivisione dei dati è attiva per impostazione predefinita. Puoi disattivarla in qualsiasi momento in Impostazioni → Privacy.',
  'settings.privacyConsentPolicyLink': 'Leggi l\'informativa sulla privacy',
  'settings.privacyMetrics': 'Metriche anonime',
  'settings.privacyMetricsHint': 'Conteggi di esecuzione, utilizzo di token, tasso di errore, durata. Nessun prompt, nessun dato di progetto.',
  'settings.privacyContent': 'Contenuto della conversazione',
  'settings.privacyContentHint': 'Prompt, risposte dell’assistente, input/output degli strumenti e file di contesto completo necessari per la revisione della qualità. I segreti vengono rimossi prima dell’invio.',
  'settings.privacyInstallationId': 'ID anonimo',
  'settings.privacyOptedOut': 'escluso',
  'settings.privacyDataDeletion': 'Elimina i miei dati',
  'settings.privacyDataDeletionHint': 'Ruota il tuo ID anonimo e interrompe l\'invio. Le tracce esistenti scadono secondo la nostra politica di conservazione.',
  'settings.about': 'Informazioni',
  'settings.aboutHint': 'Versione e informazioni di esecuzione',
  'settings.appVersion': 'Versione',
  'settings.appChannel': 'Canale',
  'settings.appRuntime': 'Ambiente',
  'settings.appPlatform': 'Piattaforma',
  'settings.appArchitecture': 'Architettura',
  'settings.runtimePackaged': 'Applicazione impacchettata',
  'settings.runtimeDevelopment': 'Sviluppo',
  'settings.versionUnavailable': 'Le informazioni sulla versione non sono disponibili quando il daemon è offline.',
  'settings.installLatest': 'Installa l\'ultima versione',
  'settings.alreadyLatest': 'Stai usando l\'ultima versione',
  'settings.mcpTitle': 'Server MCP',
  'settings.mcpHint': 'Consenti agli agent di coding (Cursor, Claude Code, VS Code…) di leggere direttamente i tuoi progetti ZalureAI.',
  'settings.mcpDaemonError': 'Impossibile raggiungere il daemon locale per risolvere i percorsi di installazione ({error}). Assicurati che ZalureAI sia in esecuzione, quindi riapri questo pannello.',
  'settings.mcpBuildDaemon': 'Compila prima il daemon.',
  'settings.mcpNodeMissing': 'Il binario Node è mancante.',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js è mancante. Esegui `pnpm --filter @open-design/daemon build` e aggiorna.',
  'settings.mcpMethodCli': 'Comando CLI',
  'settings.mcpInstructionCli': 'Esegui questo nel tuo terminale.',
  'settings.mcpMethodToml': 'Configurazione TOML',
  'settings.mcpInstructionCodex': 'Aggiungi questa tabella a {path}. La stessa configurazione è condivisa tra la CLI Codex e l\'estensione IDE Codex.',
  'settings.mcpMethodOneClick': 'Installazione con un clic',
  'settings.mcpInstructionCursor': 'Fai clic su "Install in Cursor" per installare con una finestra di approvazione, oppure unisci questo JSON in {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Installa in Cursor',
  'settings.mcpMethodJson': 'Configurazione JSON',
  'settings.mcpInstructionCopilot': 'Apri la Command Palette ({shortcut}), esegui "MCP: Open User Configuration" e unisci questo JSON. Copilot Chat deve essere in modalità Agent affinché gli strumenti vengano visualizzati.',
  'settings.mcpInstructionAntigravity': 'In Antigravity: pannello Agent, menu "..." → MCP Servers → Manage MCP Servers → View raw config. Unisci questo JSON.',
  'settings.mcpInstructionZed': 'Apri le impostazioni di Zed ({shortcut}) e unisci questo nell\'oggetto di livello superiore. Zed usa "context_servers", non "mcpServers".',
  'settings.mcpInstructionWindsurf': 'Apri {path} (oppure usa l\'icona MCP in Cascade → Configure) e unisci:',
  'settings.mcpCopyAria': 'Copia lo snippet di configurazione MCP',
  'settings.mcpResolvingFailed': '# risoluzione dei percorsi non riuscita, vedi l\'errore sopra',
  'settings.mcpLoadingPaths': '# caricamento dei percorsi di installazione dal daemon locale…',
  'settings.mcpCopied': 'Copiato',
  'settings.mcpCopy': 'Copia',
  'settings.mcpCursorApproval': 'Cursor mostra una finestra di approvazione prima di scrivere la configurazione.',
  'settings.mcpCodexOneClickInstall': 'Installa in Codex',
  'settings.mcpCodexOneClickUninstall': 'Rimuovi da Codex',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI non trovato nel PATH — installa Codex o incolla lo snippet manualmente.',
  'settings.mcpCodexInstallSuccess': 'Installato. Riavvia Codex per caricare il nuovo server.',
  'settings.mcpCodexUninstallSuccess': 'Rimosso da Codex.',
  'settings.mcpCodexBusy': 'In corso…',
  'settings.mcpCodexInstallError': 'Operazione non riuscita: {error}',
  'settings.mcpRestartNote': 'Riavvia il tuo client per rilevare il nuovo server.',
  'settings.mcpRestartDetail': 'La maggior parte degli editor carica i server MCP solo all\'avvio. In Cursor / VS Code / Antigravity / Windsurf puoi eseguire `Developer: Reload Window` dalla command palette invece di un riavvio completo. Zed e Claude Code richiedono di chiudere e riaprire.',
  'settings.mcpCapabilitiesTitle': 'Cosa può fare il tuo agent',
  'settings.mcpCapabilityRead': 'Leggere o cercare qualsiasi file in un progetto (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Recuperare un bundle di design in una sola chiamata: il file di ingresso più ogni variabile CSS, componente e font a cui fa riferimento.',
  'settings.mcpCapabilityDefault': 'Utilizzare per impostazione predefinita il progetto e il file che hai aperto in ZalureAI, così puoi dire "build this in my app" senza dover ripetere quale design.',
  'settings.mcpRunningNote': 'ZalureAI deve essere in esecuzione affinché le chiamate agli strumenti MCP abbiano successo. Se hai avviato il tuo coding agent prima di aprire ZalureAI, riavvia l\'agent in modo che possa raggiungere il daemon attivo.',
  'entry.tabDesigns': 'Design',
  'entry.tabTemplates': 'Modelli',
  'entry.tabDesignSystems': 'Design system',
  'entry.tabConnectors': 'Connettori',
  'entry.openSettingsTitle': 'Impostazioni',
  'entry.openSettingsAria': 'Apri impostazioni',
  'entry.discordLabel': 'Unisciti a Discord',
  'entry.discordAria': 'Unisciti al Discord di ZalureAI',
  'entry.discordAriaWithOnline': 'Unisciti al Discord di ZalureAI - {online}',
  'entry.discordOnlineLabel': '{count} online',
  'entry.followXLabel': 'Segui @nexudotio su X',
  'entry.resizeAria': 'Ridimensiona la barra laterale',
  'entry.loadingWorkspace': 'Caricamento dello spazio di lavoro…',
  'entry.useEverywhereTitle': 'Usa ovunque',
  'entry.useEverywhereAria': 'Apri la guida Usa ovunque (CLI, MCP, HTTP, Skills)',
  'entry.navExpand': 'Espandi la barra laterale',
  'entry.navCollapse': 'Comprimi la barra laterale',
  'entry.navNewProject': 'Nuovo progetto',
  'entry.navHome': 'Home',
  'entry.navProjects': 'Progetti',
  'entry.navTasks': 'Automazioni',
  'entry.navPlugins': 'Plugin',
  'entry.navDesignSystems': 'Design system',
  'entry.navIntegrations': 'Integrazioni',
  'workspaceTabs.project': 'Progetto',
  'workspaceTabs.pluginDetails': 'Dettagli del plugin',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'Cosa vuoi progettare?',
  'homeHero.templatesScrollHint': 'Scorri verso l\'alto per esplorare altri template',
  'homeHero.templatesCollapse': 'Comprimi modelli',
  'homeHero.subtitlePrefix': 'L\'alternativa open source a Claude Design.',
  'homeHero.placeholder': 'Descrivi cosa vuoi generare…',
  'homeHero.placeholderActive': 'Modifica la query di esempio o scrivine una tua…',
  'homeHero.skills': 'Competenze',
  'homeHero.addMenu': 'Aggiungi contesto',
  'homeHero.addPlugin': 'Aggiungi plugin',
  'homeHero.addConnectors': 'Aggiungi connettori',
  'homeHero.addMcp': 'Aggiungi server MCP',
  'homeHero.noPlugins': 'Nessun plugin installato',
  'homeHero.noMcp': 'Nessun server MCP',
  'homeHero.noConnectors': 'Nessun connettore collegato',
  'homeHero.applying': 'Applicazione in corso…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Competenza: {title}',
  'homeHero.removePlugin': 'Rimuovi plugin',
  'homeHero.removePluginAria': 'Rimuovi plugin {title}',
  'homeHero.clearActivePlugin': 'Disattiva plugin attivo',
  'homeHero.clearActiveSkill': 'Disattiva competenza attiva',
  'homeHero.contextItemsResolved': '{n} elementi di contesto risolti',
  'homeHero.removeFile': 'Rimuovi file',
  'homeHero.contextSearchResults': 'Risultati ricerca contesto',
  'homeHero.contextSurfaces': 'Aree di contesto',
  'homeHero.loadingContext': 'Caricamento del contesto…',
  'homeHero.noResults': 'Nessun risultato per "{query}".',
  'homeHero.searchPrompt': 'Cerca file, plugin, competenze, server MCP e connettori.',
  'homeHero.parameters': '{n} parametri',
  'homeHero.details': 'Dettagli',
  'homeHero.toRun': 'per eseguire',
  'homeHero.forNewLine': 'per andare a capo',
  'homeHero.run': 'Esegui',
  'homeHero.typeSomethingToRun': 'Scrivi qualcosa da eseguire',
  'homeHero.promptExamples': 'Esempi',
  'homeHero.footer.designSystem': 'Stile',
  'homeHero.footer.autoDesignSystem': 'Auto',
  'homeHero.footer.autoDesignSystemSummary': 'Abbina automaticamente il design system e lo stile visivo più adatti al prompt attuale.',
  'homeHero.footer.ratio': 'Rapporto',
  'homeHero.footer.duration': 'Durata',
  'homeHero.footer.resolution': 'Risoluzione',
  'homeHero.footer.speakerNotes': 'Note',
  'homeHero.footer.noSpeakerNotes': 'Senza note',
  'homeHero.footer.availableCount': '{n} disponibili',
  'homeHero.footer.noMatches': 'Nessuna corrispondenza',
  'homeHero.moreShortcuts': 'Altro',
  'homeHero.railAria': 'Scegli una categoria di progetto o una scorciatoia iniziale',
  'homeHero.subTypeAria': 'Scegli un sottotipo',
  'homeHero.confirmReplaceTitle': 'Sostituire il prompt attuale?',
  'homeHero.confirmReplaceBody': 'L\'uso di {title} sostituirà il testo attualmente presente nell\'input.',
  'homeHero.confirmReplace': 'Sostituisci',
  'homeHero.chip.prototype': 'Prototipo',
  'homeHero.chip.liveArtifact': 'Artefatto live',
  'homeHero.chip.deck': 'Presentazione',
  'homeHero.chip.image': 'Immagine',
  'homeHero.chip.video': 'Video',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.audio': 'Audio',
  'homeHero.chip.createPlugin': 'Crea plugin',
  'homeHero.chip.figma': 'Da Figma',
  'homeHero.chip.folder': 'Da cartella',
  'homeHero.chip.template': 'Da modello',
  'homeHero.chip.liveArtifactHint': 'Crea un artefatto HTML/CSS/JS interattivo con anteprima live.',
  'homeHero.chip.hyperframesHint': 'Crea animazioni basate su HTML: didascalie, elementi visivi reattivi all\'audio, transizioni tra scene.',
  'homeHero.chip.createPluginHint': 'Crea un plugin ZalureAI riutilizzabile e aggiungilo a I miei plugin.',
  'homeHero.chip.figmaHint': 'Migra un frame di Figma nel design system attivo.',
  'homeHero.chip.folderHint': 'Importa una cartella locale esistente e continua a modificarla.',
  'homeHero.chip.templateHint': 'Inizia da un modello incluso.',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'Cartella',
  'workingDirPicker.homeTitle': 'Salvato nella memoria locale — clicca per scegliere una cartella',
  'workingDirPicker.processing': 'Elaborazione in corso…',
  'workingDirPicker.select': 'Memoria locale',
  'workingDirPicker.clearAria': 'Cancella directory di lavoro',
  'workingDirPicker.replaceFailed': 'Impossibile sostituire la directory di lavoro',
  'workingDirPicker.unavailable': 'Il selettore di cartelle non è disponibile in questa build. Esegui l\'app desktop per scegliere una cartella.',
  'workingDirPicker.openUnavailable': 'Apri questo progetto nell\'app desktop per mostrare la cartella.',
  'workingDirPicker.openFailed': 'Impossibile mostrare questa cartella',
  'workingDirPicker.showInFileManager': 'Mostra nel file manager',
  'workingDirPicker.replace': 'Scegli cartella…',
  'workingDirPicker.recent': 'Directory recenti',
  'workingDirPicker.defaultLabel': 'Archiviazione locale',
  'handoff.toTarget': 'Passa a {target}',
  'handoff.openInTarget': 'Apri in {target}',
  'handoff.openAction': 'Apri',
  'handoff.menuTitle': 'In quale editor aprire?',
  'handoff.action': 'Passa il controllo',
  'handoff.fallbackTitle': 'Nessun editor trovato in $PATH - apre in {target}',
  'handoff.chooseTargetAria': 'Scegli la destinazione del passaggio',
  'handoff.optionsAria': 'Opzioni di passaggio',
  'handoff.editorSection': 'Apri con editor',
  'handoff.cliSection': 'Copia per CLI',
  'handoff.clickOpen': 'Clicca per aprire',
  'handoff.framework': 'Framework di codice',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'vanilla JavaScript, HTML e CSS',
  'handoff.amrWebsite': 'Apri il sito AMR',
  'handoff.copyPrompt': 'Copia prompt',
  'handoff.copyPromptForTarget': 'Copia prompt per {target}',
  'handoff.copied': 'Copiato',
  'handoff.projectPathUnavailable': 'Il percorso del progetto è ancora in caricamento. Riprova tra un momento.',
  'handoff.copyFailed': 'La scrittura negli appunti è stata bloccata. Riprova tra un momento.',
  'handoff.promptIntro': 'Continua da questa cartella di progetto locale di ZalureAI:',
  'handoff.promptTarget': 'Destinazione',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Stai subentrando in {cli}. Per favore:',
  'handoff.promptReadFiles': 'Entra o leggi prima questa directory. Dai priorità a DESIGN.md, README, HTML/CSS/JS esistenti, asset e package.json se presente.',
  'handoff.promptKeepDesign': 'Conserva il design visivo, il layout, le interazioni e gli asset attuali. Non fermarti a un piano.',
  'handoff.promptProduceCode': 'Genera o modifica codice {framework} reale ed eseguibile. Se il progetto ha già uno stack più chiaro, segnala il conflitto e mantieni il risultato eseguibile.',
  'handoff.promptVerify': 'Concludi indicandomi i comandi di esecuzione, anteprima e verifica.',
  'handoff.promptCommandHint': 'Per iniziare dalla directory del progetto, usa:',
  'handoff.promptProject': 'Progetto',
  'handoff.promptProjectId': 'ID progetto',
  'handoff.notInstalled': 'Non installato',
  'handoff.notDetectedTitle': '{target} - non rilevato in $PATH',
  'designSystemPicker.select': 'Scegli design system',
  'designSystemPicker.loading': 'Caricamento dei design system…',
  'designSystemPicker.searchPlaceholder': 'Cerca design system (titolo / categoria / riepilogo)',
  'designSystemPicker.searchCompactPlaceholder': 'Cerca design system',
  'designSystemPicker.noneTitle': 'Nessun design system',
  'designSystemPicker.noneSummary': 'Lascia scegliere liberamente al modello',
  'designSystemPicker.empty': 'Nessun design system corrispondente',
  'designSystemPicker.openPreview': 'Apri anteprima',
  'designSystemPicker.loadingPreview': 'Caricamento dell\'anteprima…',
  'designSystemPicker.noPreview': 'Nessuna pagina di anteprima. Apri i Design System per vedere l\'anteprima completa.',
  'designSystemPicker.previewHint': 'Passa il mouse su un design system per visualizzarne l\'anteprima',
  'designSystemPicker.fullscreenAria': 'Anteprima a schermo intero di {title}',
  'designSystemPicker.closeFullscreen': 'Chiudi anteprima a schermo intero',
  'designSystemPicker.closeEsc': 'Chiudi (Esc)',
  'designSystemPicker.previewFrameTitle': 'Anteprima di {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Anteprima a schermo intero di {title}',
  'recentProjects.title': 'Progetti recenti',
  'recentProjects.viewAll': 'Mostra tutti',
  'recentProjects.empty': 'Ancora nessun progetto — scrivi un prompt per iniziarne uno.',
  'pluginsHome.title': 'Community',
  'pluginsHome.subtitle': 'Workflow di ZalureAI pronti all\'uso inclusi in questo runtime. Scegline uno per caricare un prompt iniziale oppure esplora il registry per altro.',
  'pluginsHome.browseRegistry': 'Esplora registry',
  'pluginsHome.count': '{filtered} di {total}',
  'pluginsHome.loadingCatalog': 'Caricamento del catalogo…',
  'pluginsHome.emptyCatalog': 'Il catalogo è vuoto. I plugin inclusi sono forniti con ZalureAI e dovrebbero comparire qui automaticamente — prova a riavviare il daemon se il problema persiste.',
  'pluginsHome.emptyFiltered': 'Nessun plugin corrisponde ai filtri attuali.',
  'pluginsHome.clearFilters': 'Cancella filtri',
  'pluginsHome.modeAria': 'Modalità plugin',
  'pluginsHome.featured': 'Salvato',
  'pluginsHome.totalInCatalog': '{n} nel catalogo',
  'pluginsHome.categoryFilterAria': 'Filtro categoria',
  'pluginsHome.subcategoryFilterAria': 'Filtro sottocategoria {label}',
  'pluginsHome.allCategory': 'Tutti {label}',
  'pluginsHome.searchPlaceholder': 'Cerca plugin…',
  'pluginsHome.searchAria': 'Cerca plugin',
  'pluginsHome.clearSearch': 'Cancella ricerca',
  'pluginsHome.facet.import': 'Importa',
  'pluginsHome.facet.create': 'Crea',
  'pluginsHome.facet.export': 'Esporta',
  'pluginsHome.facet.share': 'Condividi',
  'pluginsHome.facet.deploy': 'Distribuisci',
  'pluginsHome.facet.refine': 'Perfeziona',
  'pluginsHome.facet.extend': 'Estendi',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Codice / cartella',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Screenshot',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Slide',
  'pluginsHome.facet.publicLink': 'Link pubblico',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Dashboard',
  'pluginsHome.subfacet.app-prototypes': 'App',
  'pluginsHome.subfacet.landing-marketing': 'Landing / marketing',
  'pluginsHome.subfacet.developer-tools': 'Strumenti dev',
  'pluginsHome.subfacet.docs-reports': 'Doc / report',
  'pluginsHome.subfacet.brand-design': 'Brand / design',
  'pluginsHome.subfacet.pitch-business': 'Pitch / business',
  'pluginsHome.subfacet.course-training': 'Corsi / formazione',
  'pluginsHome.subfacet.reports-briefings': 'Report / briefing',
  'pluginsHome.subfacet.product-sales': 'Prodotto / vendite',
  'pluginsHome.subfacet.engineering-talks': 'Talk tecnici',
  'pluginsHome.subfacet.creative-decks': 'Deck creativi',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / mockup',
  'pluginsHome.subfacet.brand-visuals': 'Brand / logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboard',
  'pluginsHome.subfacet.social-content': 'Social / contenuti',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / ritratto',
  'pluginsHome.subfacet.illustration-style': 'Illustrazione / stile',
  'pluginsHome.subfacet.motion-effects': 'Motion / effetti',
  'pluginsHome.subfacet.social-short-form': 'Social / short form',
  'pluginsHome.subfacet.marketing-product': 'Marketing / prodotto',
  'pluginsHome.subfacet.data-explainers': 'Dati / spiegazioni',
  'pluginsHome.subfacet.cinematic-story': 'Cinematico / storia',
  'pluginsView.lede': 'Esplora i workflow installati, scopri le voci del registry, gestisci le sorgenti e prepara i plugin per la distribuzione al team.',
  'pluginsView.importPlugin': 'Importa plugin',
  'pluginsView.agentContext': 'Contesto Agent',
  'pluginsView.summaryAria': 'Riepilogo plugin',
  'pluginsView.areasAria': 'Aree dei plugin',
  'pluginsView.loading': 'Caricamento dei plugin…',
  'pluginsView.tab.installed': 'Installati',
  'pluginsView.tab.available': 'Disponibili',
  'pluginsView.tab.sources': 'Sorgenti',
  'pluginsView.tab.team': 'Team',
  'pluginsView.tabHint.installed': 'I tuoi plugin',
  'pluginsView.tabHint.available': 'Dalle sorgenti',
  'pluginsView.tabHint.sources': 'Cataloghi',
  'pluginsView.tabHint.team': 'Enterprise',
  'pluginsView.installedTitle': 'Plugin installati',
  'pluginsView.installedSubtitle': 'Plugin importati o installati da sorgenti del marketplace.',
  'pluginsView.installedEmpty': 'Ancora nessun plugin utente installato. Usa Crea / Importa oppure installa una voce Disponibile.',
  'pluginsView.availableTitle': 'Disponibili dalle sorgenti',
  'pluginsView.availableSubtitle': 'Voci del catalogo rilevate dai marketplace configurati.',
  'pluginsView.availableFiltersAria': 'Filtri plugin disponibili',
  'pluginsView.searchAvailableAria': 'Cerca plugin disponibili',
  'pluginsView.searchAvailablePlaceholder': 'Cerca plugin disponibili',
  'pluginsView.clearAvailableSearch': 'Cancella ricerca plugin disponibili',
  'pluginsView.source': 'Sorgente',
  'pluginsView.availableEmptyInstalled': 'Ancora nessuna voce disponibile. Le voci del catalogo installate vengono rimosse da Disponibili; disinstallane una per renderla nuovamente disponibile.',
  'pluginsView.availableEmptyFiltered': 'Nessuna voce disponibile corrisponde ai filtri.',
  'pluginsView.availableEmptyNoSources': 'Nessuna voce disponibile al momento. Aggiungi una sorgente nella scheda Sorgenti.',
  'pluginsView.installing': 'Installazione in corso…',
  'pluginsView.install': 'Installa',
  'pluginsView.sourcesTitle': 'Sorgenti del registro',
  'pluginsView.sourcesSubtitle': 'Cataloghi del marketplace che alimentano le voci dei plugin disponibili.',
  'pluginsView.sourceUrl': 'URL sorgente',
  'pluginsView.defaultTrust': 'Attendibilità predefinita',
  'pluginsView.trust.restricted': 'Limitato',
  'pluginsView.trust.trusted': 'Attendibile',
  'pluginsView.trust.official': 'Ufficiale',
  'pluginsView.adding': 'Aggiunta in corso…',
  'pluginsView.addSource': 'Aggiungi sorgente',
  'pluginsView.sourcesEmpty': 'Nessuna sorgente del registro ancora configurata.',
  'pluginsView.pluginsCount': '{n} plugin',
  'pluginsView.catalogVersion': 'catalogo v{version}',
  'pluginsView.trustFor': 'Attendibilità per {name}',
  'pluginsView.refreshing': 'Aggiornamento in corso…',
  'pluginsView.removing': 'Rimozione in corso…',
  'pluginsView.teamTitle': 'Marketplace privati del team',
  'pluginsView.teamBody': 'Quest\'area è riservata ai cataloghi aziendali e dei team, alle politiche di attendibilità private e ai controlli condivisi del ciclo di vita dei plugin.',
  'pluginCard.details': 'Dettagli',
  'pluginCard.use': 'Usa',
  'pluginCard.useWithQuery': 'Usa con query',
  'pluginCard.applying': 'Applicazione in corso…',
  'pluginCard.publish': 'Pubblica',
  'pluginCard.contribute': 'Contribuisci',
  'pluginCard.starting': 'Avvio in corso…',
  'pluginCard.detailsAria': 'Visualizza i dettagli di {title}',
  'pluginCard.chooseUseAria': 'Scegli come usare {title}',
  'pluginCard.useOptionsAria': 'Opzioni d\'uso per {title}',
  'pluginCard.shareAria': 'Condividi {title}',
  'pluginCard.publishAria': 'Pubblica {title} come repository GitHub',
  'pluginCard.publishTitle': 'Pubblica il plugin come repository GitHub',
  'pluginCard.contributeAria': 'Contribuisci con {title} a ZalureAI',
  'pluginCard.contributeTitle': 'Contribuisci con il plugin a ZalureAI tramite una pull request',
  'skillPluginCandidate.createForMe': 'Crea plugin/template',
  'skillPluginCandidate.contributeToMain': 'Contribuisci a open-design',
  'skillPluginCandidate.repoDescription': 'Questo repo sembra poter funzionare come plugin.',
  'integrations.kicker': 'Integrazione',
  'integrations.lede': 'Collega sistemi esterni, porta gli strumenti MCP nel loop del tuo agent e usa ZalureAI da altri IDE, script e automazioni.',
  'integrations.agentReady': 'Pronto per l\'agent',
  'integrations.areasAria': 'Aree di integrazione',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skill',
  'integrations.tabHint.mcp': 'Strumenti esterni',
  'integrations.tabHint.connectors': 'Account e API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Integrazioni Skill',
  'integrations.skillsBody': 'La gestione delle integrazioni a livello di Skill viene trasferita da un altro branch. Questa scheda è riservata affinché la configurazione di MCP, Connettori e future Skill risieda nello stesso percorso di Integrazione.',
  'mcpClient.title': 'Server MCP esterni',
  'mcpClient.subtitle': 'Strumenti di terze parti per il tuo agent di coding.',
  'mcpClient.addServer': 'Aggiungi server',
  'mcpClient.emptyTitle': 'Nessun server MCP configurato.',
  'mcpClient.emptyBody': 'Fai clic su "Aggiungi server" per iniziare — scegli un modello (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) oppure configura un server stdio / HTTP personalizzato.',
  'mcpClient.saveChanges': 'Salva modifiche',
  'mcpClient.storedAt': 'Memorizzato in',
  'mcpClient.daemonError': 'Impossibile raggiungere il daemon locale. Assicurati che ZalureAI sia in esecuzione, quindi riapri questo pannello.',
  'mcpClient.saveFailed': 'Salvataggio non riuscito. Verifica che il daemon sia in esecuzione e riprova.',
  'useEverywhere.modalAria': 'Usa ZalureAI ovunque',
  'useEverywhere.modalTitle': 'Usa ZalureAI ovunque',
  'useEverywhere.modalSubtitle': 'Integra ZalureAI in qualsiasi IDE, agent o script — CLI, HTTP, MCP e Skill. Usa “Copia la guida per un agent” e incollala in Claude Code, Codex, Cursor, openclaw o hermes per configurare tutto.',
  'useEverywhere.closeAria': 'Chiudi usa ovunque',
  'useEverywhere.closeTitle': 'Chiudi (Esc)',
  'useEverywhere.tabsAria': 'Superfici di integrazione',
  'useEverywhere.footStrong': 'Passaggio di consegne con un clic.',
  'useEverywhere.footBody': 'Copia una guida markdown strutturata su cui il tuo agent può agire immediatamente — installa, verifica e usa.',
  'useEverywhere.configureMcp': 'Configura server MCP',
  'useEverywhere.copyGuide': 'Copia guida per un agent',
  'useEverywhere.copy': 'Copia',
  'useEverywhere.copied': 'Copiato',
  'useEverywhere.copyFailed': 'Copia non riuscita',
  'useEverywhere.copySnippetAria': 'Copia snippet: {label}',
  'useEverywhere.section.overview.tab': 'Panoramica',
  'useEverywhere.section.overview.heading': 'ZalureAI funziona ovunque lavori il tuo agent',
  'useEverywhere.section.overview.intro': 'ZalureAI è molto più di una finestra — è un daemon locale con privilegi (`od`) più un registro di Skill + Design System + Atoms. Una volta in esecuzione sulla tua macchina, qualsiasi agent di codice (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, un tuo script) può avviare generazioni, ispezionare progetti e produrre artefatti di design attraverso quattro interfacce intercambiabili.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` per script headless, CI e automazione da shell.',
  'useEverywhere.section.overview.bullet2': 'Server MCP — collega ZalureAI come server Model Context Protocol così che qualsiasi agent compatibile con MCP possa elencare skill, eseguire scenari e leggere artefatti.',
  'useEverywhere.section.overview.bullet3': 'API HTTP — endpoint REST + SSE su `http://127.0.0.1:7456/api/*`; la stessa interfaccia usata dalla UI web.',
  'useEverywhere.section.overview.bullet4': 'Skill — pacchetti `SKILL.md` pronti all\'uso (compatibili con Claude) che qualsiasi agent già presente nel tuo PATH può invocare senza ZalureAI.',
  'useEverywhere.section.overview.bullet5': 'Artefatti standard — genera progetti HTML reali da Skill, plugin predefiniti inclusi ed esempi di plugin della community prima dell\'avvio del daemon.',
  'useEverywhere.section.overview.snippet1': 'Avvia il daemon (e la web UI) in locale',
  'useEverywhere.section.overview.snippet2': 'Conferma che sia raggiungibile',
  'useEverywhere.section.overview.snippet3': 'Importa gli artefatti standard prima dell\'avvio',
  'useEverywhere.section.overview.footer': 'Per impostazione predefinita, il daemon scrive in `./.od/` (locale al progetto). Imposta `OD_DATA_DIR=~/.open-design` per condividere i dati tra progetti.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Controlla ZalureAI da qualsiasi shell',
  'useEverywhere.section.cli.intro': 'Il binario `od` è incluso con il daemon ed è lo stesso binario usato da Claude Code / Codex quando eseguono una generazione. La maggior parte dei sottocomandi sono client leggeri che inviano POST al daemon locale, quindi funzionano allo stesso modo sia che tu l\'abbia avviato tramite `pnpm tools-dev` sia come app pacchettizzata.',
  'useEverywhere.section.cli.bullet1': '`od` (senza argomenti) — avvia il daemon e apre la UI web.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — produce byte di immagine / video / audio attraverso il protocollo media unificato.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — avvia l\'esecuzione di un progetto a partire da un prompt + skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — installa e applica plugin della community.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — ispeziona ciò che è disponibile localmente.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — verifica lo stato del daemon e rileva le CLI degli agent nel tuo PATH.',
  'useEverywhere.section.cli.snippet1': 'Genera un\'immagine (delega al media provider configurato)',
  'useEverywhere.section.cli.snippet2': 'Esegui un plugin di scenario in modalità headless e trasmetti gli eventi come righe JSON',
  'useEverywhere.section.cli.snippet3': 'Elenca skill e design system disponibili in locale',
  'useEverywhere.section.cli.snippet4': 'Verifica gli artefatti precaricati tramite la CLI',
  'useEverywhere.section.cli.snippet5': 'Verifica l\'ambiente + gli agent rilevati (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Tutti i sottocomandi accettano `--daemon-url http://127.0.0.1:<port>` per puntare a uno specifico daemon in esecuzione — utile quando si esegue una seconda istanza in sandbox per i test.',
  'useEverywhere.section.mcp.tab': 'Server MCP',
  'useEverywhere.section.mcp.heading': 'Esponi ZalureAI come server MCP a qualsiasi coding agent',
  'useEverywhere.section.mcp.intro': 'ZalureAI include un server Model Context Protocol (`od mcp`) che consente a qualsiasi client compatibile con MCP — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — di scoprire gli strumenti di ZalureAI (elenca skill, genera anteprime, genera media, esegui plugin) senza ricorrere manualmente alla shell. Il daemon pubblica uno snippet di installazione pronto da incollare tramite `GET /api/mcp/install-info` per ogni client principale.',
  'useEverywhere.section.mcp.bullet1': 'Trasporto stdio — nessuna porta aggiuntiva, il client avvia direttamente `od mcp`.',
  'useEverywhere.section.mcp.bullet2': 'Rileva automaticamente l\'URL del daemon attivo tramite il socket di stato IPC locale quando viene avviato come sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Ripiega su `--daemon-url http://127.0.0.1:<port>` per le installazioni semplici, così il processo MCP trova sempre un daemon in esecuzione.',
  'useEverywhere.section.mcp.bullet4': 'Fissa `OD_DATA_DIR` in modo che il processo MCP generato scriva nello stesso percorso già usato dal daemon (evita EPERM nei bundle delle app macOS pacchettizzate).',
  'useEverywhere.section.mcp.snippet1': 'Configurazione generica del client MCP (funziona in Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Oppure: chiedi al daemon lo snippet personalizzato per la tua installazione',
  'useEverywhere.section.mcp.snippet3': 'Variante MCP live-artifacts (leggi e aggiorna le dashboard)',
  'useEverywhere.section.mcp.footer': 'Nell\'app ZalureAI, apri Impostazioni → Integrazioni per copiare un comando di installazione specifico per il client (Cursor, Claude Code, Antigravity, VS Code) invece di modificare il JSON manualmente.',
  'useEverywhere.section.http.tab': 'API HTTP',
  'useEverywhere.section.http.heading': 'Stessa superficie REST + SSE usata dalla web UI',
  'useEverywhere.section.http.intro': 'Il daemon locale serve un\'API HTTP su `http://127.0.0.1:7456` (porta configurabile). Ogni endpoint chiamato dalla web UI è utilizzabile anche dai tuoi script. Gli endpoint di streaming (turni di chat, esecuzioni di progetto) emettono Server-Sent Events con i tipi di contratto in `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — stato di attività del daemon.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` e `GET /api/design-systems` — registri disponibili.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` e `POST /api/projects` — elenca e crea progetti (POST restituisce il progetto + la prima conversazione).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — stream SSE di eventi dell\'agent per una conversazione.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — collega un plugin installato e ottieni la sua query di esempio renderizzata + gli input.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — CLI di agent di codice rilevate nel tuo PATH.',
  'useEverywhere.section.http.snippet1': 'Elenca le skill installate (l\'agent le userà come template)',
  'useEverywhere.section.http.snippet2': 'Crea un progetto da un prompt (flusso completo lato server)',
  'useEverywhere.section.http.snippet3': 'Trasmetti in streaming un turno di chat (SSE — ogni riga è compatibile con JSON-Lines)',
  'useEverywhere.section.http.footer': 'I tipi TypeScript puri per ogni richiesta/risposta si trovano in `@open-design/contracts` — importali nel tuo script per il completamento automatico completo senza configurare un generatore.',
  'useEverywhere.section.skills.tab': 'Skill e headless',
  'useEverywhere.section.skills.heading': 'Skill pronte all\'uso per qualsiasi agent — anche senza ZalureAI in esecuzione',
  'useEverywhere.section.skills.intro': 'Una Skill è una directory con un file `SKILL.md` compatibile con Claude (front-matter YAML + corpo). ZalureAI estende il formato con il namespace `od:` (`mode`, `preview`, `design_system`, `inputs`, …) così che lo stesso artefatto possa essere usato sia all\'interno di ZalureAI sia da un agent standard come Claude Code, Codex, openclaw o hermes. Il rilevamento segue una catena di precedenza così che i progetti possano sovrascrivere le proprie skill.',
  'useEverywhere.section.skills.bullet1': 'Rilevamento: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (vince il progetto).',
  'useEverywhere.section.skills.bullet2': 'Crea un collegamento simbolico di una skill in più progetti per condividerla senza copiarla.',
  'useEverywhere.section.skills.bullet3': 'Ogni skill può dichiarare connettori, atomi, requisiti di design system e un output di esempio `preview` per la galleria.',
  'useEverywhere.section.skills.bullet4': 'Headless: un agent con `od` nel suo PATH può chiamare `od skills list` e poi eseguire qualsiasi skill; il daemon è facoltativo per i flussi di sola lettura.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` mette alla prova la stessa struttura di artefatti con esempi di plugin predefiniti ed esempi di plugin della community, poi memorizza i progetti `index.html` risultanti come dati di test riutilizzabili.',
  'useEverywhere.section.skills.snippet1': 'SKILL.md minimale (front matter compatibile con Claude + extra di ZalureAI)',
  'useEverywhere.section.skills.snippet2': 'Crea un collegamento simbolico di una skill condivisa in un progetto (stile cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Headless: elenca le skill che il daemon vede in questo momento',
  'useEverywhere.section.skills.snippet4': 'Bundle di fixture di artefatti headless',
  'useEverywhere.section.skills.footer': 'Specifica: `docs/skills-protocol.md` e `docs/agent-adapters.md` coprono l\'intera superficie degli adapter (Claude Code, Codex, Cursor, agent compatibili con MCP, fallback API BYOK) e le strategie di iniezione delle skill per ciascun adapter.',
  'tasks.kicker': 'Spazio di lavoro per l\'automazione',
  'tasks.comingSoon': 'Prossimamente',
  'tasks.lede': 'Le automazioni trasformano i prompt in lavoro duraturo: Orbit le esegue, le routine le mantengono attive, le pianificazioni decidono quando si attivano e i live artifact mostrano cosa è cambiato.',
  'tasks.newAutomation': 'Nuova automazione',
  'tasks.previewNote': 'Solo superficie di anteprima. Le impostazioni di Orbit sono già disponibili oggi; routine, pianificazioni e il collegamento dei live artifact arriveranno con l\'unione dei branch di backend.',
  'tasks.primitivesAria': 'Primitive di automazione',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Un runtime persistente per il lavoro dell\'agent a lunga esecuzione o ricorrente.',
  'tasks.primitive.orbit.enabled': 'Riepilogo giornaliero attivato',
  'tasks.primitive.orbit.manualOnly': 'Solo manuale',
  'tasks.primitive.routines.title': 'Routine',
  'tasks.primitive.routines.body': 'Definizioni di attività durature che persistono dopo la fine di una singola chat.',
  'tasks.primitive.routines.meta': 'Shell del prodotto pronta',
  'tasks.primitive.schedules.title': 'Pianificazioni',
  'tasks.primitive.schedules.body': 'Trigger temporali o basati su eventi che decidono quando una routine deve essere eseguita.',
  'tasks.primitive.schedules.meta': 'Branch in sospeso',
  'tasks.primitive.liveArtifacts.title': 'Live artifact',
  'tasks.primitive.liveArtifacts.body': 'Report e note che continuano ad aggiornarsi mentre un agent lavora.',
  'tasks.primitive.liveArtifacts.meta': 'Modello di anteprima',
  'tasks.listAria': 'Elenco delle automazioni',
  'tasks.routinesAndRuns': '{n} routine ed esecuzioni',
  'tasks.filtersAria': 'Filtri di automazione',
  'tasks.filter.scheduled': 'Pianificato',
  'tasks.filter.running': 'In esecuzione',
  'tasks.filter.done': 'Completato',
  'tasks.configurationAria': 'Configurazione automazione',
  'tasks.slot.trigger': 'Trigger',
  'tasks.slot.pattern': 'Pattern',
  'tasks.slot.runtime': 'Runtime',
  'tasks.slot.output': 'Output',
  'tasks.liveArtifact': 'Artefatto live',
  'tasks.viewProgress': 'Visualizza avanzamento',
  'tasks.pause': 'Pausa',
  'tasks.runNow': 'Esegui ora',
  'tasks.openArtifact': 'Apri artefatto',
  'tasks.status.dailyAt': 'Giornaliero · {time}',
  'tasks.status.pausedManual': 'In pausa · solo manuale',
  'tasks.sample.orbit.title': 'Riepilogo connettori Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'Il digest dei connettori è pianificato',
  'tasks.sample.orbit.metaDisabled': 'Apri le impostazioni di Orbit per abilitare',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · artefatto live',
  'tasks.sample.orbit.previewDisabled': 'Nessuna esecuzione pianificata',
  'tasks.sample.orbit.triggerEnabled': 'Pianificazione · ogni giorno alle {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manuale · esegui su richiesta',
  'tasks.sample.orbit.pattern': 'Routine · digest connettori',
  'tasks.sample.orbit.runtime': 'Orbit · pianificato dal daemon',
  'tasks.sample.orbit.output': 'Artefatto live · report aggiornabile',
  'tasks.sample.orbit.artifactMetaEnabled': 'Si aggiorna dopo ogni esecuzione',
  'tasks.sample.orbit.artifactMetaDisabled': 'In attesa della pianificazione',
  'tasks.sample.orbit.body1': '# Riepilogo attività Orbit Daily',
  'tasks.sample.orbit.body2': 'Connettori verificati · successi, salti ed errori',
  'tasks.sample.orbit.body3': 'I punti salienti diventano un artefatto live aggiornabile.',
  'tasks.sample.mcp.title': 'Ricerca su alternative a MCP',
  'tasks.sample.mcp.status': 'In esecuzione in orbit · 2h 14m',
  'tasks.sample.mcp.meta': '14 / 30 fonti elaborate',
  'tasks.sample.mcp.preview': 'research_notes.md · live',
  'tasks.sample.mcp.trigger': 'Manuale · esecuzione singola',
  'tasks.sample.mcp.pattern': 'Prompt di ricerca approfondita',
  'tasks.sample.mcp.runtime': 'Remoto · persistente',
  'tasks.sample.mcp.output': 'Report live · aggiornamento automatico',
  'tasks.sample.mcp.artifactMeta': 'Aggiornato 12s fa',
  'tasks.sample.mcp.body1': '# Alternative a MCP - risultati preliminari',
  'tasks.sample.mcp.body2': '14 fonti esaminate · 3 candidati selezionati',
  'tasks.sample.mcp.body3': '## Selezione',
  'tasks.sample.mcp.body4': '- Schemi di chiamata strumenti tramite JSON-RPC...',
  'tasks.sample.mcp.body5': '- Protocolli Agent basati su gRPC...',
  'tasks.sample.weekly.title': 'Digest settimanale del team',
  'tasks.sample.weekly.status': 'Prossimo: lun 9:00',
  'tasks.sample.weekly.meta': 'Aggiorna il documento settimanale del Team',
  'tasks.sample.weekly.preview': 'team_weekly.md · prossimo artefatto',
  'tasks.sample.weekly.trigger': 'Pianificazione · settimanale',
  'tasks.sample.weekly.pattern': 'Routine · digest del team',
  'tasks.sample.weekly.runtime': 'Remoto · ricorrente',
  'tasks.sample.weekly.output': 'Artefatto live · markdown',
  'tasks.sample.weekly.artifactMeta': 'Ultimo aggiornamento 4g fa',
  'tasks.sample.weekly.body1': '# Settimanale del team',
  'tasks.sample.weekly.body2': '## In corso',
  'tasks.sample.weekly.body3': '- Passaggio di integrazione del design system',
  'tasks.sample.weekly.body4': '- Controllo qualità dei connettori',
  'tasks.sample.weekly.body5': '## Rischi',
  'tasks.sample.pr.title': 'Promemoria revisione PR',
  'tasks.sample.pr.status': 'Su nuova PR · attivato 23m fa',
  'tasks.sample.pr.meta': 'Invia un messaggio diretto su Slack',
  'tasks.sample.pr.preview': 'Ultima consegna riuscita',
  'tasks.sample.pr.trigger': 'Evento · nuova PR',
  'tasks.sample.pr.pattern': 'Routine · notifica',
  'tasks.sample.pr.runtime': 'Locale · esecuzione rapida',
  'tasks.sample.pr.output': 'Messaggio · DM Slack',
  'tasks.sample.pr.artifactMeta': 'Ultimo avvio 23m fa',
  'tasks.sample.pr.body1': 'Aperta la PR #184 per la revisione',
  'tasks.sample.pr.body2': 'Revisori abbinati: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Consegna: messaggio diretto Slack inviato',
  'tasks.sample.meeting.title': 'Preparazione pre-riunione',
  'tasks.sample.meeting.status': 'Domani · 10:00',
  'tasks.sample.meeting.meta': 'Esecuzione singola · invia riepilogo',
  'tasks.sample.meeting.preview': 'meeting_brief.md · in coda',
  'tasks.sample.meeting.trigger': 'Pianificazione · esecuzione singola',
  'tasks.sample.meeting.pattern': 'Prompt di briefing',
  'tasks.sample.meeting.runtime': 'Remoto · limitato',
  'tasks.sample.meeting.output': 'Artefatto + messaggio',
  'tasks.sample.meeting.artifactMeta': 'In coda per la generazione',
  'tasks.sample.meeting.body1': '# Brief riunione',
  'tasks.sample.meeting.body2': 'Fonte dell\'agenda: evento del calendario + documenti collegati',
  'tasks.sample.meeting.body3': 'L\'output includerà decisioni, blocchi e domande.',
  'tasks.sample.candidate.title': 'Monitoraggio candidati',
  'tasks.sample.candidate.status': 'Non riuscito · richiede attenzione',
  'tasks.sample.candidate.meta': 'Autenticazione scaduta',
  'tasks.sample.candidate.preview': 'Ricollega Greenhouse per riprendere',
  'tasks.sample.candidate.trigger': 'Pianificazione · giornaliera',
  'tasks.sample.candidate.pattern': 'Routine · sincronizzazione candidati',
  'tasks.sample.candidate.runtime': 'Remoto · ricorrente',
  'tasks.sample.candidate.output': 'Artefatto live · tabella',
  'tasks.sample.candidate.artifactMeta': 'In pausa fino al ripristino dell\'autenticazione',
  'tasks.sample.candidate.body1': '# Pipeline candidati',
  'tasks.sample.candidate.body2': 'Ultima sincronizzazione riuscita: 2g fa',
  'tasks.sample.candidate.body3': 'Azione richiesta: riconnetti l\'account di origine.',
  'routines.title': 'Automazioni',
  'routines.subtitle': 'Automazioni pianificate che vengono eseguite automaticamente.',
  'routines.newAutomation': 'Nuova automazione',
  'routines.loading': 'Caricamento…',
  'routines.empty': 'Nessuna automazione.',
  'routines.emptyHint': 'Fai clic su Nuova automazione per pianificare un\'esecuzione automatica dell\'Agent.',
  'routines.runHistoryLoading': 'Caricamento esecuzioni…',
  'routines.runHistoryEmpty': 'Nessuna esecuzione.',
  'routines.fieldName': 'Nome',
  'routines.fieldNamePlaceholder': 'Briefing mattutino',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Recupera l\'attività di ieri su GitHub + Linear e riassumi cosa è cambiato.',
  'routines.fieldSchedule': 'Pianificazione',
  'routines.fieldMinute': 'Minuto di ogni ora',
  'routines.fieldTime': 'Orario',
  'routines.fieldTimezone': 'Fuso orario',
  'routines.fieldsetProject': 'Progetto',
  'routines.kind.hourly': 'Ogni ora',
  'routines.kind.daily': 'Ogni giorno',
  'routines.kind.weekdays': 'Giorni feriali',
  'routines.kind.weekly': 'Ogni settimana',
  'routines.weekday.short.0': 'Dom',
  'routines.weekday.short.1': 'Lun',
  'routines.weekday.short.2': 'Mar',
  'routines.weekday.short.3': 'Mer',
  'routines.weekday.short.4': 'Gio',
  'routines.weekday.short.5': 'Ven',
  'routines.weekday.short.6': 'Sab',
  'routines.weekday.long.0': 'Domenica',
  'routines.weekday.long.1': 'Lunedì',
  'routines.weekday.long.2': 'Martedì',
  'routines.weekday.long.3': 'Mercoledì',
  'routines.weekday.long.4': 'Giovedì',
  'routines.weekday.long.5': 'Venerdì',
  'routines.weekday.long.6': 'Sabato',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Viene eseguita ogni ora al minuto :{minute}',
  'routines.describe.daily': 'Viene eseguita ogni giorno alle {time} {tz}',
  'routines.describe.weekdays': 'Viene eseguito da lun a ven alle {time} {tz}',
  'routines.describe.weekly': 'Viene eseguita ogni {day} alle {time} {tz}',
  'routines.modeCreate': 'Crea un nuovo progetto a ogni esecuzione',
  'routines.modeCreateHint': 'Uno spazio di lavoro nuovo e isolato a ogni attivazione.',
  'routines.modeReuse': 'Riutilizza un progetto esistente',
  'routines.modeReuseHint': 'Ogni esecuzione vive come una nuova conversazione all\'interno del progetto.',
  'routines.pickProject': '— Scegli un progetto —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ nuovo progetto a ogni esecuzione',
  'routines.tagPaused': 'in pausa',
  'routines.metaNext': 'prossima: {when}',
  'routines.metaLast': 'ultima:',
  'routines.triggerManual': 'manuale',
  'routines.triggerScheduled': 'pianificata',
  'routines.openProject': 'Apri progetto',
  'routines.openProjectTitle': 'Apri il progetto su cui ha scritto questa esecuzione',
  'routines.runNow': 'Esegui ora',
  'routines.edit': 'Modifica',
  'routines.pause': 'Sospendi',
  'routines.resume': 'Riprendi',
  'routines.history': 'Cronologia',
  'routines.hideHistory': 'Nascondi cronologia',
  'routines.delete': 'Elimina',
  'routines.deleteTitle': 'Elimina questa automazione',
  'routines.cancel': 'Annulla',
  'routines.save': 'Salva',
  'routines.saving': 'Salvataggio…',
  'routines.create': 'Crea',
  'routines.creating': 'Creazione…',
  'routines.status.queued': 'in coda',
  'routines.status.running': 'in esecuzione',
  'routines.status.succeeded': 'completato',
  'routines.status.failed': 'non riuscito',
  'routines.status.canceled': 'annullato',
  'routines.confirmDelete': 'Eliminare questa automazione? Le esecuzioni precedenti e i relativi progetti vengono conservati.',
  'routines.errorPickProject': 'Scegli un progetto da riutilizzare oppure passa a “Crea nuovo a ogni esecuzione”',
  'routines.errorAgentEmptyOutput': 'L\'Agent è terminato senza produrre alcun output. Il modello o il provider potrebbe aver restituito una risposta vuota — controlla i log dell\'Agent per eventuali errori a monte.',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': 'Fai clic per assegnarci una star su GitHub',
  'entry.githubStarAria': 'Assegna una star a ZalureAI su GitHub',
  'entry.tabImageTemplates': 'Modelli di immagine',
  'entry.tabVideoTemplates': 'Modelli di video',
  'promptTemplates.searchPlaceholder': 'Cerca modelli…',
  'promptTemplates.countLabel': '{n} risultati',
  'promptTemplates.emptyImage': 'Nessun modello di prompt di immagine installato per ora.',
  'promptTemplates.emptyVideo': 'Nessun modello di prompt video installato per ora.',
  'promptTemplates.emptyNoMatch': 'Nessun modello corrisponde alla tua ricerca.',
  'promptTemplates.attributionFooter': 'Adattato da librerie di prompt pubbliche. Ogni scheda rimanda all\'autore originale.',
  'promptTemplates.openPreviewTitle': 'Apri prompt e anteprima',
  'promptTemplates.sourcePrefix': 'Fonte:',
  'promptTemplates.fetchError': 'Impossibile caricare il contenuto di questo modello.',
  'promptTemplates.promptLabel': 'Corpo del prompt',
  'promptTemplates.copyPrompt': 'Copia prompt',
  'promptTemplates.copyDone': 'Copiato!',
  'promptTemplates.modelHint': 'Modello suggerito: {model}',
  'promptTemplates.openSource': 'Vedi originale',
  'promptTemplates.openFullscreen': 'Apri anteprima a schermo intero',
  'promptTemplates.closeFullscreen': 'Chiudi anteprima a schermo intero',
  'promptTemplates.allSources': 'Tutte le fonti',
  'promptTemplates.sourceFilterAria': 'Filtra per fonte',
  'promptTemplates.retry': 'Riprova',
  'connectors.title': 'Connettori',
  'connectors.subtitle': 'Fonti di dati locali e future che possono alimentare gli artefatti live.',
  'connectors.account': 'Account',
  'connectors.noAccount': 'Non connesso',
  'connectors.tools': 'Strumenti',
  'connectors.connect': 'Connetti',
  'connectors.disconnect': 'Disconnetti',
  'connectors.authorizationPending': 'In attesa di autorizzazione...',
  'connectors.authorizationPendingHint': 'Completa l\'autorizzazione nella finestra aperta.',
  'connectors.cancelAuthorization': 'Annulla',
  'connectors.configure': 'Configura',
  'connectors.unavailable': 'Non disponibile',
  'connectors.phaseStubTitle': 'Le API dei connettori arrivano nella fase 3; questa è un\'anteprima.',
  'connectors.statusAvailable': 'Disponibile',
  'connectors.statusConnected': 'Connesso',
  'connectors.statusError': 'Errore',
  'connectors.statusDisabled': 'Disabilitato',
  'connectors.gateTitle': 'Aggiungi la tua chiave API Composio per continuare',
  'connectors.gateBody': 'Incolla la tua chiave sopra, poi clicca su Salva chiave per caricare le integrazioni disponibili.',
  'connectors.aboutLabel': 'Informazioni',
  'connectors.detailsLabel': 'Dettagli',
  'connectors.statusLabel': 'Stato',
  'connectors.category.aiAgents': 'Agenti IA',
  'connectors.category.aiInfrastructure': 'Infrastruttura IA',
  'connectors.category.accounting': 'Contabilità',
  'connectors.category.admin': 'Amministrazione',
  'connectors.category.advertising': 'Pubblicità',
  'connectors.category.analytics': 'Analisi',
  'connectors.category.automation': 'Automazione',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Calendario',
  'connectors.category.commerce': 'Commercio',
  'connectors.category.communication': 'Comunicazione',
  'connectors.category.contacts': 'Contatti',
  'connectors.category.dataPlatform': 'Piattaforma dati',
  'connectors.category.database': 'Database',
  'connectors.category.design': 'Design',
  'connectors.category.developer': 'Strumenti sviluppatore',
  'connectors.category.documentation': 'Documentazione',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Istruzione',
  'connectors.category.email': 'Email',
  'connectors.category.events': 'Eventi',
  'connectors.category.fieldService': 'Servizio sul campo',
  'connectors.category.finance': 'Finanza',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Moduli',
  'connectors.category.gaming': 'Giochi',
  'connectors.category.hr': 'Risorse umane',
  'connectors.category.hospitality': 'Ospitalità',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integrazione',
  'connectors.category.localization': 'Localizzazione',
  'connectors.category.logistics': 'Logistica',
  'connectors.category.maps': 'Mappe',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Media',
  'connectors.category.meetings': 'Riunioni',
  'connectors.category.nonprofit': 'No profit',
  'connectors.category.observability': 'Osservabilità',
  'connectors.category.payments': 'Pagamenti',
  'connectors.category.personal': 'Personale',
  'connectors.category.presentations': 'Presentazioni',
  'connectors.category.procurement': 'Approvvigionamento',
  'connectors.category.product': 'Prodotto',
  'connectors.category.productivity': 'Produttività',
  'connectors.category.projectManagement': 'Gestione progetti',
  'connectors.category.recruiting': 'Reclutamento',
  'connectors.category.research': 'Ricerca',
  'connectors.category.salesIntelligence': 'Intelligence vendite',
  'connectors.category.scheduling': 'Pianificazione',
  'connectors.category.search': 'Ricerca',
  'connectors.category.security': 'Sicurezza',
  'connectors.category.signing': 'Firma',
  'connectors.category.social': 'Social',
  'connectors.category.spreadsheets': 'Fogli di calcolo',
  'connectors.category.storage': 'Archiviazione',
  'connectors.category.support': 'Supporto',
  'connectors.category.surveys': 'Sondaggi',
  'connectors.category.tasks': 'Attività',
  'connectors.category.timeTracking': 'Tracciamento tempo',
  'connectors.category.video': 'Video',
  'connectors.category.whiteboard': 'Lavagna',
  'connectors.categoryLabel': 'Categoria',
  'connectors.providerLabel': 'Provider',
  'connectors.toolsSection': 'Strumenti',
  'connectors.toolsLoading': 'Caricamento strumenti…',
  'connectors.noToolsAvailable': 'Nessuno strumento disponibile per ora. Connettiti per scoprire le capacità di questa integrazione.',
  'connectors.toolDetailsUnavailable': 'I dettagli degli strumenti non sono disponibili, ma questo connettore riporta {n} strumenti.',
  'connectors.loadMoreTools': 'Carica altri strumenti',
  'connectors.openDetailsAria': 'Apri dettagli di {name}',
  'connectors.toolsBadgeNone': 'Nessuno strumento',
  'connectors.toolsBadgeOne': '{n} strumento',
  'connectors.toolsBadgeMany': '{n} strumenti',
  'connectors.searchPlaceholder': 'Cerca connettori…',
  'connectors.searchAriaLabel': 'Cerca connettori per nome, provider o strumento',
  'connectors.searchClear': 'Cancella ricerca',
  'connectors.emptyNoMatchTitle': 'Nessun connettore corrisponde a « {query} »',
  'connectors.emptyNoMatchBody': 'Prova un\'altra parola chiave o cancella la ricerca per vedere il catalogo completo.',
  'connectors.emptyNoMatchAction': 'Cancella ricerca',
  'newproj.tabPrototype': 'Prototipo',
  'newproj.tabLiveArtifact': 'Artefatto live',
  'newproj.tabDeck': 'Presentazione',
  'newproj.tabTemplate': 'Da un modello',
  'newproj.tabMedia': 'Media',
  'newproj.tabOther': 'Altro',
  'newproj.titlePrototype': 'Nuovo prototipo',
  'newproj.titleLiveArtifact': 'Nuovo artefatto live',
  'newproj.titleDeck': 'Nuova presentazione',
  'newproj.titleTemplate': 'Partire da un modello',
  'newproj.titleImage': 'Nuova immagine',
  'newproj.titleVideo': 'Nuovo video',
  'newproj.titleAudio': 'Nuovo audio',
  'newproj.titleMedia': 'Nuovo media',
  'newproj.titleOther': 'Nuovo progetto',
  'newproj.namePlaceholder': 'Nome del progetto',
  'newproj.fidelityLabel': 'Fedeltà',
  'newproj.fidelityWireframe': 'Wireframe',
  'newproj.fidelityHigh': 'Alta fedeltà',
  'newproj.toggleSpeakerNotes': 'Usa note del relatore',
  'newproj.toggleSpeakerNotesHint': 'Meno testo sulle diapositive — mantieni i punti di discussione nelle note.',
  'newproj.toggleAnimations': 'Includi animazioni',
  'newproj.toggleAnimationsHint': 'Aggiungi movimento (entrata, hover, transizioni) oltre al modello.',
  'newproj.targetPlatformsLabel': 'Piattaforme di destinazione',
  'newproj.targetPlatformsHint': 'Scegline una o più. Il web responsive copre solo i breakpoint del browser; aggiungi iOS, Android, app per tablet o app desktop per le varianti native multipiattaforma.',
  'newproj.platform.responsive.label': 'Web responsive',
  'newproj.platform.responsive.hint': 'Un\'unica esperienza web adattata per browser desktop, tablet e mobile',
  'newproj.platform.webDesktop.label': 'Web desktop',
  'newproj.platform.webDesktop.hint': 'Prodotto o landing page browser-first',
  'newproj.platform.mobileIos.label': 'App iOS',
  'newproj.platform.mobileIos.hint': 'Frame iPhone e regole di interazione iOS',
  'newproj.platform.mobileAndroid.label': 'App Android',
  'newproj.platform.mobileAndroid.hint': 'Frame Pixel e regole di interazione Material',
  'newproj.platform.tablet.label': 'App per tablet',
  'newproj.platform.tablet.hint': 'Esperienza tablet in stile nativo con viste affiancate',
  'newproj.platform.desktopApp.label': 'App desktop',
  'newproj.platform.desktopApp.hint': 'Chrome dell\'app macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Superfici companion',
  'newproj.includeLandingPage': 'Includi landing page',
  'newproj.includeLandingPageHint': 'Aggiungi una pagina di marketing responsive per annunci, liste d\'attesa, campagne di lancio, download dell\'app o presentazione del prodotto.',
  'newproj.includeOsWidgets': 'Includi widget di sistema',
  'newproj.includeOsWidgetsHint': 'Aggiungi widget nativi della piattaforma per la schermata Home, la schermata di blocco o l\'accesso rapido per app mobile/tablet.',
  'newproj.includeOsWidgetsDisabledHint': 'Disponibile quando un\'app iOS, Android o per tablet è selezionata come piattaforma di destinazione.',
  'newproj.templateLabel': 'Modello',
  'newproj.noTemplatesTitle': 'Nessun modello per ora',
  'newproj.noTemplatesBody': 'Apri un progetto, poi usa il menu Condividi nel visualizzatore di file per convertirlo in modello. I modelli appaiono qui.',
  'newproj.savedTemplate': 'Modello salvato',
  'newproj.fileSingular': 'file',
  'newproj.filePlural': 'file',
  'newproj.create': 'Crea',
  'newproj.locationLabel': 'Salva in',
  'newproj.locationDefault': 'Progetti ZalureAI',
  'newproj.locationExternalBase': 'Base esterna',
  'newproj.createLiveArtifact': 'Crea artefatto live',
  'newproj.createFromTemplate': 'Crea dal modello',
  'newproj.createDisabledTitle': 'Salva prima un progetto come modello (menu Condividi in un progetto).',
  'newproj.importClaudeZip': 'Importa un ZIP Claude Design',
  'newproj.importClaudeZipTitle': 'Importa un\'esportazione .zip Claude Design',
  'newproj.importingClaudeZip': 'Importazione…',
  'newproj.privacyFooter': 'Solo tu puoi vedere il tuo progetto per impostazione predefinita.',
  'newproj.designSystem': 'Design system',
  'newproj.dsNoneFreeform': 'Nessuno — libero',
  'newproj.dsNoneSubtitleEmpty': 'Nessun token di sistema, scegli la tua palette',
  'newproj.dsNoneSubtitleSelected': 'Ignora i token di sistema. L\'agente sceglie la propria palette.',
  'newproj.dsCategoryFallback': 'Design system',
  'newproj.dsSearch': 'Cerca design system…',
  'newproj.dsModeAria': 'Modalità di selezione',
  'newproj.dsModeSingle': 'Singolo',
  'newproj.dsModeMulti': 'Multiplo',
  'newproj.dsNoneTitle': 'Nessuno — libero',
  'newproj.dsNoneSub': 'Ignora i token di sistema. L\'agente sceglie la propria palette.',
  'newproj.dsEmpty': 'Nessun design system corrisponde a « {query} ».',
  'newproj.dsFootSingular': 'è solo a scopo di ispirazione.',
  'newproj.dsFootPlural': 'sono solo a scopo di ispirazione.',
  'newproj.dsFootClear': 'Cancella',
  'newproj.dsBadgeDefault': 'PREDEFINITO',
  'newproj.dsPrimaryFallback': 'Primario',
  'newproj.surfaceImage': 'Immagine',
  'newproj.surfaceVideo': 'Video',
  'newproj.surfaceAudio': 'Audio',
  'newproj.modelLabel': 'Modello',
  'newproj.modelSearch': 'Cerca modelli…',
  'newproj.modelEmpty': 'Nessun modello corrisponde a questa ricerca.',
  'newproj.modelRecommended': 'Consigliato',
  'newproj.modelMissingTitle': 'Scegli un modello',
  'newproj.modelMissingSub': 'Scegli quale modello gestisce questa superficie.',
  'newproj.aspectLabel': 'Formato',
  'newproj.videoLengthLabel': 'Durata',
  'newproj.videoLengthSeconds': '{n}s',
  'newproj.audioKindLabel': 'Tipo di audio',
  'newproj.audioKindMusic': 'Musica',
  'newproj.audioKindSpeech': 'Voce / TTS',
  'newproj.audioKindSfx': 'Effetti sonori',
  'newproj.audioDurationLabel': 'Durata',
  'newproj.audioDurationSeconds': '{n}s',
  'newproj.voiceLabel': 'Voce',
  'newproj.voicePlaceholder': 'Identificatore voce del provider, opzionale',
  'newproj.connectorsLabel': 'Connettori',
  'newproj.connectorsHint': 'Fonti di dati che questo artefatto può interrogare.',
  'newproj.connectorsEmptyTitle': 'Nessun connettore configurato',
  'newproj.connectorsEmptyBody': 'Connetti una fonte di dati affinché l\'artefatto live utilizzi dati reali invece di segnaposto.',
  'newproj.connectorsEmptyCta': 'Configura connettori →',
  'newproj.connectorsLoading': 'Caricamento connettori…',
  'newproj.connectorsCountOne': '{n} connesso',
  'newproj.connectorsCountMany': '{n} connessi',
  'newproj.connectorsManage': 'Gestisci',
  'newproj.promptTemplateLabel': 'Modello di riferimento',
  'newproj.promptTemplateNoneTitle': 'Nessuno — scrivi il tuo',
  'newproj.promptTemplateNoneSub': 'Ignora la galleria, descrivi il tuo brief',
  'newproj.promptTemplateRefSub': 'Modello di riferimento',
  'newproj.promptTemplateSearch': 'Cerca modelli…',
  'newproj.promptTemplateEmpty': 'Nessun modello installato per questa superficie per ora.',
  'newproj.promptTemplateBodyLabel': 'Prompt (puoi modificarlo)',
  'newproj.promptTemplateOptimizeHint': 'Modifica ciò che vuoi — le tue modifiche vengono trasmesse al brief dell\'agente.',
  'newproj.promptTemplateBodyEmpty': 'Corpo vuoto — l\'agente non riceverà alcun riferimento di modello.',
  'newproj.deleteTemplateTitle': 'Elimina modello',
  'newproj.deleteTemplateConfirm': 'Eliminare « {name} » ? Questa operazione non può essere annullata.',
  'newproj.deleteTemplateConfirmCta': 'Elimina modello',
  'newproj.deleteTemplateError': 'Impossibile eliminare questo modello. Riprova.',
  'designs.subRecent': 'Recenti',
  'designs.subYours': 'I tuoi design',
  'designs.filterAria': 'Filtra progetti',
  'designs.searchPlaceholder': 'Cerca…',
  'designs.emptyNoProjects': 'Nessun progetto per ora.',
  'designs.emptyNoMatch': 'Nessun progetto corrisponde alla tua ricerca.',
  'designs.deleteTitle': 'Elimina progetto',
  'designs.deleteConfirm': 'Eliminare « {name} » ?',
  'designs.cardFreeform': 'libero',
  'designs.badgeLive': 'Attivo',
  'designs.liveArtifactBadgesAria': 'Badge artifact live',
  'designs.liveCount': '{n} attivi',
  'designs.statusLive': 'Artifact live',
  'designs.statusArchived': 'Archiviato',
  'designs.statusError': 'Errore',
  'designs.statusRefreshing': 'Aggiornamento…',
  'designs.statusRefreshFailed': 'Aggiornamento non riuscito',
  'designs.statusRefreshed': 'Aggiornato',
  'designs.status.notStarted': 'Non iniziato',
  'designs.status.queued': 'In coda',
  'designs.status.running': 'In corso',
  'designs.status.awaitingInput': 'Input richiesto',
  'designs.status.succeeded': 'Completato',
  'designs.status.published': 'Pubblicato',
  'designs.status.failed': 'Fallito',
  'designs.status.canceled': 'Annullato',
  'designs.viewToggleAria': 'Modalità di visualizzazione',
  'designs.viewGrid': 'Vista griglia',
  'designs.viewKanban': 'Vista tabella',
  'designs.kanbanEmptyColumn': 'Nessun design',
  'designs.deleteAria': 'Elimina progetto {name}',
  'designs.menuMore': 'Altre azioni',
  'designs.menuRename': 'Rinomina',
  'designs.menuDelete': 'Elimina',
  'designs.renamePrompt': 'Nuovo nome per "{name}"',
  'designs.selectMode': 'Seleziona',
  'designs.cancelSelect': 'Annulla',
  'designs.deleteSelected': 'Elimina selezionati',
  'designs.selectedCount': '{n} selezionati',
  'designs.deleteSelectedConfirm': 'Eliminare {n} progetto/i?',
  'designs.deleteSelectedSuccess': '{n} progetto/i eliminato/i con successo.',
  'designs.deleteSelectedPartial': '{deleted} progetto/i eliminato/i; {failed} non riusciti.',
  'designs.tagPrototype': 'Prototipo',
  'designs.tagLiveArtifact': 'Artifact live',
  'designs.tagSlide': 'Diapositiva',
  'designs.tagMedia': 'Media',
  'designs.renameTitle': 'Rinomina progetto',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Annulla',
  'examples.typeLabel': 'Tipo',
  'examples.surfaceLabel': 'Superficie',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Immagine',
  'examples.surfaceVideo': 'Video',
  'examples.surfaceAudio': 'Audio',
  'examples.scenarioLabel': 'Scenario',
  'examples.modeAll': 'Tutto',
  'examples.modePrototypeDesktop': 'Prototipi · Desktop',
  'examples.modePrototypeMobile': 'Prototipi · Mobile',
  'examples.modeDeck': 'Presentazioni',
  'examples.modeDocument': 'Documenti e modelli',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Attivo',
  'examples.scenarioGeneral': 'Generale',
  'examples.scenarioEngineering': 'Ingegneria',
  'examples.scenarioProduct': 'Prodotto',
  'examples.scenarioDesign': 'Design',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Vendite',
  'examples.scenarioFinance': 'Finanza',
  'examples.scenarioHr': 'Risorse umane',
  'examples.scenarioOperations': 'Operazioni',
  'examples.scenarioSupport': 'Supporto',
  'examples.scenarioLegal': 'Legale',
  'examples.scenarioEducation': 'Istruzione',
  'examples.scenarioPersonal': 'Personale',
  'examples.searchPlaceholder': 'Cerca esempi…',
  'examples.searchAria': 'Cerca esempi per nome',
  'examples.emptyNoSkills': 'Nessuna competenza disponibile. Il daemon è in esecuzione?',
  'examples.emptyNoMatch': 'Nessun esempio corrisponde a questi filtri.',
  'examples.openPreview': '⤢ Apri anteprima',
  'examples.loadingPreview': 'Caricamento anteprima…',
  'examples.hoverPreview': 'Passa sopra per visualizzare l\'anteprima',
  'examples.usePrompt': 'Usa questo prompt',
  'examples.previewModalTitle': 'Apri anteprima completa (modale)',
  'examples.shareTitle': 'Condividi questo esempio',
  'examples.shareLoadFirst': 'Passa sopra per caricare prima l\'anteprima',
  'examples.unavailablePlaceholder': 'Nessuna anteprima {kind} fornita — apri per saperne di più',
  'examples.shareUnavailable': 'Nessuna anteprima {kind} fornita da condividere',
  'examples.shareMenu': 'Condividi ▾',
  'examples.exportPdfAllSlides': 'Esporta in PDF (tutte le diapositive)',
  'examples.exportPptxLocked': 'Esporta in PPTX… (apri prima il modello)',
  'examples.tagSlideDeck': 'Presentazione',
  'examples.tagTemplate': 'Modello',
  'examples.tagDesignSystem': 'Design system',
  'examples.tagMobilePrototype': 'Prototipo mobile',
  'examples.tagDesktopPrototype': 'Prototipo desktop',
  'examples.tagImage': 'Immagine',
  'examples.tagVideo': 'Video',
  'examples.tagAudio': 'Audio',
  'examples.previewLabel': 'Anteprima',
  'ds.surfaceLabel': 'Superficie',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Immagine',
  'ds.surfaceVideo': 'Video',
  'ds.surfaceAudio': 'Audio',
  'ds.searchPlaceholder': 'Cerca design system…',
  'ds.emptyNoMatch': 'Nessun design system corrisponde alla tua ricerca.',
  'ds.badgeDefault': 'PREDEFINITO',
  'ds.preview': 'Anteprima',
  'ds.previewTitle': 'Anteprima del design system',
  'ds.categoryAll': 'Tutto',
  'ds.categoryUncategorized': 'Non categorizzato',
  'ds.showcase': 'Vetrina',
  'ds.tokens': 'Token',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Caricamento di DESIGN.md…',
  'avatar.title': 'Account e impostazioni',
  'avatar.localCli': 'CLI locale',
  'avatar.anthropicApi': 'API Anthropic',
  'avatar.useLocal': 'Usa CLI locale',
  'avatar.useApi': 'Usa API · BYOK',
  'avatar.codeAgent': 'Agente di codice',
  'avatar.rescan': 'Rianalizza il PATH',
  'avatar.amrConsole': 'Account AMR',
  'avatar.amrConsoleMeta': 'Saldo e ricarica',
  'avatar.settings': 'Impostazioni',
  'avatar.backToProjects': 'Torna ai progetti',
  'avatar.metaActive': 'attivo',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'selezionato',
  'avatar.noAgentSelected': 'nessun agente selezionato',
  'avatar.modelSection': 'Modello',
  'avatar.modelLabel': 'Modello',
  'avatar.reasoningLabel': 'Ragionamento',
  'avatar.customSuffix': '(personalizzato)',
  'socialShare.openDesignSection': 'Condividi ZalureAI',
  'socialShare.openDesignTitle': 'ZalureAI su GitHub',
  'socialShare.openDesignText': 'ZalureAI è uno spazio di lavoro open-source per creare, modificare, distribuire e consegnare artifact di design.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'CONDIVISIONE SOCIAL',
  'socialShare.projectTitle': '{title} · ZalureAI',
  'socialShare.projectText': 'Creato con ZalureAI: {title}. Visualizza l\'artifact distribuito e metti una stella al repo: {repo}',
  'socialShare.projectCopyText': 'Creato con ZalureAI: {title}\n{url}\nRepo di ZalureAI: {repo}',
  'socialShare.deployFirst': 'Pubblica e poi condividi…',
  'socialShare.copied': 'Copiato',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Cambia CLI / modello',
  'inlineSwitcher.chipCli': 'CLI locale',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'predefinito',
  'inlineSwitcher.noAgent': 'nessun agent',
  'inlineSwitcher.modeLabel': 'Modalità',
  'inlineSwitcher.agentLabel': 'Agent',
  'inlineSwitcher.providerLabel': 'Provider',
  'inlineSwitcher.modelLabel': 'Modello',
  'inlineSwitcher.useCli': 'Usa CLI locale',
  'inlineSwitcher.useByok': 'Usa API key BYOK',
  'inlineSwitcher.daemonOffline': 'Daemon offline — apri le impostazioni',
  'inlineSwitcher.noAgentsDetected': 'Nessuna CLI rilevata nel PATH',
  'inlineSwitcher.openSettingsForModel': 'Configura il provider nelle Impostazioni',
  'inlineSwitcher.missingApiKey': 'API key non impostata — apri le Impostazioni per aggiungerla.',
  'inlineSwitcher.openFullSettings': 'Apri impostazioni di esecuzione',
  'inlineSwitcher.customSuffix': '(personalizzato)',
  'project.backToProjects': 'Torna ai progetti',
  'project.metaFreeform': 'libero',
  'project.customInstructions': 'Istruzioni del progetto',
  'project.customInstructionsPlaceholder': 'Istruzioni per questo progetto (inserite in ogni messaggio)…',
  'project.resizeChatPanel': 'Ridimensiona il pannello della chat',
  'project.instructionsActive': 'Attivo — incluso in ogni messaggio',
  'chat.tabChat': 'Chat',
  'chat.tabComments': 'Commenti',
  'chat.commentsSoon': 'Commenti — presto disponibile',
  'chat.comments.attached': 'Allegato alla chat',
  'chat.comments.emptyAttached': 'Nessun commento allegato.',
  'chat.comments.saved': 'Commenti salvati',
  'chat.comments.emptySaved': 'Nessun commento salvato.',
  'chat.comments.add': 'Aggiungi',
  'chat.comments.addAll': 'Aggiungi tutto',
  'chat.comments.remove': 'Rimuovi',
  'chat.comments.placeholder': 'Commenta questo elemento…',
  'chat.comments.addSend': 'Aggiungi e invia',
  'chat.comments.updateSend': 'Aggiorna e invia',
  'chat.comments.removeAttachment': 'Rimuovi commento allegato',
  'chat.comments.removeAttachmentAria': 'Rimuovi commento allegato per {name}',
  'chat.comments.comment': 'Commento',
  'chat.comments.sendToChat': 'Invia alla chat',
  'chat.comments.sending': 'Invio…',
  'chat.comments.edit': 'Modifica',
  'chat.comments.select': 'Seleziona',
  'chat.comments.selectAll': 'Seleziona tutto',
  'chat.comments.deselect': 'Deseleziona',
  'chat.comments.nSelected': '{n} selezionati',
  'chat.comments.pin': 'Fissa',
  'chat.comments.addNote': 'Aggiungi nota',
  'chat.comments.savedToast': 'Commento salvato',
  'chat.comments.pinSavedToast': 'Elemento fissato salvato',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} elementi acquisiti',
  'chat.comments.clear': 'Cancella',
  'chat.comments.targetImage': 'Immagine',
  'chat.comments.targetControl': 'Controllo',
  'chat.comments.targetLink': 'Collegamento',
  'chat.comments.targetText': 'Testo',
  'chat.comments.targetSection': 'Sezione',
  'chat.comments.targetPage': 'Pagina',
  'chat.comments.targetArea': 'Area',
  'chat.annotationNotePlaceholder': 'Aggiungi una nota per questo contrassegno',
  'chat.annotationAttachImage': 'Allega immagine',
  'chat.annotationAttachedImages': 'Immagini allegate',
  'chat.annotationAttachedRemove': 'Rimuovi ultima immagine',
  'chat.annotationAddToInput': 'Aggiungi all\'input',
  'chat.annotationAddingToInput': 'Aggiunta in corso...',
  'chat.annotationQueue': 'Coda',
  'chat.annotationQueueing': 'Accodamento in corso...',
  'chat.annotationSending': 'Invio in corso...',
  'chat.annotationSendDisabledReason': 'È in esecuzione un\'attività',
  'chat.annotationPreviewMissing': 'Impossibile acquisire l\'anteprima. Riprova.',
  'chat.annotationPreviewMissingInk': 'Impossibile acquisire l\'anteprima. Riprova per evitare di inviare solo l\'inchiostro.',
  'chat.annotationSentWithoutScreenshot': 'Impossibile catturare l\'anteprima. L\'annotazione è stata inviata senza screenshot.',
  'chat.annotationTimeout': 'Invio dell\'annotazione scaduto. Riprova.',
  'chat.annotationFailed': 'Invio dell\'annotazione non riuscito. Riprova.',
  'chat.annotationProjectCreateFailed': 'Impossibile creare un progetto, quindi l\'annotazione non è stata inviata.',
  'chat.annotationUploadFailed': 'Caricamento dell\'allegato non riuscito. Riprova.',
  'chat.conversationsTitle': 'Conversazioni',
  'chat.conversationsAria': 'Cronologia delle conversazioni',
  'chat.newConversation': 'Nuova conversazione',
  'chat.newConversationsTitle': 'Nuova conversazione',
  'chat.conversationsHeading': 'Conversazioni',
  'chat.new': 'Nuova',
  'chat.emptyConversations': 'Nessuna conversazione per ora.',
  'chat.deleteConversation': 'Elimina conversazione',
  'chat.renameConversationLabel': 'Rinomina "{title}"',
  'chat.deleteConversationConfirm': 'Eliminare « {title} » ? Questo elimina i suoi messaggi.',
  'chat.untitledConversation': 'Conversazione senza titolo',
  'chat.forkedConversationTitle': 'Fork di {title}',
  'chat.forkConversationFailed': 'Impossibile creare un fork di questa conversazione.',
  'chat.startTitle': 'Inizia una conversazione',
  'chat.startHint': 'Descrivi ciò che vuoi generare oppure parti da uno di questi esempi:',
  'chat.fillInputTitle': 'Clicca per riempire il campo',
  'chat.jumpToLatest': 'Vai al più recente',
  'chat.scrollToLatest': 'Scorri fino al più recente',
  'chat.you': 'Tu',
  'chat.openFile': 'Apri {name}',
  'chat.copyPrompt': 'Copia prompt',
  'chat.copyErrorDiagnostic': 'Copy error diagnostics',
  'chat.copyDone': 'Copiato!',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Descrivi ciò che vuoi generare…',
  'chat.activeFileEditingLabel': 'Modifica',
  'chat.activeFilePlaceholder': 'Chiedi a ZalureAI di modificare {file}...',
  'chat.designArtifactsShowMore': 'Mostra altri {count} file di design',
  'chat.mode.chat.label': 'Chiedi',
  'chat.mode.chat.title': 'Modalità Ask',
  'chat.mode.chat.summary': 'Per risposte rapide, modifiche, pianificazione e discussione senza presumere che vada creato un artefatto di design.',
  'chat.mode.chat.solves': 'Usala per chiarire idee, migliorare prompt, confrontare opzioni o fare domande su un lavoro esistente.',
  'chat.mode.chat.query1': 'Riassumi questa bozza e indica le lacune.',
  'chat.mode.chat.query2': 'Aiutami a scegliere la struttura migliore per questa landing page.',
  'chat.mode.chat.query3': 'Rivedi questo design e suggerisci miglioramenti concreti.',
  'chat.mode.design.label': 'Design',
  'chat.mode.design.title': 'Modalità Design',
  'chat.mode.design.summary': 'Per creare o modificare output concreti: pagine, prototipi, artefatti live, slide, immagini, video, HyperFrames, audio, dashboard e file di progetto.',
  'chat.mode.design.solves': 'Usala quando vuoi che ZalureAI generi file, aggiorni il workspace o trasformi un brief in deliverable multimodali.',
  'chat.mode.design.query1': 'Crea una landing page di lancio prodotto e un prototipo HyperFrames da questo brief.',
  'chat.mode.design.query2': 'Crea un deck investor di 10 slide con note per lo speaker.',
  'chat.mode.design.query3': 'Genera concept immagine, video e audio per questa campagna.',
  'chat.mode.cardBestFor': 'Ideale per',
  'chat.mode.cardTry': 'Prova a chiedere',
  'chat.composerHint': '⌘/Ctrl + Invio per inviare · includi obiettivo, contenuto, stile e formato',
  'chat.cliSettingsTitle': 'Impostazioni CLI e modello',
  'chat.cliSettingsAria': 'Apri impostazioni CLI e modello',
  'chat.attachTitle': 'Allega file (o incolla / trascina)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Allega file',
  'chat.importTitle': 'Importa fonti (presto disponibile)',
  'chat.importLabel': 'Importa',
  'chat.importComingSoon': 'Presto disponibile',
  'chat.importSoon': 'Presto',
  'chat.importFig': 'Carica un file .fig',
  'chat.importGitHub': 'Connetti GitHub',
  'chat.importWeb': 'Cattura un elemento web',
  'chat.importFolder': 'Collega una cartella di codice',
  'chat.importSkills': 'Competenze e design system',
  'chat.importProject': 'Fai riferimento a un altro progetto',
  'chat.importDesignSystemHeader': 'Scegli un design system',
  'chat.importDesignSystemBack': 'Indietro',
  'chat.importDesignSystemSearch': 'Cerca design system…',
  'chat.importDesignSystemEmpty': 'Nessun design system corrisponde a "{query}"',
  'chat.importDesignSystemNone': 'Nessuno — formato libero',
  'chat.importDesignSystemNoneSub': 'Non ancorare a un sistema in questo turno',
  'chat.importDesignSystemActive': 'Attivo',
  'chat.importDesignSystemSwitched': 'Design system cambiato in {title}',
  'chat.importDesignSystemFailed': 'Impossibile cambiare design system. Riprova.',
  'chat.importDesignSystemLoadFailed': 'Impossibile caricare i design system.',
  'browserUse.title': 'Ispirazione',
  'browserUse.summary': '{count} azioni web, dando priorità a estrazione asset, linguaggio di design, motion, controlli visivi e struttura dei componenti.',
  'browserUse.searchAria': 'Cerca ispirazione',
  'browserUse.searchPlaceholder': 'Cerca screenshot, font, colori, a11y...',
  'browserUse.empty': 'Nessuna ispirazione corrispondente',
  'browserUse.unavailable': 'L\'ispirazione non è disponibile qui',
  'browserUse.added': 'Aggiunto al composer',
  'browserUse.category.assets': 'Estrazione asset',
  'browserUse.category.tokens': 'Linguaggio di design',
  'browserUse.category.motion': 'Animazione',
  'browserUse.category.visual': 'Controlli visivi',
  'browserUse.category.structure': 'Componenti',
  'browserUse.category.project': 'Esecuzione progetto',
  'browserUse.category.general': 'Generale',
  'browserUse.input.none': 'Nessun input',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Selettore opzionale',
  'browserUse.input.requirementSelector': 'Requisito, selettore opzionale',
  'browserUse.input.selectorOptional': 'Selettore opzionale',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Selettore, scale=2',
  'browserUse.input.gridOverlay': '12 colonne, max 1200, gap 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, dominio o termini di ricerca',
  'browserUse.input.selector': 'Selettore',
  'browserUse.input.selectorText': 'Selettore e testo',
  'browserUse.input.scroll': 'Pixel, alto, basso o pagina',
  'browserUse.input.terminalRun': 'Comando, timeout 120s',
  'browserUse.input.command': 'Comando',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Migliori candidati per il logo da header, nav, nomi di classe, posizione, immagine OG e fallback sul favicon.',
  'browserUse.action.list_images.output': 'Tutte le immagini img, srcset, source e di sfondo CSS con dimensioni e testo alt.',
  'browserUse.action.download_assets.output': 'Cartella degli asset scaricati più _manifest.json con supporto per referer e cookie.',
  'browserUse.action.extract_svgs.output': 'SVG inline e file .svg collegati salvati come singoli file SVG.',
  'browserUse.action.optimize_svgs.output': 'File SVG ottimizzati più rapporto di compressione.',
  'browserUse.action.extract_colors.output': 'Palette ponderata più variabili colore CSS :root come palette.json e palette.html.',
  'browserUse.action.extract_fonts.output': 'Principali famiglie di font, dimensioni, pesi e regole @font-face come typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Raggio, ombra, spaziatura e variabili CSS come tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Scala tipografica per titoli, corpo e pulsanti con dimensione, peso, line-height e rapporti.',
  'browserUse.action.extract_buttons.output': 'Libreria di stili dei pulsanti deduplicata come buttons.html e buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Container grid e flex, direzione, gap, colonne e larghezze massime come layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Breakpoint responsive delle media query come breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'Gradienti CSS come gradients.css, gradients.json e HTML di anteprima.',
  'browserUse.action.extract_shadows.output': 'Box shadow, text shadow e drop shadow come shadows.json più anteprima.',
  'browserUse.action.extract_easings.output': 'Funzioni di easing per transizioni e animazioni come easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js e style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, regole di transizione e transform, librerie di motion rilevate, motion.css e motion.json.',
  'browserUse.action.validate_view.output': 'Percorsi degli screenshot più problemi visivi e di layout strutturati.',
  'browserUse.action.audit_layout.output': 'Difetti di layout tra cui overflow, limiti, sovrapposizioni e testo troncato come audit.json.',
  'browserUse.action.audit_accessibility.output': 'Problemi di a11y con selettori, etichette, ruoli, focus, contrasto e screenshot dove utile.',
  'browserUse.action.responsive_screenshots.output': 'Screenshot per mobile 390, tablet 834 e desktop 1440.',
  'browserUse.action.screenshot_full.output': 'Screenshot dell\'intera pagina oltre il viewport.',
  'browserUse.action.screenshot_element.output': 'Screenshot di un singolo elemento a 2x per impostazione predefinita.',
  'browserUse.action.screenshot_with_grid.output': 'Screenshot con sovrapposizione della griglia di layout.',
  'browserUse.action.screenshot_dark_mode.output': 'Screenshot con prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Guida di stile di una pagina con colori, scala tipografica, raggio e ombre.',
  'browserUse.action.extract_html.output': 'HTML pulito e autonomo, senza script, noscript o attributi di eventi inline.',
  'browserUse.action.extract_component_inventory.output': 'Pattern di componenti ricorrenti, selettori, conteggi e screenshot.',
  'browserUse.action.extract_copy.output': 'Titoli, CTA, testo del corpo e descrizioni come copy.md e copy.json.',
  'browserUse.action.extract_nav.output': 'Navigazione principale e link del footer come sitemap.md e nav.json.',
  'browserUse.action.extract_forms.output': 'Campi del modulo, etichette, suggerimenti di convalida e azioni di invio come forms.json.',
  'browserUse.action.run_project.output': 'URL del server di sviluppo rilevato aperto nella scheda Browser.',
  'browserUse.action.detect_project.output': 'Framework, package manager, comando di installazione, comando di sviluppo e porta.',
  'browserUse.action.page_info.output': 'URL, titolo, descrizione, immagine OG, colore del tema, favicon e viewport.',
  'browserUse.action.snapshot.output': 'Fino a 120 elementi interattivi e di testo visibili con tag, etichetta, href e coordinate.',
  'browserUse.action.navigate.output': 'Apri la pagina e restituisci page_info.',
  'browserUse.action.click.output': 'Clicca sul primo elemento corrispondente dopo averlo portato in vista con lo scorrimento.',
  'browserUse.action.type_text.output': 'Compila un campo di input e invia gli eventi input e change.',
  'browserUse.action.scroll.output': 'Posizione di scorrimento attuale e massima.',
  'browserUse.action.extract_og_metadata.output': 'Titolo meta, descrizione, URL canonico, card OG/Twitter, immagine social e colore del tema.',
  'browserUse.action.terminal_run.output': 'stdout, stderr e codice di uscita.',
  'browserUse.action.terminal_run_background.output': 'ID dell\'attività in background e output recente.',
  'browserUse.action.terminal_read.output': 'Output recente del terminale condiviso.',
  'chat.designToolbox.title': 'Strumenti di design',
  'chat.designToolbox.tooltip': 'Strumenti di design',
  'chat.designToolbox.aria': 'Apri strumenti di design',
  'chat.designToolbox.searchPlaceholder': 'Cerca skill / MCP / plugin / connettori / file di design...',
  'chat.designToolbox.searchAria': 'Cerca risorse degli strumenti di design',
  'chat.designToolbox.followupSection': 'Domanda di approfondimento',
  'chat.designToolbox.resourcesSection': 'Risorse globali',
  'chat.designToolbox.selected': 'Selezionato',
  'chat.designToolbox.noResources': 'Nessuna risorsa trovata per "{query}".',
  'chat.designToolbox.badge.video': 'Video',
  'chat.designToolbox.badge.image': 'Immagine',
  'chat.designToolbox.badge.motion': 'Animazione',
  'chat.designToolbox.badge.polish': 'Rifinitura',
  'chat.designToolbox.action.auto-match.title': 'Abbina al passaggio successivo',
  'chat.designToolbox.action.auto-match.badge': 'Abbina',
  'chat.designToolbox.action.auto-match.description': 'Definisci prima il livello di gusto, poi abbina skill, MCP, plugin, connettori e file.',
  'chat.designToolbox.action.motion.title': 'Aggiungi animazione / movimento',
  'chat.designToolbox.action.motion.badge': 'Animazione',
  'chat.designToolbox.action.motion.description': 'Aggiungi movimenti di entrata, di scorrimento, di transizione di stato e micro-interazioni all\'HTML o all\'elemento di pagina attuale.',
  'chat.designToolbox.action.motion-polish.title': 'Rifinisci l\'animazione',
  'chat.designToolbox.action.motion-polish.badge': 'Tempistica',
  'chat.designToolbox.action.motion-polish.description': 'Esamina tempistica, easing, prestazioni e fallback per il movimento ridotto delle animazioni esistenti.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Rimuovi l\'aspetto da AI',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Gusto',
  'chat.designToolbox.action.anti-ai-polish.description': 'Rimuovi l\'aspetto da template, i gradienti da AI, le pile di card scadenti e i testi vaghi.',
  'chat.designToolbox.action.visual-polish.title': 'Rifinitura del design / pronto per la pubblicazione',
  'chat.designToolbox.action.visual-polish.badge': 'Rifinitura',
  'chat.designToolbox.action.visual-polish.description': 'Valuta gerarchia visiva, tipografia, spaziatura, comportamento responsive, accessibilità e qualità della consegna.',
  'chat.designToolbox.action.image-gen.title': 'Genera immagini / riferimenti visivi',
  'chat.designToolbox.action.image-gen.badge': 'Immagine',
  'chat.designToolbox.action.image-gen.description': 'Genera riferimenti di sezione, asset, icone, immagini social o una moodboard per la pagina attuale.',
  'chat.designToolbox.action.video-gen.title': 'Genera video / script di animazione',
  'chat.designToolbox.action.video-gen.badge': 'Video',
  'chat.designToolbox.action.video-gen.description': 'Trasforma il design in un breve video, uno storyboard Remotion / Hyperframes o un prompt pronto per la generazione.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Template MCP',
  'chat.designToolbox.kind.connector': 'Connettore',
  'chat.designToolbox.kind.designFile': 'File di design',
  'chat.designToolbox.context.browser': 'Browser',
  'chat.designToolbox.context.designFiles': 'File di design',
  'chat.designToolbox.context.designSystem': 'Design system',
  'chat.designToolbox.context.folder': 'Cartella',
  'chat.designToolbox.context.terminal': 'Terminale',
  'chat.designToolbox.context.sideChat': 'Chat laterale',
  'chat.designToolbox.context.liveArtifact': 'Artefatto live',
  'chat.designToolbox.context.file': 'File',
  'chat.designToolbox.prompt.contextGeneric': 'Target corrente: il file HTML / file di design / elemento web attualmente aperto.',
  'chat.designToolbox.prompt.contextSpecific': 'Destinazione attuale: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Mantieni l\'intento già presente nel composer: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Skill selezionata: {skill}. Usala come flusso di lavoro principale per questo turno.',
  'chat.designToolbox.prompt.noSkill': 'Se nessuna skill specifica corrisponde, scegli prima la combinazione migliore tra skill, MCP, plugin, connettori e file di design disponibili.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Agisci come orchestratore Creative Director e completa un flusso di lavoro di design:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Definisci innanzitutto cosa significa “design accattivante”: pubblico, obiettivo di business, percezione del brand, riferimenti di stile, densità delle informazioni, standard di colore/tipografia/animazione/asset e pattern AI/template da evitare.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Cerca e abbina l\'intero indice di risorse qui sopra. Non usare solo i consigli del toolbox di design; combina skill, MCP, plugin, connettori e file di design quando è utile.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. Se il target o il livello estetico è ancora poco chiaro, guidami con scelte finite o un\'interfaccia in stile modulo e includi un valore predefinito consigliato. Se è sufficientemente chiaro, esegui direttamente il passaggio successivo.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Completa il flusso in questo ordine: diagnosi -> direzione stilistica -> selezione delle risorse -> modifica/generazione concreta -> verifica. A ogni passaggio, spiega perché sono state scelte queste risorse e cosa serve confermare in seguito.',
  'chat.designToolbox.prompt.motion': 'Aggiungi un movimento di alta qualità all\'elemento HTML / pagina corrente: scegli 1-2 momenti più utili di ingresso, scroll, transizione di stato o micro-interazione. Mantienilo sobrio, preferisci transform / opacity e includi i fallback per prefers-reduced-motion.',
  'chat.designToolbox.prompt.motionPolish': 'Rivedi e perfeziona timing, easing, prestazioni e accessibilità del movimento esistente. Rimuovi animazioni brusche, scadenti o che danneggiano la leggibilità; usa una timeline più raffinata quando serve.',
  'chat.designToolbox.prompt.antiAiPolish': 'Esegui un passaggio di rifinitura anti-effetto-AI: rimuovi layout da template, gradienti/bagliori scadenti, pile di card prive di senso e testi vaghi. Conserva le informazioni e fai in modo che sembri il lavoro di un vero designer.',
  'chat.designToolbox.prompt.visualPolish': 'Rifinisci questo design finché non è pronto per la pubblicazione: controlla gerarchia, tipografia, spaziatura, comportamento responsive, stati dei pulsanti, stati vuoto/caricamento/errore e accessibilità; correggi direttamente i problemi più importanti.',
  'chat.designToolbox.prompt.imageGen': 'Crea il prossimo piano di asset visivi per questo design: riferimenti per le sezioni, asset hero, illustrazioni, icone, immagini social o un moodboard. Decidi prima quale tipo di immagine manca, poi fornisci prompt di generazione eseguibili / piano dei file.',
  'chat.designToolbox.prompt.videoGen': 'Orienta questo design verso il video: crea uno storyboard per un video breve, una struttura di frame Hyperframes / Remotion o un prompt pronto per Sora/fal. Preferisci far diventare naturalmente il contenuto HTML / della pagina esistente delle inquadrature.',
  'chat.designToolbox.prompt.useSkill': 'Usa {skill} sul design corrente.',
  'chat.designToolbox.prompt.skillInstruction': 'Decidi prima l\'obiettivo di follow-up migliore, poi completa un passaggio concreto. Se dipende da asset o API esterne, fornisci un fallback eseguibile o indica cosa devo fornire.',
  'chat.designToolbox.prompt.selectedResource': 'Risorsa selezionata: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Descrizione della risorsa: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Usa questo plugin come contesto principale per il flusso di design corrente. Se espone input o GenUI, guidami nella scelta quando serve; se non si adatta al target, scegli una risorsa globale migliore e spiega perché.',
  'chat.designToolbox.prompt.mcpResource': 'Preferisci questa capacità MCP per il prossimo passaggio di design. Quando servono asset esterni, acquisizione web, generazione di immagini/video o dati, decidi prima se può svolgere il compito, poi fornisci un piano eseguibile.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Questo MCP è un template configurabile. Se è lo strumento più utile per questo passaggio di design, guida prima la configurazione; se esiste un\'alternativa già configurata, continua con quell\'alternativa.',
  'chat.designToolbox.prompt.connectorResource': 'Usa questo connettore quando servono dati reali, asset, contenuti dell\'account o accesso a flussi di lavoro esterni. Prima di usarlo, spiega cosa verrà letto o scritto e chiedi conferma quando opportuno.',
  'chat.designToolbox.prompt.fileResource': 'Usa questo file di design come target di design corrente o asset di riferimento e completa il passaggio successivo a partire da esso. Se servono altri file per il confronto, continua a cercare tra tutti i file di design.',
  'chat.designToolbox.prompt.resourceIndex': 'Indice globale delle risorse: skill({skills}), plugin({plugins}), MCP({mcpEnabled} abilitati / {mcpTemplates} template), connettori({connectors} connessi), file di design({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Skill ricercabili',
  'chat.designToolbox.prompt.searchablePlugins': 'Plugin ricercabili',
  'chat.designToolbox.prompt.availableMcp': 'MCP disponibili',
  'chat.designToolbox.prompt.connectedConnectors': 'Connettori connessi',
  'chat.designToolbox.prompt.referenceDesignFiles': 'File di design di riferimento',
  'chat.designToolbox.prompt.mcpTemplateName': 'Template {name}',
  'chat.designToolbox.prompt.processRule': 'Regola del flusso di lavoro: definisci prima l\'obiettivo estetico e i vincoli, poi cerca e abbina le risorse; quando serve una scelta dell\'utente, genera un\'interfaccia a scelte finite e continua dopo la conferma.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} altri',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Superfici di menzione',
  'chat.mentionTabAll': 'Tutti',
  'chat.mentionTabTabs': 'Schede',
  'chat.mentionTabPlugins': 'Plugin',
  'chat.mentionTabSkills': 'Skill',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Connettori',
  'chat.mentionTabFiles': 'File di design',
  'chat.mentionNoResults': 'Nessun risultato per “{query}”.',
  'chat.mentionSearchPrompt': 'Cerca tra file di design, schede, plugin, skill, server MCP e connettori.',
  'chat.mentionSectionTabs': 'Schede',
  'chat.mentionSectionPlugins': 'Plugin',
  'chat.mentionSectionSkills': 'Skill',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Connettori',
  'chat.mentionSectionFiles': 'File di design',
  'chat.mentionActiveSkill': 'Attivo',
  'chat.mentionUseMcpTitle': 'Usa {name}',
  'chat.mentionUseConnectorTitle': 'Usa {name}',
  'chat.mentionPluginOfficial': 'Ufficiale',
  'chat.mentionPluginMine': 'Il mio plugin',
  'chat.linkedFolderRemoveAria': 'Rimuovi cartella collegata {path}',
  'chat.linkedFolderNotFound': 'La cartella non esiste',
  'chat.linkedFolderAlready': 'Questa cartella è già collegata',
  'chat.linkedFolderPickError': 'Impossibile aprire il selettore di cartelle',
  'chat.queuedHeader': 'In coda',
  'chat.queuedToSend': 'per inviare',
  'chat.queuedEditQueuedTaskAria': 'Modifica attività in coda',
  'chat.queuedSave': 'Salva',
  'chat.queuedCancel': 'Annulla',
  'chat.queuedReorder': 'Trascina per riordinare',
  'chat.queuedEdit': 'Modifica',
  'chat.queuedMore': 'altri in coda',
  'chat.queuedFollowUpFallback': 'Follow-up in coda',
  'chat.send': 'Invia',
  'chat.stop': 'Ferma',
  'chat.removeAria': 'Rimuovi {name}',
  'chat.example1Title': 'Pitch deck editoriale',
  'chat.example1Tag': 'Rivista',
  'chat.example1Prompt': 'Un pitch deck editoriale di 10 diapositive per uno studio di design che raccoglie fondi — layout a griglia svizzera, titoli con serif sovradimensionati e capolettera, numeri di sezione in monospace, generosi spazi negativi e diapositive fotografiche a pagina intera intervallate da diapositive ricche di testo. Copertina, visione, mercato, prodotto, trazione, team, raccolta fondi, contatto.',
  'chat.example2Title': 'Dashboard SaaS analytics',
  'chat.example2Tag': 'Dati',
  'chat.example2Prompt': 'Una dashboard analytics densa per un SaaS di strumenti per sviluppatori — banner KPI con delta settimana su settimana, due grafici a linee sovrapposte (MRR e spazi di lavoro attivi), una mappa di calore mondiale dell\'utilizzo, una griglia di retention di coorte, una classifica dei migliori clienti e un feed di notizie in tempo reale. Tema scuro, numeri tabulari in monospace, accenti sparkline.',
  'chat.example3Title': 'Report annuale a scorrimento lungo',
  'chat.example3Tag': 'Editoriale',
  'chat.example3Prompt': 'Un report annuale interattivo per un\'ONG climatica — layout editoriale a scorrimento lungo che mescola grandi blocchi di citazioni, visualizzazioni di dati (barre sovrapposte, contatori animati, una mappa coropletica dei siti di progetto), separatori fotografici, un muro di donatori e una chiamata all\'azione finale. Testo in serif moderno, etichette di grafici in sans-serif, palette di carta dai toni terrosi.',
  'preview.usePlugin': 'Usa plugin',
  'preview.usePluginOnly': 'Usa solo il plugin',
  'preview.usePluginOnlyDesc': 'Usa la struttura del plugin e scrivi tu il contenuto',
  'preview.replicateContent': 'Replica questo contenuto',
  'preview.replicateContentDesc': 'Usa il prompt di esempio per ricreare la preview',
  'preview.shareMenu': 'Condividi',
  'preview.exportMenu': 'Esporta',
  'preview.shareTemplateBadge': 'Template',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copia link del template',
  'preview.copyShareText': 'Copia testo da condividere',
  'preview.shareSocialGroup': 'Condividi sui social',
  'preview.shareCopyGroup': 'Copia',
  'preview.shareExportGroup': 'Esporta file',
  'preview.shareCopied': 'Copiato',
  'preview.shareCopyFailed': 'Copia non riuscita',
  'preview.shareTextDefault': 'Template ZalureAI: {title}',
  'preview.openInNewTab': 'Apri in una nuova scheda',
  'preview.exit': '⤓ Esci',
  'preview.fullscreen': '⤢ Schermo intero',
  'preview.closeTitle': 'Chiudi (Esc)',
  'preview.loading': 'Caricamento di {label}…',
  'preview.errorTitle': 'Impossibile caricare questo esempio.',
  'preview.errorBody': 'Il caricamento dell\'HTML dell\'esempio è fallito. Verifica che ZalureAI sia in esecuzione e riprova.',
  'preview.retry': 'Riprova',
  'preview.unavailableTitle': 'Nessuna anteprima fornita per {noun}.',
  'preview.unavailableBody': 'Esegui il prompt nella chat per generare un risultato {kind}.',
  'preview.nounSkill': 'questa competenza',
  'preview.nounPlugin': 'questo plugin',
  'preview.nounTemplate': 'questo modello',
  'preview.showSidebar': 'Mostra {label}',
  'preview.hideSidebar': 'Nascondi {label}',
  'misc.savedTemplate': 'Modello salvato',
  'misc.primary': 'Primario',
  'misc.designSystem': 'Design system',
  'workspace.designFiles': 'File di design',
  'workspace.focusMode': 'Spazio di lavoro focus',
  'workspace.showChat': 'Mostra chat',
  'workspace.closeTab': 'Chiudi scheda',
  'workspace.deleteFileConfirm': 'Eliminare « {name} » dalla cartella del progetto?',
  'workspace.deleteSelectedFilesConfirm': 'Eliminare i {n} file selezionati dalla cartella del progetto?',
  'workspace.deleteSelectedFilesPartial': 'Impossibile eliminare {n} file.',
  'workspace.openFromDesignFiles': 'Apri un file da',
  'workspace.designFilesLink': 'File di design',
  'workspace.loadingSketch': 'Caricamento dello schizzo…',
  'workspace.newTab': 'Nuova scheda',
  'workspace.searchFilesPlaceholder': 'Cerca file…',
  'workspace.openTabs': 'Schede aperte',
  'workspace.openFile': 'Apri un file',
  'workspace.noFilesMatch': 'Nessun file corrispondente',
  'workspace.allFiles': 'Tutti',
  'workspace.createNew': 'Crea nuovo',
  'workspace.tabOpen': 'Aperto',
  'workspace.sideChatContextBanner': 'Contesto integrato dalla conversazione corrente',
  'workspace.sideChatDefaultTitle': 'Chat laterale',
  'workspace.newTerminal': 'Nuovo terminale',
  'workspace.newTerminalDescription': 'Apri una shell nella cartella del progetto in una nuova scheda',
  'workspace.newBrowser': 'Nuovo browser',
  'workspace.newBrowserDescription': 'Apri una scheda browser integrata per siti di riferimento e attività',
  'workspace.terminalStarting': 'Avvio del terminale…',
  'workspace.terminalStartingDescription': 'Preparazione della shell del progetto. Di solito richiede pochi secondi.',
  'workspace.terminalSessionEnded': 'Sessione terminata',
  'workspace.terminalReconnecting': 'Riconnessione…',
  'workspace.terminalStartFailed': 'Impossibile avviare la sessione del terminale',
  'workspace.terminalRestart': 'Riavvia',
  'designFiles.title': 'File di design',
  'designFiles.upload': 'Carica file',
  'designFiles.pasteText': 'Incolla come file di testo',
  'designFiles.newSketch': 'Nuovo schizzo',
  'designFiles.empty': 'Le creazioni appariranno qui',
  'designFiles.refresh': 'Aggiorna',
  'designFiles.delete': 'Elimina',
  'designFiles.searchPlaceholder': 'Cerca file…',
  'designFiles.up': 'Su',
  'designFiles.back': 'Indietro',
  'designFiles.crumbs': 'progetto',
  'designFiles.rowMenu': 'Menu di riga',
  'designFiles.openInTab': 'Apri in una scheda',
  'designFiles.download': 'Scarica',
  'designFiles.downloadSelected': 'Scarica {n} selezionati in ZIP',
  'designFiles.deleteSelected': 'Elimina {n}',
  'designFiles.clearSelection': 'Cancella selezione',
  'designFiles.selectPage': 'Seleziona tutto nella pagina',
  'designFiles.selectAll': 'Seleziona tutto',
  'designFiles.dropTitle': '⤓ Trascina i file qui',
  'designFiles.dropDesc': 'Immagini, documenti, riferimenti o cartelle — l\'agente li userà come contesto.',
  'designFiles.dropLabel': 'Trascina i file qui',
  'designFiles.upload.title': 'Carica file',
  'designFiles.paste.title': 'Incolla testo come file',
  'designFiles.upload.label': 'Carica',
  'designFiles.paste.label': 'Incolla',
  'designFiles.previewOpen': 'Apri',
  'designFiles.previewClose': 'Chiudi anteprima',
  'designFiles.modified': 'Modificato {time} · {size}',
  'designFiles.weeksAgo': '{n} sett fa',
  'designFiles.groupBy': 'Raggruppa per',
  'designFiles.groupByKind': 'Tipo',
  'designFiles.groupByModified': 'Modifica',
  'designFiles.filterBy': 'Filtra per tipo',
  'designFiles.filterClear': 'Cancella',
  'designFiles.filterCount': '{n} tipi',
  'designFiles.expandGroup': 'Espandi',
  'designFiles.collapseGroup': 'Riduci',
  'designFiles.sectionPages': 'Pagine',
  'designFiles.sectionScripts': 'Script',
  'designFiles.sectionImages': 'Immagini',
  'designFiles.sectionSketches': 'Schizzi',
  'designFiles.sectionLiveArtifacts': 'Artifact live',
  'designFiles.sectionOther': 'Altro',
  'designFiles.modifiedToday': 'Oggi',
  'designFiles.modifiedYesterday': 'Ieri',
  'designFiles.modifiedPrevious7Days': 'Ultimi 7 giorni',
  'designFiles.modifiedPrevious30Days': 'Ultimi 30 giorni',
  'designFiles.modifiedOlder': 'Più vecchio',
  'designFiles.showMore': 'Mostra +{n} in più',
  'designFiles.kindHtml': 'Pagina HTML',
  'designFiles.kindImage': 'Immagine',
  'designFiles.kindSketch': 'Schizzo',
  'designFiles.kindText': 'Testo',
  'designFiles.kindCode': 'Script',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Documento',
  'designFiles.kindPresentation': 'Presentazione',
  'designFiles.kindSpreadsheet': 'Foglio di calcolo',
  'designFiles.kindLiveArtifact': 'Artifact live',
  'designFiles.kindBinary': 'Binario',
  'designFiles.kindFolder': 'Cartella',
  'designFiles.folderCount': '{n} file',
  'designFiles.newFolderTitle': 'Nuova cartella',
  'designFiles.newFolderLabel': 'Nome cartella',
  'designFiles.moveTitle': 'Sposta nella cartella',
  'designFiles.moveLabel': 'Cartella di destinazione',
  'designFiles.moveRoot': 'Radice del progetto',
  'designFiles.moveNewFolder': 'Nuova cartella…',
  'designFiles.move': 'Sposta',
  'designFiles.copyPath': 'Copia percorso',
  'designFiles.copiedPath': 'Percorso copiato',
  'designFiles.deleteFolderConfirm': 'Eliminare la cartella "{name}" e tutto il suo contenuto?',
  'designFiles.folderCreated': 'Cartella "{name}" creata',
  'designFiles.folderDeleted': 'Cartella "{name}" eliminata',
  'designFiles.filesMoved': '{n} spostati in {dest}',
  'designFiles.colName': 'Nome',
  'designFiles.colKind': 'Tipo',
  'designFiles.colModified': 'Modificato il',
  'designFiles.perPage': 'Mostra',
  'designFiles.all': 'Tutto',
  'designFiles.prev': 'Precedente',
  'designFiles.next': 'Successivo',
  'designFiles.jumpToPage': 'Vai alla pagina',
  'designFiles.pageInfo': '{start}–{end} su {total}',
  'designFiles.sectionFolders': 'Cartelle',
  'designFiles.sectionStylesheets': 'Fogli di stile',
  'designFiles.sectionDocuments': 'Documenti',
  'designFiles.kindStylesheet': 'Foglio di stile',
  'designFiles.modifiedExt': 'Modificato {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Informazioni utili',
  'designFiles.usefulInfoTip': 'Fai doppio clic su un file per aprirlo in una scheda completa.',
  'designFiles.usefulInfoTip2': 'Digita @ nella chat per usare un file come contesto.',
  'designFiles.usefulInfoTip4': 'Scegli un design system per risultati coerenti con il brand.',
  'designFiles.usefulInfoTip5': 'Senza idee? Prova un template plugin nella Community in Home.',
  'designFiles.usefulInfoTip6': 'Domande o suggerimenti? Unisciti al nostro Discord.',
  'designFiles.usefulInfoTip7': 'Ti piace ZalureAI? Lascia una stella su GitHub.',
  'designFiles.usefulInfoTip8': 'Segui @nexudotio su X per le ultime novità.',
  'designFiles.usefulInfoTip9': 'Trascina immagini, documenti o intere cartelle in questo pannello — l’agente li userà come contesto.',
  'designFiles.usefulInfoTip10': 'Clicca su «Nuovo schizzo», disegna un layout e lascia che l’agente lo generi.',
  'designFiles.usefulInfoTip11': 'Seleziona un elemento nell’anteprima per commentarlo — l’agente farà modifiche mirate.',
  'designFiles.usefulInfoTip12': 'Risultato non convincente? Cerchiarlo è più veloce che descriverlo di nuovo.',
  'designFiles.usefulInfoTip13': 'Esporta ogni design come PDF, immagine o HTML autonomo con un clic.',
  'designFiles.usefulInfoTip14': 'Soddisfatto di un progetto? Salvalo come template dal menu Condividi.',
  'designFiles.usefulInfoTip15': 'Dopo il deploy puoi generare subito le card per i social.',
  'quickSwitcher.placeholder': 'Apri un file…',
  'quickSwitcher.empty': 'Nessun file in questo progetto',
  'quickSwitcher.noMatches': 'Nessun risultato',
  'quickSwitcher.navigate': 'naviga',
  'quickSwitcher.open': 'apri',
  'quickSwitcher.close': 'chiudi',
  'pasteDialog.title': 'Incolla testo',
  'pasteDialog.hint': 'Salvato nella cartella del progetto. Scegli un nome.',
  'pasteDialog.fileNameLabel': 'Nome del file',
  'pasteDialog.namePlaceholder': 'note.txt',
  'pasteDialog.contentLabel': 'Contenuto',
  'pasteDialog.contentPlaceholder': 'Incolla qualsiasi cosa…',
  'pasteDialog.save': 'Salva',
  'pasteDialog.cancel': 'Annulla',
  'sketch.save': 'Salva schizzo',
  'sketch.cancel': 'Annulla',
  'sketch.saving': 'Salvataggio…',
  'sketch.saved': 'Salvato',
  'sketch.tooltipDirty': 'Modifiche non salvate',
  'sketch.tooltipClean': 'Salvato',
  'fileViewer.empty': 'Seleziona un file da visualizzare.',
  'fileViewer.loading': 'Caricamento…',
  'fileViewer.exportPptx': 'Esporta in PPTX',
  'fileViewer.openInNewTab': 'Apri in una nuova scheda',
  'fileViewer.copyPath': 'Copia percorso',
  'fileViewer.copied': 'Copiato!',
  'fileViewer.share': 'Condividi',
  'fileViewer.binaryMeta': 'Binario · {size}',
  'fileViewer.binaryNote': 'File binario ({size} byte). Scarica o apri dal disco per ispezionare.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Documento',
  'fileViewer.presentationMeta': 'Presentazione',
  'fileViewer.spreadsheetMeta': 'Foglio di calcolo',
  'fileViewer.previewUnavailable': 'Anteprima non disponibile. Scarica o apri il file per ispezionare.',
  'fileViewer.download': 'Scarica',
  'fileViewer.open': 'Apri',
  'fileViewer.imageMeta': 'Immagine · {size}',
  'fileViewer.reactMeta': 'Componente React · {size}',
  'fileViewer.sketchMeta': 'Schizzo · {size}',
  'fileViewer.markdownStreamingMeta': 'Anteprima in streaming…',
  'fileViewer.markdownErrorMeta': 'L\'anteprima potrebbe essere incompleta (errore di generazione).',
  'fileViewer.markdownStreamingStatus': 'Streaming… visualizzazione del markdown parziale.',
  'fileViewer.markdownErrorStatus': 'Errore di generazione. Visualizzazione dell\'ultimo contenuto disponibile.',
  'fileViewer.videoMeta': 'Video · {size}',
  'fileViewer.audioMeta': 'Audio · {size}',
  'fileViewer.reload': 'Ricarica',
  'fileViewer.reloadDisk': 'Ricarica dal disco',
  'fileViewer.copy': 'Copia',
  'fileViewer.copyTitle': 'Copia contenuto del file',
  'fileViewer.saveDisabled': 'Salva (visualizzatore in sola lettura)',
  'fileViewer.save': 'Salva',
  'fileViewer.preview': 'Anteprima',
  'fileViewer.source': 'Sorgente',
  'fileViewer.tweaks': 'Modifiche',
  'fileViewer.tweaksUnavailable': 'Nessun pannello di modifiche in questo artefatto',
  'fileViewer.jsxModuleTitle': 'Nessuna anteprima autonoma',
  'fileViewer.jsxModuleBody': 'Questo file è un modulo componente caricato da un’altra pagina.',
  'fileViewer.jsxModuleCta': 'Apri la pagina che lo visualizza:',
  'fileViewer.comment': 'Commenta',
  'fileViewer.edit': 'Modifica',
  'fileViewer.draw': 'Disegna',
  'fileViewer.mark': 'Contrassegna',
  'fileViewer.markTool': 'Strumento contrassegno',
  'fileViewer.boxSelect': 'Selezione a riquadro',
  'fileViewer.screenshot': 'Screenshot',
  'manualEdit.layers': 'Livelli',
  'manualEdit.editableCount': '{count} modificabile',
  'manualEdit.hiddenBadge': 'Nascosto',
  'manualEdit.title': 'Editor manuale',
  'manualEdit.fallbackTitle': 'Modifica',
  'manualEdit.movePanel': 'Sposta pannello di modifica',
  'manualEdit.editParams': 'Modifica parametri',
  'manualEdit.closePanel': 'Chiudi pannello di modifica',
  'manualEdit.selectLayer': 'Seleziona un livello',
  'manualEdit.empty': 'Clicca un elemento nell\'anteprima o scegli un livello.',
  'manualEdit.noEditableLayers': 'Nessun livello modificabile trovato.',
  'manualEdit.noClass': 'nessuna classe',
  'manualEdit.tabsAria': 'Schede di modifica manuale',
  'manualEdit.tabContent': 'Contenuto',
  'manualEdit.tabStyle': 'Stile',
  'manualEdit.tabAttributes': 'Attributi',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Sorgente',
  'manualEdit.attributesJson': 'JSON degli attributi',
  'manualEdit.selectedHtml': 'HTML dell\'elemento selezionato',
  'manualEdit.fullSource': 'Sorgente completo dell\'artefatto',
  'manualEdit.applyContent': 'Applica contenuto',
  'manualEdit.applyStyle': 'Applica stile',
  'manualEdit.applyAttributes': 'Applica attributi',
  'manualEdit.applyHtml': 'Applica HTML',
  'manualEdit.applySource': 'Applica sorgente',
  'manualEdit.invalidAttributes': 'JSON degli attributi non valido.',
  'manualEdit.changes': 'Modifiche',
  'manualEdit.undo': 'Annulla',
  'manualEdit.redo': 'Ripeti',
  'manualEdit.noChanges': 'Nessuna modifica manuale ancora.',
  'manualEdit.imageUrl': 'URL immagine',
  'manualEdit.altText': 'Testo alternativo',
  'manualEdit.label': 'Etichetta',
  'manualEdit.text': 'Testo',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Colore testo',
  'manualEdit.background': 'Sfondo',
  'manualEdit.fontSize': 'Dimensione carattere',
  'manualEdit.weight': 'Peso',
  'manualEdit.align': 'Allineamento',
  'manualEdit.padding': 'Padding',
  'manualEdit.margin': 'Margine',
  'manualEdit.radius': 'Raggio',
  'manualEdit.border': 'Bordo',
  'manualEdit.width': 'Larghezza',
  'manualEdit.minHeight': 'Altezza minima',
  'manualEdit.deleteElement': 'Elimina elemento',
  'manualEdit.deleteElementConfirm': 'Eliminare l\'elemento selezionato? L\'operazione può essere annullata con Annulla.',
  'manualEdit.uploadImage': 'Carica immagine',
  'manualEdit.uploadingImage': 'Caricamento immagine…',
  'manualEdit.uploadImageFailed': 'Impossibile caricare l\'immagine.',
  'manualEdit.focusSlides': 'Concentra sulle slide',
  'manualEdit.showPanels': 'Mostra pannelli',
  'fileViewer.zoomOut': 'Riduci zoom',
  'fileViewer.zoomIn': 'Aumenta zoom',
  'fileViewer.resetZoom': 'Reimposta zoom',
  'fileViewer.viewportAria': 'Viewport di anteprima',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Anteprima desktop a larghezza intera',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Anteprima tablet a 820 × 1180 (riferimento verticale moderno)',
  'fileViewer.viewportMobile': 'Mobile',
  'fileViewer.viewportMobileTitle': 'Anteprima mobile a 390 × 844',
  'fileViewer.reloadAria': 'Ricarica',
  'fileViewer.previousSlide': 'Diapositiva precedente',
  'fileViewer.nextSlide': 'Diapositiva successiva',
  'fileViewer.slideNavAria': 'Navigazione diapositive',
  'fileViewer.present': 'Presenta',
  'fileViewer.presentInTab': 'In questa scheda',
  'fileViewer.presentFullscreen': 'Schermo intero',
  'fileViewer.presentNewTab': 'Nuova scheda',
  'fileViewer.exitPresentation': 'Esci dalla presentazione',
  'fileViewer.shareLabel': 'Condividi',
  'fileViewer.shareMenuShareLink': 'CONDIVIDI',
  'fileViewer.shareMenuPublishOnline': 'PUBBLICA ONLINE',
  'fileViewer.shareMenuDownload': 'SCARICA',
  'fileViewer.shareMenuPresentation': 'Presentazione',
  'fileViewer.shareMenuSourceFiles': 'File sorgente',
  'fileViewer.shareMenuSave': 'SALVA',
  'fileViewer.copyShareLink': 'Copia link di condivisione',
  'fileViewer.openSharePage': 'Apri pagina condivisa',
  'fileViewer.shareLinkRequiresDeploy': 'Pubblica prima online per ottenere un link',
  'fileViewer.shareLinkPublishGuide': 'Pubblica online sopra per abilitare la condivisione ↑',
  'fileViewer.shareAfterGenerationComplete': 'Condivisione disponibile al termine della generazione',
  'fileViewer.copyProviderLink': 'Copia link {provider}',
  'fileViewer.copyCloudflareLink': 'Copia link Cloudflare',
  'fileViewer.screenshotCopying': 'Copia dello screenshot in corso...',
  'fileViewer.screenshotCopied': 'Screenshot copiato negli appunti',
  'fileViewer.screenshotClipboardDenied': 'Il browser ha bloccato l\'accesso agli appunti',
  'fileViewer.screenshotPreviewLoading': 'L\'anteprima si sta ancora caricando. Riprova tra un momento.',
  'fileViewer.screenshotCaptureFailed': 'Impossibile acquisire l\'anteprima. Riprova.',
  'fileViewer.exportPdf': 'Esporta in PDF',
  'fileViewer.exportPdfAllSlides': 'Esporta in PDF (tutte le diapositive)',
  'fileViewer.exportPptxBusy': 'Attendi la fine del turno in corso.',
  'fileViewer.exportPptxHint': 'Invia una richiesta all\'agente per convertire questo design in PPTX.',
  'fileViewer.exportPptxNa': 'L\'esportazione PPTX non è disponibile qui.',
  'fileViewer.exportZip': 'Scarica come .zip',
  'fileViewer.exportHtml': 'Esporta in HTML autonomo',
  'fileViewer.exportMd': 'Esporta in Markdown',
  'fileViewer.exportImage': 'Esporta come immagine',
  'fileViewer.exportImageFailed': 'Acquisizione immagine non riuscita. Riprova o usa lo strumento screenshot del browser.',
  'fileViewer.exportImageModalSubtitle': 'Scegli un formato, poi scarica l\'anteprima corrente come immagine.',
  'fileViewer.exportImageFormatLabel': 'Formato',
  'fileViewer.exportImageSaving': 'Salvataggio immagine…',
  'fileViewer.exportImageSaved': 'Immagine salvata',
  'fileViewer.exportImageDownloadStarted': 'Download avviato',
  'fileViewer.exportImageDownloadDetails': '{filename} si trova nei download del browser se non è apparsa la finestra Salva con nome.',
  'fileViewer.exportJsx': 'Esporta in JSX',
  'fileViewer.exportReactHtml': 'Esporta anteprima in HTML',
  'fileViewer.exportStarted': 'Esportazione avviata',
  'fileViewer.saveAsTemplate': 'Salva come modello…',
  'fileViewer.savingTemplate': 'Salvataggio del modello…',
  'fileViewer.savedTemplate': 'Salvato come « {name} »',
  'fileViewer.savedTemplateFail': 'Impossibile salvare il modello — riprova.',
  'fileViewer.templateNamePrompt': 'Nome del modello',
  'fileViewer.templateNameDefault': 'Modello senza titolo',
  'fileViewer.templateDescPrompt': 'Breve descrizione (facoltativa — cosa rende utile questo modello?)',
  'liveArtifact.refresh.button': 'Aggiorna',
  'liveArtifact.refresh.buttonTitle': 'Aggiorna questo artefatto live',
  'liveArtifact.refresh.loadingTitle': 'Caricamento artifact live…',
  'liveArtifact.refresh.noSourceTitle': 'Nessuna origine di aggiornamento ancora disponibile.',
  'liveArtifact.refresh.running': 'Aggiornamento…',
  'liveArtifact.refresh.runningMessage': 'Aggiornamento di dati e anteprima in corso. Potrebbe richiedere un momento.',
  'liveArtifact.refresh.runningAction': 'L\'anteprima precedente resta visibile finché l\'aggiornamento non riesce.',
  'liveArtifact.refresh.successOne': 'Aggiornamento completato. Dati aggiornati.',
  'liveArtifact.refresh.successMany': 'Aggiornamento completato. Dati aggiornati.',
  'liveArtifact.refresh.successAction': 'L\'anteprima è stata ricaricata con i dati più recenti salvati.',
  'liveArtifact.refresh.previousFailure': 'Aggiornamento precedente non riuscito: {message}',
  'liveArtifact.refresh.failureAction': 'Controlla la cronologia degli aggiornamenti, risolvi il problema di origine o di autorizzazione, poi riprova.',
  'liveArtifact.refresh.networkFailure': 'Richiesta di aggiornamento non riuscita. Verifica la connessione e riprova.',
  'liveArtifact.refresh.genericFailure': 'Aggiornamento non riuscito.',
  'liveArtifact.refresh.statusNever': 'Non aggiornabile',
  'liveArtifact.refresh.statusReady': 'Pronto per l\'aggiornamento',
  'liveArtifact.refresh.statusSucceeded': 'Aggiornato',
  'liveArtifact.refresh.statusFailed': 'Aggiornamento non riuscito',
  'liveArtifact.refresh.statusRunning': 'Aggiornamento in corso',
  'liveArtifact.refresh.statusRunningDescription': 'Un\'esecuzione di aggiornamento è attualmente in corso.',
  'liveArtifact.refresh.statusSucceededDescription': 'L\'ultimo aggiornamento è terminato con successo.',
  'liveArtifact.refresh.statusFailedDescription': 'L\'ultimo tentativo di aggiornamento non è stato completato con successo.',
  'liveArtifact.refresh.statusReadyDescription': 'Le origini aggiornabili sono configurate ma nessuna esecuzione è in corso.',
  'liveArtifact.refresh.statusNeverDescription': 'Questo artefatto live non ha ancora un\'origine di aggiornamento.',
  'liveArtifact.refresh.eventStarted': 'Avviato',
  'liveArtifact.refresh.eventSucceeded': 'Riuscito',
  'liveArtifact.refresh.eventFailed': 'Non riuscito',
  'liveArtifact.refresh.eventStartedDetail': 'Aggiornamento avviato…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} origine aggiornata',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} origini aggiornate',
  'liveArtifact.refresh.timelineEmpty': 'Nessuna attività di aggiornamento in questa sessione. Avvia un aggiornamento per registrare una cronologia oppure attendi le esecuzioni automatiche.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Ultimo aggiornamento',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Mai',
  'liveArtifact.refresh.justNow': 'adesso',
  'liveArtifact.refresh.factCreated': 'Creato',
  'liveArtifact.refresh.factLastUpdated': 'Ultimo aggiornamento',
  'liveArtifact.refresh.factUnknown': 'Sconosciuto',
  'liveArtifact.refresh.persistedTitle': 'Cronologia aggiornamenti salvata',
  'liveArtifact.refresh.persistedHint': 'Voci caricate da refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Nessuna cronologia aggiornamenti salvata.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'riuscito',
  'liveArtifact.refresh.persistedStatusRunning': 'in esecuzione',
  'liveArtifact.refresh.persistedStatusFailed': 'non riuscito',
  'liveArtifact.refresh.persistedStatusCancelled': 'annullato',
  'liveArtifact.refresh.persistedStatusSkipped': 'saltato',
  'liveArtifact.refresh.sessionTitle': 'Attività della sessione',
  'liveArtifact.refresh.sessionHint': 'Eventi rilevati mentre questa scheda è aperta',
  'liveArtifact.refresh.docSourceTitle': 'Origine documento',
  'liveArtifact.refresh.docSourceHint': 'Origine configurata',
  'liveArtifact.refresh.docSourceType': 'Tipo',
  'liveArtifact.refresh.docSourceTool': 'Strumento',
  'liveArtifact.refresh.docSourceConnector': 'Connettore',
  'liveArtifact.refresh.debugSummary': 'Metadati di debug avanzati',
  'liveArtifact.refresh.debugNote': 'Può includere ID dei connettori, nomi di file, metadati delle origini e percorsi interni degli artefatti.',
  'liveArtifact.viewer.tabPreview': 'Anteprima',
  'liveArtifact.viewer.tabCode': 'Codice',
  'liveArtifact.viewer.tabData': 'Dati',
  'liveArtifact.viewer.tabRefreshHistory': 'Cronologia aggiornamenti',
  'liveArtifact.viewer.dataEmpty': 'Nessuna cache data.json disponibile.',
  'liveArtifact.viewer.code.templateHeading': 'HTML del modello',
  'liveArtifact.viewer.code.renderedHeading': 'HTML renderizzato',
  'liveArtifact.viewer.code.templateHelp': 'Il modello modificabile utilizzato con data.json per generare l\'anteprima.',
  'liveArtifact.viewer.code.renderedHelp': 'L\'index.html generato attualmente caricato dall\'anteprima.',
  'liveArtifact.viewer.code.variantAria': 'Variante del codice',
  'liveArtifact.viewer.code.variantTemplate': 'Modello',
  'liveArtifact.viewer.code.variantRendered': 'Renderizzato',
  'liveArtifact.viewer.code.loading': 'Caricamento codice…',
  'liveArtifact.viewer.code.unavailable': 'Il codice non è ancora disponibile.',
  'liveArtifact.viewer.code.empty': 'Questo file di codice è vuoto.',
  'fileViewer.deployToVercel': 'Distribuisci su Vercel',
  'fileViewer.redeployToVercel': 'Ridistribuisci',
  'fileViewer.deployingToVercel': 'Distribuzione su Vercel…',
  'fileViewer.deployProviderLabel': 'Provider',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'Distribuisci su {provider}',
  'fileViewer.redeployToProvider': 'Ridistribuisci su {provider}',
  'fileViewer.deployingToProvider': 'Distribuzione su {provider}…',
  'fileViewer.preparingPublicLink': 'Preparazione del link pubblico…',
  'fileViewer.copyDeployLink': 'Copia link',
  'fileViewer.deployModalTitle': 'Distribuisci',
  'fileViewer.deployModalSubtitle': 'Usa l\'account del provider selezionato per distribuire questa anteprima HTML.',
  'fileViewer.vercelToken': 'Token Vercel',
  'fileViewer.vercelTokenGetLink': 'Ottieni un token Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Incolla il tuo token Vercel',
  'fileViewer.vercelTokenReuseHint': 'Il token salvato verrà utilizzato. Inserisci un nuovo token per sostituirlo.',
  'fileViewer.vercelTokenRequired': 'Inserisci e salva prima un token Vercel.',
  'fileViewer.cloudflareApiToken': 'Token API Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Ottieni token API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Incolla il tuo token API Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'Il token API Cloudflare salvato verrà utilizzato. Inserisci un nuovo token per sostituirlo.',
  'fileViewer.cloudflareApiTokenRequired': 'Inserisci e salva prima un token API Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Seleziona Pages Edit durante la creazione del token API; i domini personalizzati richiedono Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'ID team',
  'fileViewer.vercelTeamSlug': 'Slug team',
  'fileViewer.cloudflareAccountId': 'ID account',
  'fileViewer.cloudflareAccountIdHint': 'Trova l’ID account nella dashboard Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Inserisci e salva prima un ID account Cloudflare.',
  'fileViewer.cloudflareZoneLabel': 'Dominio',
  'fileViewer.cloudflareZonePlaceholder': 'Salva le impostazioni Cloudflare per caricare i domini',
  'fileViewer.cloudflareZoneRequired': 'Seleziona prima un dominio Cloudflare.',
  'fileViewer.cloudflareZonesLoading': 'Caricamento domini Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'Aggiorna domini',
  'fileViewer.cloudflareZonesLoadFailed': 'Impossibile caricare i domini Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'Nessun dominio Cloudflare completo attivo trovato per questo account.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Prefisso sottodominio',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Usa solo un\'etichetta DNS: lettere minuscole, numeri e trattini.',
  'fileViewer.cloudflareHostnamePreview': 'Anteprima dominio personalizzato: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Facoltativo: collega un dominio personalizzato. Lasciando vuoto verrà comunque creato un link pages.dev.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Dominio personalizzato',
  'fileViewer.optional': 'Facoltativo',
  'fileViewer.vercelPreviewOnly': 'Le distribuzioni sono in modalità Preview per ora.',
  'fileViewer.cloudflarePagesPreviewHint': 'Le distribuzioni Cloudflare Pages utilizzano Direct Upload.',
  'fileViewer.savingConfig': 'Salvataggio…',
  'fileViewer.deployConfigSaveFailed': 'Impossibile salvare le impostazioni Vercel.',
  'fileViewer.deployFailed': 'Distribuzione fallita. Controlla le impostazioni Vercel e riprova.',
  'fileViewer.deployProviderConfigSaveFailed': 'Impossibile salvare le impostazioni {provider}.',
  'fileViewer.deployProviderFailed': 'Distribuzione {provider} fallita. Controlla le impostazioni e riprova.',
  'fileViewer.deployResultLabel': 'URL distribuito',
  'fileViewer.deployLinkReady': 'Pronto',
  'fileViewer.deploySuccessToast': 'Distribuzione caricata correttamente',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Link pubblico in attesa',
  'fileViewer.deployLinkDelayed': 'Il sito è distribuito. Il provider sta ancora preparando il link pubblico.',
  'fileViewer.deployLinkFailed': 'Il dominio personalizzato è fallito',
  'fileViewer.deployLinkProtectedLabel': 'Protezione della distribuzione attivata',
  'fileViewer.deployLinkProtected': 'Il sito è distribuito, ma questo link di anteprima richiede autenticazione. Disattiva Deployment Protection o usa un dominio personalizzato.',
  'fileViewer.retryLink': 'Riprova ora',
  'questionForm.submit': 'Invia',
  'questionForm.skip': 'Salta',
  'questionForm.locked': 'Risposto',
  'conv.switch': 'Cambia conversazione',
  'conv.label': 'Conversazione',
  'conv.heading': 'Conversazioni',
  'conv.new': '+ Nuova',
  'conv.empty': 'Nessuna conversazione per ora.',
  'conv.untitled': 'Conversazione senza titolo',
  'conv.renameTooltip': 'Doppio clic per rinominare',
  'conv.delete': 'Elimina conversazione',
  'conv.deleteConfirm': 'Eliminare « {title} » ? Questo elimina i suoi messaggi.',
  'agentPicker.label': 'Agente',
  'agentPicker.modeChoose': 'Scegli modalità di esecuzione',
  'agentPicker.localCli': 'CLI locale',
  'agentPicker.daemonOff': 'daemon arrestato',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Seleziona un agente CLI rilevato',
  'agentPicker.noAgents': 'nessun agente nel PATH',
  'agentPicker.notInstalled': 'non installato',
  'agentPicker.rescan': 'Rianalizza il PATH locale per gli agenti',
  'tool.openInTab': 'Apri {name} in una scheda',
  'tool.open': 'apri',
  'tool.todos': 'Attività',
  'tool.todosExpand': 'Mostra attività',
  'tool.todosCollapse': 'Nascondi attività',
  'tool.todosDone': 'Fatto',
  'tool.todosDismiss': 'Chiudi l\'elenco delle attività',
  'tool.write': 'Scrivi',
  'tool.edit': 'Modifica',
  'tool.read': 'Leggi',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Recupera',
  'tool.search': 'Cerca',
  'tool.lines': '{n} righe',
  'tool.changeSingular': 'modifica',
  'tool.changePlural': 'modifiche',
  'tool.in': 'in {path}',
  'tool.hide': 'nascondi',
  'tool.output': 'output',
  'tool.running': 'in corso…',
  'tool.error': 'errore',
  'tool.done': 'completato',
  'assistant.role': 'Assistente',
  'assistant.workingLabel': 'In corso',
  'assistant.doneLabel': 'Completato',
  'assistant.copyMarkdown': 'Copia il Markdown della risposta',
  'assistant.forkConversation': 'Fork da qui',
  'assistant.forkingConversation': 'Creazione fork…',
  'assistant.shareToZalureAI': 'Condividi su ZalureAI',
  'assistant.shareToZalureAIBusy': 'Preparazione pacchetto…',
  'assistant.feedbackPrompt': 'Feedback',
  'assistant.feedbackPositive': 'Utile',
  'assistant.feedbackNegative': 'Non utile',
  'assistant.feedbackReasonTitle': 'Dicci perché',
  'assistant.feedbackReasonPositiveMatched': 'Ha compreso la mia richiesta',
  'assistant.feedbackReasonPositiveVisual': 'Sembra ottimo',
  'assistant.feedbackReasonPositiveUseful': 'Struttura utile',
  'assistant.feedbackReasonPositiveEasy': 'Facile da continuare a modificare',
  'assistant.feedbackReasonPositiveDesignSystem': 'Ha seguito il design system',
  'assistant.feedbackReasonNegativeMissed': 'Ha ignorato la mia richiesta',
  'assistant.feedbackReasonNegativeVisual': 'La qualità visiva va migliorata',
  'assistant.feedbackReasonNegativeIncomplete': 'Output incompleto',
  'assistant.feedbackReasonNegativeHard': 'Difficile da usare',
  'assistant.feedbackReasonNegativeDesignSystem': 'Non ha seguito il design system',
  'assistant.feedbackReasonOther': 'Altro',
  'assistant.feedbackReasonPlaceholder': 'Aggiungi una breve nota...',
  'assistant.feedbackReasonSubmit': 'Invia',
  'assistant.emptyResponseLabel': 'Nessun output',
  'assistant.emptyResponseMessage': 'Il provider ha terminato la richiesta senza restituire testo o un artefatto. Prova un altro modello o provider, controlla la quota o riprova.',
  'assistant.unfinishedLabel': 'Fermato con lavoro non completato',
  'assistant.unfinishedSummary': '{n} attività rimanenti',
  'assistant.unfinishedMore': '+{n} in più',
  'assistant.continueRemaining': 'Continua le attività rimanenti',
  'chat.resumeRunCta': 'Riprendi l’esecuzione',
  'assistant.outTokens': '{n} output',
  'assistant.producedFiles': 'File di questo turno',
  'assistant.openFile': 'Apri',
  'assistant.downloadFile': 'Scarica',
  'nextStep.title': 'Passo successivo',
  'nextStep.more': 'Altro',
  'nextStep.share': 'Condividi',
  'nextStep.download': 'Scarica',
  'nextStep.contribute': 'Contribuisci',
  'assistant.thinking': 'Riflessione',
  'assistant.thought': 'Ha riflettuto',
  'assistant.thoughtFor': 'Ha riflettuto per {s}s',
  'assistant.systemReminder': 'Promemoria di sistema',
  'assistant.possiblePromptInjection': 'Possibile iniezione di prompt',
  'assistant.waitingFirstOutput': 'In attesa del primo output',
  'assistant.statusBootingAgent': 'Avvio dell\'agente',
  'assistant.statusPreparing': 'Preparazione in corso...',
  'assistant.statusStarting': 'Avvio',
  'assistant.statusRequesting': 'Invio della richiesta',
  'assistant.statusThinking': 'Riflessione',
  'assistant.statusStreaming': 'Streaming',
  'assistant.slowHint': 'Più lungo del solito. Il modulo si visualizza generalmente in 5–10s — puoi Fermare e riformulare.',
  'assistant.verbEditing': 'Modifica',
  'assistant.verbWriting': 'Scrittura',
  'assistant.verbReading': 'Lettura',
  'assistant.verbSearching': 'Ricerca',
  'assistant.verbRunning': 'Esecuzione',
  'assistant.verbTodos': 'Attività',
  'assistant.verbFetching': 'Recupero',
  'assistant.verbCalling': 'Chiamata',
  'qf.answered': 'risposto',
  'qf.choose': 'Scegli…',
  'qf.required': 'richiesto',
  'qf.lockedSubmitted': 'Risposte inviate — l\'agente le usa per il resto della sessione.',
  'qf.lockedPrev': 'Questo modulo proviene da un turno precedente.',
  'qf.hint': 'Scegli ciò che conviene. Ignora i campi facoltativi che non ti interessano — l\'agente userà valori predefiniti ragionevoli.',
  'qf.submitDefault': 'Invia risposte',
  'qf.submitDisabledTitle': 'Compila prima i campi richiesti',
  'qf.submitTitle': 'Invia risposte',
  'qf.cardSelected': 'selezionato',
  'qf.cardRefs': 'Rif.:',
  'qf.cardSampleText': 'Portate questo vecchio whisky al giudice biondo che fuma · 0123',
  'questions.tabLabel': 'Domande',
  'questions.banner': 'Posso farti un paio di domande veloci?',
  'questions.bannerAnswered': 'Domande completate',
  'questions.continue': 'Continua',
  'questions.generating': 'Generazione domande…',
  'questions.skipAll': 'Salta tutto',
  'questions.autoSkipHint': 'Continua automaticamente allo scadere del timer',
  'sketch.toolSelect': 'Selezione (senza effetto)',
  'sketch.toolPen': 'Penna',
  'sketch.toolText': 'Testo',
  'sketch.toolRect': 'Rettangolo',
  'sketch.toolArrow': 'Freccia',
  'sketch.toolEraser': 'Gomma',
  'sketch.color': 'Colore',
  'sketch.strokeSize': 'Dimensione tratto',
  'sketch.undo': 'Annulla',
  'sketch.clear': 'Cancella',
  'sketch.close': 'Chiudi',
  'sketch.closeConfirm': 'Chiudere lo schizzo e abbandonare le modifiche non salvate?',
  'sketch.textPrompt': 'Testo:',
  'sketch.textModalTitle': 'Aggiungi testo',
  'critiqueTheater.userFacingName': 'Giuria di design',
  'critiqueTheater.roleDesigner': 'Designer',
  'critiqueTheater.roleCritic': 'Critico',
  'critiqueTheater.roleBrand': 'Brand',
  'critiqueTheater.roleA11y': 'Accessibilità',
  'critiqueTheater.roleCopy': 'Copia',
  'critiqueTheater.roundLabel': 'Round {n} di {m}',
  'critiqueTheater.mustFix': '{n} da correggere assolutamente',
  'critiqueTheater.composite': 'Composito',
  'critiqueTheater.threshold': 'Soglia',
  'critiqueTheater.consensus': 'Consenso',
  'critiqueTheater.interrupt': 'Interrompi',
  'critiqueTheater.interrupting': 'Interruzione…',
  'critiqueTheater.interrupted': 'Interrotto',
  'critiqueTheater.degradedHeading': 'Panel offline durante questa esecuzione',
  'critiqueTheater.degradedReasonMalformed': 'Output del panel malformato (il parser ha rifiutato il blocco).',
  'critiqueTheater.degradedReasonOversize': 'L\'output del panel ha superato il limite di byte sicuro.',
  'critiqueTheater.degradedReasonAdapter': 'L\'adapter {adapter} non supportava il protocollo Critique.',
  'critiqueTheater.degradedReasonProtocol': 'L\'adapter {adapter} ha inviato una versione del protocollo non supportata.',
  'critiqueTheater.degradedReasonMissingArtifact': 'Esecuzione terminata senza un artifact finale.',
  'critiqueTheater.replay': 'Riproduci di nuovo',
  'critiqueTheater.replaySpeed': 'Velocità di riproduzione',
  'critiqueTheater.readOnly': 'Sola lettura',
  'critiqueTheater.shippedSummary': 'Consegnato al round {round} · composito {composite}',
  'critiqueTheater.interruptedSummary': 'Interrotto al round {round} · miglior composito {composite}',
  'critiqueTheater.shippedBadge': 'Pubblicato',
  'critiqueTheater.belowThresholdBadge': 'Sotto la soglia',
  'critiqueTheater.timedOutBadge': 'Tempo scaduto',
  'critiqueTheater.failedHeading': 'Esecuzione non riuscita',
  'critiqueTheater.failedReasonCliExit': 'La CLI dell\'Agent è terminata con codice diverso da zero prima che il panel potesse completare.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Un round ha superato il proprio budget di tempo.',
  'critiqueTheater.failedReasonTotalTimeout': 'L\'esecuzione completa ha superato il budget di tempo totale.',
  'critiqueTheater.failedReasonOrchestrator': 'Errore interno dell\'orchestratore.',
  'critiqueTheater.transcriptEmpty': 'Nessuna trascrizione da riprodurre per ora. Esegui una critica per registrarne una.',
  'critiqueTheater.transcriptLoading': 'Caricamento trascrizione…',
  'critiqueTheater.transcriptError': 'Impossibile caricare la trascrizione: {error}',
  'critiqueTheater.replaySpeedPaused': 'In pausa',
  'critiqueTheater.replaySpeedInstant': 'Istantaneo',
  'critiqueTheater.replaySpeedLive': 'In diretta',
  'critiqueTheater.replaySpeedFast': 'Veloce',
  'critiqueTheater.settingsNav': 'Giuria di design',
  'critiqueTheater.settingsNavHint': 'Revisione del design a cinque panel per le tue esecuzioni',
  'critiqueTheater.settingsEnabledLabel': 'Mostra Design Jury durante le esecuzioni dell\'Agent',
  'critiqueTheater.settingsEnabledDescription': 'Se attivata, una revisione a cinque panel compare insieme alle generazioni dell\'Agent e valuta l\'output prima della pubblicazione. Puoi interrompere in qualsiasi momento.',
  'critiqueTheater.settingsEnabledProjectHint': 'Salvato per questo progetto. Le nuove esecuzioni in questo progetto verranno instradate tramite Design Jury lato server.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Apri un progetto per renderlo persistente lato server. Fino ad allora, questo modifica solo la preferenza nel browser.',
  'pet.title': 'Compagni',
  'pet.subtitle': 'Adotta un piccolo compagno che fluttua sopra il tuo spazio di lavoro.',
  'pet.navTitle': 'Compagni',
  'pet.navHint': 'Adotta o personalizza',
  'pet.tabBuiltIn': 'Integrati',
  'pet.tabBuiltInHint': 'Compagni forniti con ZalureAI — scegline uno e adottalo.',
  'pet.builtInEmpty': 'I compagni integrati non sono disponibili per ora. Prova ad aggiornare la scheda Comunità una volta che il daemon è online.',
  'pet.tabCustom': 'Personalizzato',
  'pet.tabCustomHint': 'Crea il tuo con un nome, un glifo, un colore o uno sprite.',
  'pet.tabCommunity': 'Comunità',
  'pet.tabCommunityHint': 'Compagni nati da Codex — adottane uno o generane uno nuovo.',
  'pet.tabsAria': 'Fonte del compagno',
  'pet.adopt': 'Adotta',
  'pet.adoptedBadge': 'Adottato',
  'pet.adoptCallout': 'Adotta un compagno',
  'pet.changePet': 'Cambia compagno',
  'pet.wake': 'Sveglia',
  'pet.tuck': 'Nascondi',
  'pet.wakeTitle': 'Sveglia il compagno — mostra l\'overlay fluttuante.',
  'pet.tuckTitle': 'Nascondi il compagno — nascondi l\'overlay fluttuante.',
  'pet.settingsTitle': 'Apri impostazioni del compagno',
  'pet.useCustom': 'Usa il mio compagno',
  'pet.customTitle': 'Crea il tuo',
  'pet.customHint': 'Scegli un nome, un glifo e un colore d\'accento — l\'overlay si aggiorna in tempo reale.',
  'pet.customGreetingPlaceholder': 'Fai dire ciao al tuo compagno…',
  'pet.fieldName': 'Nome',
  'pet.fieldGlyph': 'Glifo',
  'pet.fieldGlyphHint': 'Un singolo emoji funziona meglio (es. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Saluto',
  'pet.fieldAccent': 'Colore d\'accento',
  'pet.fieldAccentCustom': 'Colore personalizzato',
  'pet.fieldAccentDefault': 'Colore d\'accento predefinito',
  'pet.overlayAria': 'Compagno',
  'pet.spriteAria': '{name} — trascina per spostare, clicca per chattare',
  'pet.spriteTitle': 'Ciao da {name}! Clicca per chattare.',
  'pet.taskSummarySingle': '{count} attività dell\'Agent in esecuzione.',
  'pet.taskSummaryMultiple': '{count} attività dell\'Agent in esecuzione su {projects} progetti.',
  'pet.taskSummaryRecentSingle': '{count} attività dell\'Agent completata di recente.',
  'pet.taskSummaryRecentMultiple': '{count} attività dell\'Agent completate di recente.',
  'pet.taskListAria': 'Attività dell\'Agent attive',
  'pet.taskOpenProject': 'Apri {project}',
  'pet.taskGroup.running': 'In esecuzione',
  'pet.taskGroup.queued': 'In attesa',
  'pet.taskGroup.recent': 'Completate di recente',
  'pet.idleQuote.leonardo.text': 'L\'apprendimento non sfianca mai la mente.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Ho visto l\'angelo nel marmo e ho scolpito finché non l\'ho liberato.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Esistono due strumenti che possono aiutare lo scultore: la luce e l\'ombra.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Quando si dipinge, non si pensa.',
  'pet.idleQuote.raphael.author': 'Raffaello',
  'pet.idleQuote.caravaggio.text': 'Tutte le opere, qualunque cosa siano o da chiunque siano dipinte, non sono altro che bagattelle e sciocchezze infantili se non sono realizzate e dipinte dal vero.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'La cosa principale è emozionarsi, amare, sperare, tremare, vivere.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Compagni — sveglia, nascondi o scegli',
  'pet.composerMenuTitle': 'Compagni',
  'pet.composerMenuHint': 'suggerimento: digita /pet per alternare',
  'pet.composerOpenSettings': 'Gestisci animali',
  'pet.welcomeTeaserTitle': 'Adotta un compagno',
  'pet.welcomeTeaserBody': 'Un piccolo compagno fluttuante che sta con te.',
  'pet.welcomeTeaserCta': 'Scegline uno',
  'pet.imageUpload': 'Carica uno sprite',
  'pet.imageReplace': 'Sostituisci sprite',
  'pet.imageRemove': 'Usa un emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF o SVG. Caricamento di foglio? Trascina una striscia orizzontale e definisci il numero di frame.',
  'pet.imageHintActive': 'Visualizzazione del tuo sprite. Definisci frame > 1 per scorrere un foglio di sprite orizzontale.',
  'pet.fieldFrames': 'Frame',
  'pet.fieldFramesHint': '1 = statico. > 1 = foglio di sprite orizzontale.',
  'pet.fieldFps': 'Velocità (fps)',
  'pet.fieldFpsHint': 'A che velocità scorrono i frame.',
  'pet.atlasImport': 'Importa uno sprite Codex',
  'pet.atlasImportTitle': 'Importa un atlante di pet 8×9 / 192×208 (PNG o WebP).',
  'pet.atlasPickerTitle': 'Scegli una riga di animazione',
  'pet.atlasPickerHint': 'I pet Codex sono forniti con 9 righe di animazione. Per impostazione predefinita, manteniamo l\'atlante completo affinché il pet cambi riga al passaggio del mouse, al trascinamento e all\'inattività. Puoi anche bloccarlo su un singolo ciclo.',
  'pet.atlasCancel': 'Abbandona atlante',
  'pet.atlasAdopt': 'Blocca su questa riga',
  'pet.atlasAdoptFull': 'Usa atlante completo (animato)',
  'pet.atlasAdoptFullTitle': 'Mantieni ogni riga affinché il pet reagisca al passaggio del mouse, alla direzione del trascinamento e alle lunghe inattività.',
  'pet.atlasAdoptRowTitle': 'Ritaglia solo la riga selezionata in una singola striscia in ciclo.',
  'pet.atlasActiveHint': 'Atlante animato attivo — il pet sceglie una riga in base alla tua interazione (passaggio del mouse, trascinamento, inattività).',
  'pet.atlasRow.idle': 'Inattivo',
  'pet.atlasRow.running-right': 'Corre a destra',
  'pet.atlasRow.running-left': 'Corre a sinistra',
  'pet.atlasRow.waving': 'Saluto',
  'pet.atlasRow.jumping': 'Salto',
  'pet.atlasRow.failed': 'Fallito',
  'pet.atlasRow.waiting': 'Attesa',
  'pet.atlasRow.running': 'Corsa',
  'pet.atlasRow.review': 'Revisione',
  'pet.hatchTitle': 'Fai nascere un nuovo compagno con l\'IA',
  'pet.hatchHint': 'Usa la competenza hatch-pet integrata nella chat per generare un foglio di sprite in stile Codex, poi importalo qui.',
  'pet.hatchConcept': 'Concetto del compagno (facoltativo)',
  'pet.hatchConceptPlaceholder': 'es. un piccolo shiba pixel art in un maglione accogliente',
  'pet.hatchCopy': 'Copia prompt',
  'pet.hatchCopied': 'Copiato!',
  'pet.hatchFoot': 'Una volta che la competenza ha salvato il tuo compagno, torna e scegli "Importa uno sprite Codex".',
  'pet.slashPopoverAria': 'Comandi slash',
  'pet.slashPopoverTitle': 'Comandi',
  'pet.slashPopoverHint': '↑↓ naviga · invio per scegliere · esc per chiudere',
  'pet.slashPet': 'Alterna, adotta o vai alle impostazioni del compagno.',
  'pet.slashPetWake': 'Sveglia l\'overlay fluttuante del compagno.',
  'pet.slashPetTuck': 'Nascondi il compagno per ora.',
  'pet.slashHatch': 'Genera un pet Codex tramite la competenza hatch-pet.',
  'pet.slashHatchArg': '<concetto>',
  'pet.slashSearch': 'Cerca sul web tramite il comando OD research.',
  'pet.slashSearchArg': '<query>',
  'pet.codexTitle': 'Nati di recente',
  'pet.codexSubtitle': 'I pet impacchettati dalla competenza hatch-pet appaiono qui per un\'adozione con un clic.',
  'pet.codexSubtitleWithDir': 'Analisi di {dir} per i pet impacchettati dalla competenza hatch-pet.',
  'pet.codexEmpty': 'Nessun pet nato per ora. Digita /hatch nella chat per generarne uno.',
  'pet.codexLoading': 'Ricerca di pet nati…',
  'pet.codexRefresh': 'Aggiorna',
  'pet.codexAdopt': 'Adotta',
  'pet.codexAdopting': 'Adozione…',
  'pet.communitySync': 'Scarica i pet della comunità',
  'pet.communitySyncing': 'Download…',
  'pet.communitySyncTitle': 'Sincronizza gli ultimi pet da Codex Pet Share + j20 Hatchery in ~/.codex/pets/.',
  'pet.communitySyncDone': '{wrote} nuovi pet sincronizzati ({total} in totale).',
  'pet.communitySyncFailed': 'Sincronizzazione fallita: {error}',
  'pet.codexBundled': 'Fornito',
  'pet.codexBundledTitle': 'Fornito con ZalureAI — nessun download necessario.',
  'settings.notifications': 'Notifiche',
  'settings.notificationsHint': 'Suono e notifica desktop alla fine di un\'attività',
  'settings.notifyCompletionSound': 'Suono di fine',
  'settings.notifyCompletionSoundHint': 'Riprodotto quando un turno termina. Disabilitato per impostazione predefinita.',
  'settings.notifySuccessSound': 'Suono di successo',
  'settings.notifyFailureSound': 'Suono di fallimento',
  'settings.notifyDesktop': 'Notifica desktop',
  'settings.notifyDesktopHint': 'Inviata quando la finestra non è attiva.',
  'settings.notifyDesktopBlocked': 'Notifiche bloccate dal browser. Autorizzale nelle impostazioni del sito.',
  'settings.notifyDesktopUnsupported': 'Notifiche desktop non disponibili in questo ambiente.',
  'settings.notifyTest': 'Invia un test',
  'settings.notifyTestSent': 'Notifica di test inviata. Se non appare alcun banner, controlla le impostazioni di notifica del browser e del sistema.',
  'settings.notifyTestFailed': 'La chiamata di notifica è fallita. Controlla le impostazioni di notifica del browser e del sistema.',
  'settings.notifySoundDing': 'Ding',
  'settings.notifySoundChime': 'Campanello',
  'settings.notifySoundTwoToneUp': 'Bitonale ascendente',
  'settings.notifySoundPluck': 'Pizzicato',
  'settings.notifySoundBuzz': 'Buzz',
  'settings.notifySoundTwoToneDown': 'Bitonale discendente',
  'settings.notifySoundThud': 'Tonfo',
  'settings.skills': 'Competenze',
  'settings.skillsHint': 'Competenze che l\'agente può invocare durante l\'attività',
  'settings.skillsNew': 'Nuova competenza',
  'settings.skillsEmpty': 'Seleziona una competenza a sinistra, o creane una.',
  'settings.skillsEdit': 'Modifica',
  'settings.skillsDelete': 'Elimina',
  'settings.skillsDeleteConfirm': 'Conferma eliminazione',
  'settings.skillsName': 'Nome',
  'settings.skillsTriggers': 'Trigger (separati da virgole o ritorni a capo)',
  'settings.skillsDescription': 'Descrizione',
  'settings.skillsBody': 'Corpo SKILL.md',
  'settings.skillsCreate': 'Crea',
  'settings.skillsSave': 'Salva',
  'settings.skillsSaving': 'Salvataggio…',
  'settings.skillsFiles': 'File',
  'settings.skillsNoFiles': 'Nessun file in questa cartella di competenza.',
  'settings.skillsNameRequired': 'Il nome dello skill è obbligatorio.',
  'settings.skillsBodyRequired': 'Il corpo dello skill è obbligatorio.',
  'settings.designSystems': 'Design system',
  'settings.designSystemsHint': 'Sfoglia e attiva i design system disponibili',
  'settings.designSystemsInstalled': 'Installati',
  'settings.designSystemsAdd': 'Aggiungi design system',
  'settings.designSystemsHiddenCount': '{count} nascosti dalla galleria iniziale',
  'settings.designSystemsShowAll': 'Mostra tutti',
  'settings.designSystemsShowHidden': 'Mostra nascosti',
  'settings.designSystemsSource': 'Origine',
  'settings.designSystemsSourceLocal': 'Locale',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Riferimento del registro shadcn',
  'settings.designSystemsImportShadcn': 'Importa da shadcn',
  'settings.designSystemsStructure': 'Struttura',
  'settings.designSystemsModeHybrid': 'Ibrido',
  'settings.designSystemsModeNormalized': 'Normalizzato',
  'settings.designSystemsModeVerbatim': 'Invariato',
  'settings.designSystemsCraft': 'Realizzazione',
  'settings.designSystemsCraftColor': 'Colore',
  'settings.designSystemsCraftAccessibility': 'Accessibilità',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'Percorso progetto',
  'settings.designSystemsImportGithub': 'Importa da GitHub',
  'settings.designSystemsImportProject': 'Importa dal progetto',
  'settings.designSystemsImportedStatus': '{title} importato',
  'settings.designSystemsViewImported': 'Vedi design system importato',
  'settings.designSystemsCategory': 'Categoria',
  'settings.designSystemsAllCategories': 'Tutte le categorie',
  'settings.designSystemsShowInHomeGallery': 'Mostra nella galleria iniziale',
  'settings.projectLocations': 'Posizioni dei progetti',
  'settings.projectLocationsHint': 'Radici di archiviazione workspace',
  'settings.projectLocationsDescription': 'Aggiungi basi di lavoro che possono contenere più cartelle di progetti ZalureAI. I nuovi progetti vengono salvati come una cartella nella base selezionata.',
  'settings.projectLocationsSaveError': 'Impossibile salvare le posizioni dei progetti. Verifica che ogni percorso sia una cartella accessibile.',
  'settings.projectLocationsSaved': 'Posizioni dei progetti salvate.',
  'settings.projectLocationsScanError': 'Impossibile scansionare le posizioni dei progetti.',
  'settings.projectLocationsScanComplete': 'Scansione completata: {imported} importati, {existing} già registrati.',
  'settings.projectLocationsNoFolderSelected': 'Nessuna cartella selezionata.',
  'settings.projectLocationsDuplicate': 'Questa base di lavoro è già stata aggiunta.',
  'settings.projectLocationsWorkBaseMeta': 'Base di lavoro · i progetti vengono creati qui come sottocartelle',
  'settings.projectLocationsAddFolder': 'Aggiungi cartella…',
  'settings.projectLocationsDefaultBadge': 'Posizione predefinita',
  'settings.projectLocationsMakeDefault': 'Imposta come predefinita',
  'settings.projectLocationsDefaultSaved': 'Posizione progetto predefinita aggiornata.',
  'settings.librarySkills': 'Competenze',
  'settings.libraryDesignSystems': 'Sistemi di design',
  'settings.librarySearch': 'Cerca...',
  'settings.libraryAll': 'Tutto',
  'settings.libraryPreview': 'Anteprima',
  'settings.libraryPreviewClose': 'Chiudi',
  'settings.libraryLoading': 'Caricamento...',
  'settings.libraryNoResults': 'Nessun elemento corrisponde alla tua ricerca.',
  'settings.libraryEnabled': 'Abilitato',
  'settings.libraryDisabled': 'Disabilitato',
  'settings.connectorsNavHint': 'Connessioni ai sistemi esterni',
  'settings.connectorsHint': 'Gestisci le impostazioni dei connettori e dei provider di strumenti per questo dispositivo.',
  'settings.connectorsComposioApiKey': 'Chiave API Composio',
  'settings.connectorsSavedTitle': 'Salvata nel daemon locale',
  'settings.connectorsSavedWithTail': 'Salvata · ••••{tail}',
  'settings.connectorsSaved': 'Salvata',
  'settings.connectorsGetApiKey': 'Ottieni una chiave API',
  'settings.connectorsReplaceKeyPlaceholder': 'Incolla una nuova chiave per sostituire quella salvata',
  'settings.connectorsApiKeyPlaceholder': 'Incolla la chiave API Composio',
  'settings.connectorsClear': 'Cancella',
  'settings.connectorsClearConfirmTitle': 'Cancellare la chiave API Composio salvata?',
  'settings.connectorsClearConfirmBody': 'Rimuovere la chiave disconnette tutti i connettori Composio collegati a questo spazio. Gli account connessi, le autorizzazioni OAuth e gli accessi agli strumenti verranno tutti rimossi.',
  'settings.connectorsClearConfirmContinue': 'Continua',
  'settings.connectorsClearFinalTitle': 'Questa azione disconnetterà tutti i connettori',
  'settings.connectorsClearFinalBody': 'Azione irreversibile. Dovrai riconnettere ogni integrazione dall\'inizio dopo aver incollato una nuova chiave.',
  'settings.connectorsClearFinalConfirm': 'Rimuovi chiave e disconnetti',
  'settings.connectorsClearArming': 'Un momento…',
  'settings.connectorsClearCancel': 'Annulla',
  'settings.connectorsSaveKey': 'Salva chiave',
  'settings.connectorsSaveKeyTitle': 'Invia questa chiave al daemon locale',
  'settings.connectorsKeySaving': 'Salvataggio…',
  'settings.connectorsKeySaved': 'Salvato ✓',
  'settings.connectorsKeyError': 'Impossibile salvare la chiave. Verifica che il daemon locale sia avviato poi riprova.',
  'settings.connectorsHelpSaved': 'La tua chiave sblocca il catalogo qui sotto e rimane nel daemon locale. Incolla una nuova chiave per sostituirla o cancellala.',
  'settings.connectorsHelpUnsaved': 'Modifiche non salvate — clicca su Salva chiave per memorizzare questa informazione nel daemon locale e sbloccare il catalogo qui sotto.',
  'settings.connectorsHelpEmpty': 'Aggiungi una chiave per sbloccare il catalogo qui sotto. Le chiavi sono memorizzate localmente nel daemon e non vengono mai inviate tramite variabili d\'ambiente.',
  'settings.connectorsLoadingSavedKey': 'Ricerca di una chiave salvata nel daemon locale…',
  'settings.autosaveSaving': 'Salvataggio…',
  'settings.autosaveSaved': 'Tutte le modifiche salvate',
  'settings.autosaveError': 'Impossibile salvare le modifiche. Il daemon locale potrebbe essere offline.',
  'settings.libraryToggleLabel': 'Alterna',
  'settings.memory': 'Memoria',
  'settings.memoryHint': 'Fatti personali estratti automaticamente dalle conversazioni',
  'settings.customInstructionsTitle': 'Regole globali',
  'settings.customInstructionsHint': 'Istruzioni fisse che ZalureAI deve seguire in ogni chat. Salva fatti, preferenze e contesto del progetto come memorie.',
  'settings.customInstructionsPlaceholder': 'es. "Usa sempre TypeScript. Preferisci i componenti funzionali. Mantieni le risposte concise."',
  'settings.memoryDescription': 'Fatti sulle tue preferenze estratti automaticamente, salvati in Markdown e reinseriti in ogni chat.',
  'settings.memoryEnabled': 'Abilitata',
  'settings.memoryDisabled': 'Disabilitata',
  'settings.memoryEnableLabel': 'Abilita iniezione di memoria',
  'settings.memoryDisabledBanner': 'La memoria è attualmente disabilitata. I fatti esistenti rimangono su disco ma non verranno iniettati nelle nuove chat.',
  'settings.memoryNew': 'Nuova memoria',
  'settings.memoryEdit': 'Modifica',
  'settings.memoryDelete': 'Elimina',
  'settings.memoryPreview': 'Anteprima',
  'settings.memoryEmpty': 'Nessuna memoria per ora.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Preferisco la modalità scura',
  'settings.memoryName': 'Nome',
  'settings.memoryDesc': 'Descrizione in una riga',
  'settings.memoryBody': 'Corpo (Markdown supportato)',
  'settings.memoryBodyHint': 'Enuncia la regola, poi aggiungi Why e How to apply.',
  'settings.memoryStartersLabel': 'Hai bisogno di un punto di partenza? Clicca per compilare il modulo:',
  'settings.memoryStarterUserName': 'Il mio ruolo',
  'settings.memoryStarterUserDesc': 'Sono un ingegnere frontend che lavora su uno strumento di design SaaS',
  'settings.memoryStarterUserBody': '- Ruolo: ingegnere frontend senior\n- Stack: React, TypeScript, Vite\n- Dominio: strumenti di design / collaborazione\n- Fuso orario: GMT+8 (Asia/Shanghai)\n\nQuando applicare: qualsiasi chat — inquadra gli esempi attorno al frontend web.',
  'settings.memoryStarterFeedbackName': 'Preferenze UI',
  'settings.memoryStarterFeedbackDesc': 'Modalità scura, testo del corpo grande, bassa densità di informazioni',
  'settings.memoryStarterFeedbackBody': '- Tema: scuro per impostazione predefinita\n- Testo del corpo: ≥ 18px\n- Densità di informazioni: preferisci spazi bianchi, meno elementi per schermo\n\nPerché: meno affaticamento degli occhi durante lunghe sessioni.\nQuando applicare: ogni volta che generi UI, pagine web o diapositive.',
  'settings.memoryStarterProjectName': 'Progetto attuale',
  'settings.memoryStarterProjectDesc': 'ZalureAI v0.5 — editor di design guidato da chat',
  'settings.memoryStarterProjectBody': '- Obiettivo: spedire l\'editor guidato da chat questo trimestre\n- Priorità: rendering in streaming, multimodale locale, offline-first\n- Stack: Next.js 16, daemon Express, SQLite\n\nQuando applicare: in qualsiasi conversazione su questo progetto.',
  'settings.memorySaveHint': 'Non salvato automaticamente — clicca su Crea / Salva per applicare.',
  'settings.memoryIndexSaveHint': 'Le modifiche all\'indice non vengono salvate automaticamente — clicca su Salva indice per applicare.',
  'settings.memoryIndexUnsaved': 'Modifiche non salvate',
  'settings.memoryFlashCreated': '✓ Memoria creata',
  'settings.memoryFlashSaved': '✓ Memoria salvata',
  'settings.memoryFlashDeleted': '✓ Memoria eliminata',
  'settings.memoryFlashIndexSaved': '✓ Indice salvato',
  'settings.memoryFlashPathCopied': '✓ Percorso copiato',
  'settings.memoryNameLabel': 'Titolo',
  'settings.memoryTypeLabel': 'Tipo',
  'settings.memoryDescLabel': 'Descrizione',
  'settings.memoryBodyLabel': 'Contenuto',
  'settings.memoryTypeUser': 'Utente',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Progetto',
  'settings.memoryTypeReference': 'Riferimento',
  'settings.memoryIndex': 'MEMORY.md (indice)',
  'settings.memoryIndexSave': 'Salva indice',
  'settings.memoryIndexReset': 'Reimposta',
  'settings.memoryToastChanged': 'Memoria aggiornata',
  'settings.memoryToastClickHint': 'Mostra',
  'settings.memoryAll': 'Tutto',
  'settings.memoryExtractions': 'Cronologia estrazione',
  'settings.memoryExtractionsHint': 'Tentativi di estrazione recenti supportati da LLM. L\'estrazione euristica regex viene sempre eseguita per prima; l\'estrazione LLM viene eseguita in background dopo ogni turno.',
  'settings.memoryExtractionsEmpty': 'Nessuna estrazione ancora. Il prossimo turno di chat popolerà questo elenco.',
  'settings.memoryExtractionsRefresh': 'Aggiorna',
  'settings.memoryExtractionsRefreshing': 'Aggiornamento…',
  'settings.memoryExtractionPhaseRunning': 'In esecuzione…',
  'settings.memoryExtractionPhaseSuccess': 'Successo',
  'settings.memoryExtractionPhaseSkipped': 'Saltato',
  'settings.memoryExtractionPhaseFailed': 'Fallito',
  'settings.memoryExtractionSkipNoProvider': 'Nessuna chiave API configurata per l\'estrazione di memoria LLM.',
  'settings.memoryExtractionSkipDisabled': 'La memoria è disabilitata.',
  'settings.memoryExtractionSkipEmpty': 'Messaggio utente vuoto — niente da estrarre.',
  'settings.memoryExtractionSkipNoMatch': 'Nessun pattern regex corrisponde a questo turno.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'impostazioni media',
  'settings.memoryExtractionProviderOverride': 'impostazioni memoria',
  'settings.memoryExtractionProposed': 'proposto',
  'settings.memoryExtractionWritten': 'scritto',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Elimina',
  'settings.memoryExtractionsClear': 'Cancella',
  'settings.memoryExtractionsClearTitle': 'Cancella tutta la cronologia di estrazione',
  'settings.memoryExtractionsClearConfirm': 'Cancellare tutta la cronologia di estrazione? Questa azione non può essere annullata.',
  'settings.memoryNoProviderBannerTitle': 'L\'estrazione di memoria LLM non è in esecuzione',
  'settings.memoryNoProviderBannerBody': 'Nessuna chiave API trovata per l\'estrattore di memoria. Aggiungi una chiave OpenAI sotto Provider di media, o imposta ANTHROPIC_API_KEY / OPENAI_API_KEY nell\'ambiente, per abilitare l\'estrazione guidata da LLM. L\'estrazione euristica regex è ancora attiva.',
  'settings.libraryInstall': 'Installa',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Percorso locale',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/percorso/alla/cartella-skill',
  'settings.libraryInstallButton': 'Installa',
  'settings.libraryUninstall': 'Disinstalla',
  'settings.libraryBuiltIn': 'Integrato',
  'settings.libraryInstalled': 'Installato',
  'notify.successTitle': 'Attività completata',
  'notify.failureTitle': 'Attività fallita',
  'notify.successBody': 'Un turno è completato.',
  'notify.failureBody': 'L\'attività si è conclusa con un errore.',
  'updater.available': 'Aggiornamento disponibile',
  'updater.availableBody': 'ZalureAI {version} è disponibile. Verrà scaricato prima di aprire il programma di installazione.',
  'updater.checking': 'Controllo aggiornamenti',
  'updater.download': 'Scarica aggiornamento',
  'updater.downloading': 'Download aggiornamento',
  'updater.downloadingPercent': 'Download aggiornamento {percent}%',
  'updater.done': 'Fatto',
  'updater.failed': 'Aggiornamento non riuscito',
  'updater.installerOpenBody': 'Il programma di installazione è aperto. ZalureAI si sta chiudendo per consentirti di completare l’aggiornamento.',
  'updater.installerOpened': 'Programma di installazione aperto',
  'updater.later': 'Più tardi',
  'updater.openFailedFallback': 'Impossibile aprire il programma di installazione.',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Installa aggiornamento',
  'updater.opening': 'Apertura del programma di installazione...',
  'updater.payloadReadyGeneric': 'A new ZalureAI update is ready. ZalureAI will close and restart automatically.',
  'updater.payloadReadyVersion': 'ZalureAI {version} is ready. ZalureAI will close and restart automatically.',
  'updater.quitButton': 'Esci da ZalureAI',
  'updater.quitFailedBody': 'Il programma di installazione è aperto, ma ZalureAI non è riuscito a uscire. Esci da ZalureAI prima di sostituire l’app.',
  'updater.quitFailedTitle': 'Impossibile uscire',
  'updater.quitting': 'Uscita...',
  'updater.ready': 'Aggiornamento pronto',
  'updater.readyGeneric': 'È pronta una nuova versione. ZalureAI si chiuderà e aprirà il programma di installazione.',
  'updater.readyVersion': 'ZalureAI {version} è pronto. ZalureAI si chiuderà e aprirà il programma di installazione.',
  'updater.upToDate': 'Hai già la versione più recente.',
  'newsletter.label': 'Newsletter (opzionale)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Modello di memoria',
  'settings.memoryModelInlineSameAsChat': 'Stesso della chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Stesso della chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Stesso della chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Facoltativo. L\'estrattore di memoria usa una chiave API env-var o media-providers su questo provider; fissare un modello qui sovrascrive solo la scelta automatica.',
  'settings.memoryModelInlineHintCliConstrained': 'Facoltativo. La memoria chiamerà {provider}; necessita di una chiave API env-var o media-providers per quel provider, o scegli un modello sotto per sovrascrivere.',
  'settings.memoryModelInlineHintByok': 'Facoltativo. Riutilizza la tua chiave API di chat sullo stesso provider — scegliere un modello diverso (di solito più economico) cambia solo il corpo della richiesta.',
  'settings.memoryModelInlineFlashSaved': 'Salvato',
  'settings.memoryModelInlineFlashCleared': 'Cancellato',
  'settings.orbit.eyebrow': 'Automazione',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Riepilogo giornaliero dei connettori',
  'settings.orbit.lede': 'Raccoglie l\'attività dei connettori secondo una pianificazione e pubblica il risultato come artefatto live aggiornabile.',
  'settings.orbit.statusOnTitle': 'Le esecuzioni giornaliere pianificate sono attive',
  'settings.orbit.statusOffTitle': 'Le esecuzioni giornaliere pianificate sono disattivate',
  'settings.orbit.statusActive': 'Attivo',
  'settings.orbit.statusOff': 'Disattivato',
  'settings.orbit.runTitle': 'Avvia un\'esecuzione Orbit e apri la conversazione live',
  'settings.orbit.running': 'Esecuzione in corso…',
  'settings.orbit.runOpen': 'Esegui ora',
  'settings.orbit.dailySummaryTitle': 'Riepilogo giornaliero',
  'settings.orbit.dailySummarySub': 'Viene eseguito una volta al giorno all\'ora locale pianificata.',
  'settings.orbit.on': 'Attivo',
  'settings.orbit.off': 'Disattivato',
  'settings.orbit.runTimeTitle': 'Ora di esecuzione',
  'settings.orbit.runTimeSub': 'Predefinito 08:00. Salva per applicare alla pianificazione del daemon.',
  'settings.orbit.runTimeAria': 'Ora di esecuzione giornaliera di Orbit',
  'settings.orbit.nextRun': 'Prossima esecuzione',
  'settings.orbit.nextRunScheduledAfterSave': 'Pianificata dopo il salvataggio',
  'settings.orbit.schedule': 'Pianificazione',
  'settings.orbit.pausedManualOnly': 'In pausa — solo esecuzioni manuali',
  'settings.orbit.templateTitle': 'Modello di prompt',
  'settings.orbit.templateMissing': 'Il modello {id} non è installato.',
  'settings.orbit.templateMissingOption': '{id} (mancante)',
  'settings.orbit.templateMissingInstall': 'Installa una skill Orbit per guidare il prompt.',
  'settings.orbit.templateMissingPickAnother': 'Scegli un altro modello dall\'elenco.',
  'settings.orbit.templateResetTitle': 'Ripristina su {id}',
  'settings.orbit.templateReset': 'Ripristina',
  'settings.orbit.templateHelp': 'Guida Orbit con una skill — il prompt di esempio del modello selezionato viene iniettato in ogni esecuzione Orbit affinché i riepiloghi seguano questa forma.',
  'settings.orbit.templateAria': 'Modello di prompt Orbit',
  'settings.orbit.templatesLoading': 'Caricamento modelli…',
  'settings.orbit.templatesOptgroup': 'Modelli di skill Orbit',
  'settings.orbit.lastRun': 'Ultima esecuzione',
  'settings.orbit.triggerManual': 'Manuale',
  'settings.orbit.triggerScheduled': 'Pianificata',
  'settings.orbit.meterAria': '{succeeded} riusciti, {skipped} saltati, {failed} falliti su {checked} verificati',
  'settings.orbit.countChecked': 'Verificati',
  'settings.orbit.countSucceeded': 'Riusciti',
  'settings.orbit.countSkipped': 'Saltati',
  'settings.orbit.countFailed': 'Falliti',
  'settings.orbit.runError': 'Impossibile eseguire Orbit. Verifica che il daemon locale sia in esecuzione e che i connettori siano configurati.',
  'settings.orbit.gateAriaLabel': 'Sono richiesti connettori per utilizzare Orbit',
  'settings.orbit.gateEyebrow': 'Configurazione richiesta',
  'settings.orbit.gateTitle': 'Connetti uno strumento per alimentare Orbit',
  'settings.orbit.gateBody': 'Orbit riepiloga l\'attività dei tuoi connettori. Non hai ancora connesso nulla — aggiungi almeno un\'integrazione affinché Orbit abbia qualcosa da riportare.',
  'settings.orbit.gateBodyNoKey': 'Orbit riepiloga l\'attività dei tuoi connettori, e i connettori passano attraverso Composio. Aggiungi una chiave API Composio in Connettori per sbloccare il catalogo e scegliere la tua prima integrazione.',
  'settings.orbit.gateAction': 'Apri Connettori',
  'settings.orbit.gateActionNoKey': 'Configura Composio',
  'settings.orbit.gateLoading': 'Verifica dei tuoi connettori…',
  'settings.orbit.controlsLockedBadge': 'Bloccato',
  'settings.orbit.controlsLockedHint': 'Connetti uno strumento per sbloccare la pianificazione e il modello di Orbit.',
  'settings.orbit.artifactKickerLive': 'artefatto live',
  'settings.orbit.artifactKickerLegacy': 'Riepilogo legacy',
  'settings.orbit.artifactTitle': 'Riepilogo giornaliero dell\'attività Orbit',
  'settings.orbit.artifactMetaLive': 'Artefatto HTML aggiornabile generato dall\'attività dei connettori.',
  'settings.orbit.artifactMetaLegacy': 'Generato prima dell\'attivazione del supporto per artefatti live — riesegui Orbit per pubblicarne uno.',
  'settings.orbit.copyMarkdownTitle': 'Copia il riepilogo Markdown negli appunti',
  'settings.orbit.copied': 'Copiato',
  'settings.orbit.copy': 'Copia',
  'settings.orbit.openArtifact': 'Apri artefatto',
  'settings.orbit.sourceMarkdown': 'Markdown sorgente',
  'settings.memoryModelInlineHintByokNeutral': 'La memoria usa un modello separato da quello della chat. Per impostazione predefinita usa il modello della chat.',
  'diagnostics.exportTitle': 'Esporta diagnostica',
  'diagnostics.exportButton': 'Esporta diagnostica',
  'diagnostics.exportHint': 'Raccoglie i log recenti dell\'app e le informazioni sulla macchina in un file zip che puoi condividere con il team.',
  'diagnostics.exporting': 'Esportazione…',
  'diagnostics.exportSuccess': 'Diagnostica salvata in {path}',
  'diagnostics.exportFailed': 'Impossibile esportare la diagnostica: {message}',
  'automations.eyebrow': 'Sessioni agent pianificate',
  'automations.title': 'Automazioni',
  'automations.lede': 'Pianifica conversazioni ricorrenti per il lavoro sui progetti, i digest Orbit e gli artefatti live.',
  'automations.summaryAria': 'Riepilogo automazioni',
  'automations.metricActive': 'Attive',
  'automations.metricPaused': 'In pausa',
  'automations.metricTemplates': 'Template',
  'automations.newAutomation': 'Nuova automazione',
  'automations.yourAutomations': 'Le tue automazioni',
  'automations.loading': 'Caricamento',
  'automations.emptyTitle': 'Nessuna automazione',
  'automations.emptyBody': 'Creane una da un template o parti da una pianificazione vuota.',
  'automations.targetNewEachRun': 'Nuovo progetto a ogni esecuzione',
  'automations.lastRun': 'Ultima esecuzione {time}',
  'automations.openResult': 'Apri risultato',
  'automations.run': 'Esegui',
  'automations.runNowTitle': 'Esegui ora e apri la conversazione',
  'automations.history': 'Cronologia',
  'automations.hideHistory': 'Nascondi cronologia',
  'automations.edit': 'Modifica',
  'automations.pause': 'Metti in pausa',
  'automations.resume': 'Riprendi',
  'automations.deleteAria': 'Elimina automazione',
  'automations.deleteTitle': 'Elimina questa automazione',
  'automations.deleteConfirm': 'Eliminare questa automazione? Le esecuzioni passate e i relativi progetti vengono conservati.',
  'automations.proposalsTitle': 'Proposte di evoluzione',
  'automations.proposalsSub': 'Esamina l\'output dell\'automazione prima che modifichi memoria, skill o design system.',
  'automations.proposalsPending': '{n} in attesa',
  'automations.apply': 'Applica',
  'automations.reject': 'Rifiuta',
  'automations.proposalsDismissReason': 'Ignorata in Automazioni',
  'automations.templatesTitle': 'Template',
  'automations.templatesSub': 'Orbit e gli artefatti live sono template all\'interno dello stesso flusso di automazione.',
  'automations.templatesCount': '{filtered} di {total}',
  'automations.templateFiltersAria': 'Filtri template',
  'automations.templatesEmptyTitle': 'Nessun template in questa categoria.',
  'automations.templatesEmptyBody': 'Prova un filtro diverso o parti da un\'automazione vuota.',
  'automations.useTemplate': 'Usa template',
  'automations.runHistoryLoading': 'Caricamento cronologia esecuzioni...',
  'automations.runHistoryEmpty': 'Nessuna esecuzione.',
  'automations.runHistoryTitle': 'Cronologia esecuzioni',
  'automations.runHistoryLatest': 'Ultime 10',
  'automations.crystallize': 'Cristallizza',
  'automations.crystallizing': 'Cristallizzazione',
  'automations.crystallizeTitle': 'Crea bozze di proposte di skill e memoria da questa esecuzione',
  'automations.openConversation': 'Apri conversazione',
  'automations.runHistoryAria': 'Cronologia esecuzioni automazione',
  'automations.proposalsAria': 'Proposte di evoluzione automazione',
  'automations.templatesAria': 'Template automazione',
  'automations.runInProgress': 'In corso',
  'automations.scheduleStatusPaused': 'In pausa',
  'automations.nextRunManualOnly': 'Solo manuale',
  'automations.nextRunScheduled': 'Pianificata',
  'automations.nextRunAt': 'Prossima {time}',
  'automations.statusSucceeded': 'Completata',
  'automations.statusFailed': 'Non riuscita',
  'automations.statusRunning': 'In esecuzione',
  'automations.statusQueued': 'In coda',
  'automations.statusCanceled': 'Annullata',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Artefatto live',
  'automations.kindAutomation': 'Automazione',
  'automations.proposalTargetMemory': 'Memoria',
  'automations.proposalTargetDesignSystem': 'Design system',
  'automations.proposalTargetSkill': 'Skill',
  'automations.proposalTargetTemplate': 'Template automazione',
  'automations.proposalActionCreate': 'Crea',
  'automations.proposalActionUpdate': 'Aggiorna',
  'automations.proposalActionMerge': 'Unisci',
  'automations.proposalActionMove': 'Sposta',
  'automations.proposalActionDelete': 'Elimina',
  'automations.proposalActionPromote': 'Promuovi',
  'automations.filterAll': 'Tutte',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Artefatti live',
  'automations.filterMemory': 'Memoria',
  'automations.filterDesignSystems': 'Design system',
  'automations.filterSkills': 'Skill',
  'automations.filterConnectors': 'Connettori',
  'automations.filterCompression': 'Compressione',
  'automations.filterRelease': 'Rilascio',
  'automations.filterQuality': 'Qualità',
  'automations.tpl.memoryRefresh.title': 'Aggiorna la memoria del progetto a partire dal lavoro recente.',
  'automations.tpl.memoryRefresh.desc': 'Trasforma decisioni, preferenze e feedback ricorrenti in aggiornamenti di memoria riutilizzabili.',
  'automations.tpl.designSystemRefresh.title': 'Aggiorna i design system a partire dagli artefatti rilasciati.',
  'automations.tpl.designSystemRefresh.desc': 'Individua token, componenti e regole riutilizzabili nel lavoro di design recente.',
  'automations.tpl.liveArtifactRegistry.title': 'Verifica gli artefatti live e aggiorna le versioni obsolete.',
  'automations.tpl.liveArtifactRegistry.desc': 'Mantiene aggiornati dashboard, report e anteprime persistenti invece di duplicarli.',
  'automations.tpl.orbitDashboard.title': 'Crea una dashboard di attività dei connettori.',
  'automations.tpl.orbitDashboard.desc': 'Aggrega i connettori selezionati in una dashboard live in stile Orbit.',
  'automations.tpl.releaseNotes.title': 'Redigi le note di rilascio dal lavoro di design rilasciato.',
  'automations.tpl.releaseNotes.desc': 'Collega PR uniti, artefatti e modifiche rivolte al prodotto in note di rilascio.',
  'automations.tpl.qualityRegressionWatch.title': 'Monitora le regressioni di design e implementazione.',
  'automations.tpl.qualityRegressionWatch.desc': 'Confronta le modifiche recenti con benchmark, trace e riferimenti accettati.',
  'automations.tpl.orbitDaily.title': 'Digest giornaliero dei connettori.',
  'automations.tpl.orbitDaily.desc': 'Aggiorna un digest di attività dei connettori secondo una pianificazione.',
  'automations.tpl.liveStatusBoard.title': 'Mantieni aggiornato un artefatto di stato live.',
  'automations.tpl.liveStatusBoard.desc': 'Aggiorna un unico artefatto persistente invece di creare un nuovo report a ogni esecuzione.',
  'dsManager.areaAria': 'Area design system',
  'dsManager.tabDesignSystem': 'Design system',
  'dsManager.tabTemplate': 'Modello',
  'dsManager.sourceAria': 'Origine design system',
  'dsManager.templateSourceAria': 'Origine template',
  'dsManager.yourSystems': 'I tuoi sistemi',
  'dsManager.officialPresets': 'Preset ufficiali',
  'dsManager.enterprise': 'Enterprise',
  'dsManager.yourTemplates': 'I tuoi template',
  'dsManager.yourSystemsAria': 'I tuoi design system',
  'dsManager.eyebrowDesignSystems': 'Design System',
  'dsManager.yourSystemsHeading': 'I tuoi sistemi',
  'dsManager.filterAria': 'Filtra i design system',
  'dsManager.filterAll': 'Tutti',
  'dsManager.filterPublished': 'Pubblicati',
  'dsManager.filterDraft': 'Bozza',
  'dsManager.createTitle': 'Crea nuovo design system',
  'dsManager.createBody': 'Insegna a ZalureAI il tuo brand, prodotto, codice, asset e riferimenti di design.',
  'dsManager.createAction': 'Crea',
  'dsManager.emptyMine': 'Nessun design system. Creane uno dal contesto reale del prodotto, esamina la bozza e poi pubblicalo per i progetti futuri.',
  'dsManager.badgeDefault': 'Predefinito',
  'dsManager.rowMetaUpdated': 'Tu · aggiornato {date}',
  'dsManager.edit': 'Modifica',
  'dsManager.makeDefault': 'Imposta come predefinito',
  'dsManager.statusPublished': 'Pubblicato',
  'dsManager.statusDraft': 'Bozza',
  'dsManager.openSystemAria': 'Apri {title}',
  'dsManager.deleteSystemAria': 'Elimina {title}',
  'dsManager.presetsAria': 'Preset ufficiali dei design system',
  'dsManager.eyebrowLibrary': 'Libreria',
  'dsManager.eyebrowTemplates': 'Template',
  'dsManager.yourTemplatesAria': 'I tuoi template',
  'dsManager.emptyTemplates': 'Nessun template. Creane uno da qualsiasi progetto generato tramite Condividi, una volta abilitata la pubblicazione dei template.',
  'dsManager.templateDescFallback': 'Creato da un progetto',
  'dsManager.comingSoonBadge': 'Prossimamente',
  'dsManager.enterpriseDsTitle': 'Design system enterprise',
  'dsManager.enterpriseDsBody': 'I design system condivisi del team e le librerie di brand governate arriveranno presto.',
  'dsManager.enterpriseTplTitle': 'Template enterprise',
  'dsManager.enterpriseTplBody': 'I template approvati dal team e la pubblicazione a livello di organizzazione arriveranno presto.',
  'settings.instructionsTitle': 'Istruzioni / Regole',
  'settings.instructionsSubtitle': 'Comportamento fisso che l\'assistente deve seguire',
  'settings.instructionsNavSub': 'Comportamento fisso dell\'assistente',
  'settings.customInstructionsDesc': 'Istruzioni fisse che ZalureAI segue in ogni chat. Non sono memorie salvate; usa Memoria per fatti, preferenze e contesto del progetto.',
  'mcpClient.forwardedToLabel': 'Inoltrato a:',
  'mcpClient.notForwardedToLabel': 'Non inoltrato a:',
  'mcpClient.forwardedAcpNote': 'Gli adattatori ACP contrassegnati come stdio ricevono da questo elenco solo i server MCP stdio; le voci HTTP e SSE vengono scartate all\'avvio.',
  'mcpClient.notForwardedNote': 'Per quegli agent, configura i server MCP nel file di configurazione dell\'agent stesso (ad es. ~/.codex/config.toml, ~/.gemini/settings.json); i server seguenti vengono ignorati silenziosamente in quel contesto.',
};
